/** * jMathEdu System Core v 2.0 * * Last Mod Date: 2019-09-15 */
$(function () {
  console.log(jMathEduVersion);
  var RESIZE_DELAY = 20;
  var timerResize = null;
  $($('.ph-app').get(0)).trigger('focus'); // EXTRA OBJECT INFO OPEN/CLOSE

  var $fullInfo, $fullInfoDiv, $ficollapser, $fiexpander;

  if (($fullInfo = $('[data-type=full-info]')) && $fullInfo[0]) {
    $fullInfoDiv = $fullInfo.find('div');
    $fiexpander = $fullInfo.find('.expander');
    $ficollapser = $fullInfo.find('.collapser');

    if ($fullInfo.outerHeight() > $fullInfoDiv.outerHeight() - $ficollapser.outerHeight() - 20) {
      $fiexpander.remove();
      $ficollapser.remove();
      $fullInfo.addClass('is-expanded');
    }
  }

  $('.toggle-details').on('click', function (e) {
    var $this = $(this),
        $xpanItem = $('.ii-details'),
        $xpanEl = $xpanItem.find('[data-type=full-info]'),
        xtraH = $this.height();
    $xpanEl.css({
      'max-height': !$($xpanItem).hasClass('is-expanded') ? $xpanEl.find('div').outerHeight() : '6.6em'
    });
    $($xpanItem).toggleClass('is-expanded');
    setTimeout(function () {
      $xpanEl.css($($xpanItem).hasClass('is-expanded') ? {
        'max-height': $xpanEl.find('div').outerHeight(),
        'overflow': ''
      } : {
        'overflow': ''
      });
    }, 300);
    e.preventDefault();
    return false;
  }); // DISABLE UNDER CONSTRUCTION LINK CLICKS

  var tWarn;
  $('[data-under-construction]').on('click submit focus', function (e) {
    e.stopPropagation();
    e.preventDefault();
    $('.warning-show').addClass('is-active');
    clearTimeout(tWarn);
    tWarn = setTimeout(function () {
      $('.warning-show').removeClass('is-active');
    }, 2000);
    return false;
  });
  $('.warning-show').on('click', function () {
    clearTimeout(tWarn);
    $(this).removeClass('is-active');
  }); // SELECT JUMP TO URL

  $('.jump-on-change').on('change', function () {
    var $this = $(this);
    var url = $this.data('change-url'),
        val = $this.val();
    setTimeout(function () {
      window.location = url.replace('%VAL%', val).replace('//', '/');
    }, 200);
  }); // SMOOTH SCROLL INTO VIEW ON LOAD

  var $elScroll = $('.scroll-into-view');

  if ($elScroll.offset()) {
    setTimeout(function () {
      $('.ph-app').animate({
        scrollTop: $elScroll.offset().top - 15
      }, 500, 'swing');
    }, 300);
  } // TOUCH LISTENERS


  var xyTouchStart = {
    x: -1,
    y: -1
  };
  $(document).bind('touchstart', function (event) {
    xyTouchStart = {
      x: event.originalEvent.touches[0].clientX,
      y: event.originalEvent.touches[0].clientY
    };
  });
  $('body').on('click', function (event) {
    $('.btn-close-popup').trigger('click');
  }).on('keydown', function (event) {
    switch (event.key) {
      case 'Escape':
        $('body').removeClass('burger-menu-active');
        $('[data-toggle="datepicker"]').trigger('blur').datepicker('hide');
        break;

      default:
        break;
    }
  });
  var markTablet = 4;
  var markMobile = 3;
  var mobileMarker = $('.page-mobile-marker');

  var _isInMobileMode = function _isInMobileMode() {
    var markerState = mobileMarker.cssInt('borderLeftWidth'),
        isMobile = markerState === markMobile,
        isTablet = markerState === markTablet;
    window.isMobile = isMobile;
    window.isTablet = isTablet;
    return isMobile;
  }; ///////////////////////////////////////
  //       WINDOW RESIZE METHOD
  ///////////////////////////////////////


  $(window).on('resize', function (event) {
    clearTimeout(timerResize);
    timerResize = setTimeout(function () {}, RESIZE_DELAY);

    _isInMobileMode();
  });
  $(document).ready(function () {
    $('.w84domload').removeClass('w84domload');

    _isInMobileMode();
  });
});
function _typeof2(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof2 = function _typeof2(obj) { return typeof obj; }; } else { _typeof2 = function _typeof2(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof2(obj); }

(function (global, factory) {
  (typeof exports === "undefined" ? "undefined" : _typeof2(exports)) === 'object' && typeof module !== 'undefined' ? factory(exports) : typeof define === 'function' && define.amd ? define(['exports'], factory) : (global = global || self, factory(global.IMask = {}));
})(this, function (exports) {
  'use strict';

  var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

  function createCommonjsModule(fn, module) {
    return module = {
      exports: {}
    }, fn(module, module.exports), module.exports;
  }

  var O = 'object';

  var check = function check(it) {
    return it && it.Math == Math && it;
  }; // https://github.com/zloirock/core-js/issues/86#issuecomment-115759028


  var global_1 = // eslint-disable-next-line no-undef
  check((typeof globalThis === "undefined" ? "undefined" : _typeof2(globalThis)) == O && globalThis) || check((typeof window === "undefined" ? "undefined" : _typeof2(window)) == O && window) || check((typeof self === "undefined" ? "undefined" : _typeof2(self)) == O && self) || check(_typeof2(commonjsGlobal) == O && commonjsGlobal) || // eslint-disable-next-line no-new-func
  Function('return this')();

  var fails = function fails(exec) {
    try {
      return !!exec();
    } catch (error) {
      return true;
    }
  }; // Thank's IE8 for his funny defineProperty


  var descriptors = !fails(function () {
    return Object.defineProperty({}, 'a', {
      get: function get() {
        return 7;
      }
    }).a != 7;
  });
  var nativePropertyIsEnumerable = {}.propertyIsEnumerable;
  var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor; // Nashorn ~ JDK8 bug

  var NASHORN_BUG = getOwnPropertyDescriptor && !nativePropertyIsEnumerable.call({
    1: 2
  }, 1); // `Object.prototype.propertyIsEnumerable` method implementation
  // https://tc39.github.io/ecma262/#sec-object.prototype.propertyisenumerable

  var f = NASHORN_BUG ? function propertyIsEnumerable(V) {
    var descriptor = getOwnPropertyDescriptor(this, V);
    return !!descriptor && descriptor.enumerable;
  } : nativePropertyIsEnumerable;
  var objectPropertyIsEnumerable = {
    f: f
  };

  var createPropertyDescriptor = function createPropertyDescriptor(bitmap, value) {
    return {
      enumerable: !(bitmap & 1),
      configurable: !(bitmap & 2),
      writable: !(bitmap & 4),
      value: value
    };
  };

  var toString = {}.toString;

  var classofRaw = function classofRaw(it) {
    return toString.call(it).slice(8, -1);
  };

  var split = ''.split; // fallback for non-array-like ES3 and non-enumerable old V8 strings

  var indexedObject = fails(function () {
    // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
    // eslint-disable-next-line no-prototype-builtins
    return !Object('z').propertyIsEnumerable(0);
  }) ? function (it) {
    return classofRaw(it) == 'String' ? split.call(it, '') : Object(it);
  } : Object; // `RequireObjectCoercible` abstract operation
  // https://tc39.github.io/ecma262/#sec-requireobjectcoercible

  var requireObjectCoercible = function requireObjectCoercible(it) {
    if (it == undefined) throw TypeError("Can't call method on " + it);
    return it;
  }; // toObject with fallback for non-array-like ES3 strings


  var toIndexedObject = function toIndexedObject(it) {
    return indexedObject(requireObjectCoercible(it));
  };

  var isObject = function isObject(it) {
    return _typeof2(it) === 'object' ? it !== null : typeof it === 'function';
  }; // `ToPrimitive` abstract operation
  // https://tc39.github.io/ecma262/#sec-toprimitive
  // instead of the ES6 spec version, we didn't implement @@toPrimitive case
  // and the second argument - flag - preferred type is a string


  var toPrimitive = function toPrimitive(input, PREFERRED_STRING) {
    if (!isObject(input)) return input;
    var fn, val;
    if (PREFERRED_STRING && typeof (fn = input.toString) == 'function' && !isObject(val = fn.call(input))) return val;
    if (typeof (fn = input.valueOf) == 'function' && !isObject(val = fn.call(input))) return val;
    if (!PREFERRED_STRING && typeof (fn = input.toString) == 'function' && !isObject(val = fn.call(input))) return val;
    throw TypeError("Can't convert object to primitive value");
  };

  var hasOwnProperty = {}.hasOwnProperty;

  var has = function has(it, key) {
    return hasOwnProperty.call(it, key);
  };

  var document$1 = global_1.document; // typeof document.createElement is 'object' in old IE

  var EXISTS = isObject(document$1) && isObject(document$1.createElement);

  var documentCreateElement = function documentCreateElement(it) {
    return EXISTS ? document$1.createElement(it) : {};
  }; // Thank's IE8 for his funny defineProperty


  var ie8DomDefine = !descriptors && !fails(function () {
    return Object.defineProperty(documentCreateElement('div'), 'a', {
      get: function get() {
        return 7;
      }
    }).a != 7;
  });
  var nativeGetOwnPropertyDescriptor = Object.getOwnPropertyDescriptor; // `Object.getOwnPropertyDescriptor` method
  // https://tc39.github.io/ecma262/#sec-object.getownpropertydescriptor

  var f$1 = descriptors ? nativeGetOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
    O = toIndexedObject(O);
    P = toPrimitive(P, true);
    if (ie8DomDefine) try {
      return nativeGetOwnPropertyDescriptor(O, P);
    } catch (error) {
      /* empty */
    }
    if (has(O, P)) return createPropertyDescriptor(!objectPropertyIsEnumerable.f.call(O, P), O[P]);
  };
  var objectGetOwnPropertyDescriptor = {
    f: f$1
  };

  var anObject = function anObject(it) {
    if (!isObject(it)) {
      throw TypeError(String(it) + ' is not an object');
    }

    return it;
  };

  var nativeDefineProperty = Object.defineProperty; // `Object.defineProperty` method
  // https://tc39.github.io/ecma262/#sec-object.defineproperty

  var f$2 = descriptors ? nativeDefineProperty : function defineProperty(O, P, Attributes) {
    anObject(O);
    P = toPrimitive(P, true);
    anObject(Attributes);
    if (ie8DomDefine) try {
      return nativeDefineProperty(O, P, Attributes);
    } catch (error) {
      /* empty */
    }
    if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported');
    if ('value' in Attributes) O[P] = Attributes.value;
    return O;
  };
  var objectDefineProperty = {
    f: f$2
  };
  var hide = descriptors ? function (object, key, value) {
    return objectDefineProperty.f(object, key, createPropertyDescriptor(1, value));
  } : function (object, key, value) {
    object[key] = value;
    return object;
  };

  var setGlobal = function setGlobal(key, value) {
    try {
      hide(global_1, key, value);
    } catch (error) {
      global_1[key] = value;
    }

    return value;
  };

  var shared = createCommonjsModule(function (module) {
    var SHARED = '__core-js_shared__';
    var store = global_1[SHARED] || setGlobal(SHARED, {});
    (module.exports = function (key, value) {
      return store[key] || (store[key] = value !== undefined ? value : {});
    })('versions', []).push({
      version: '3.1.3',
      mode: 'global',
      copyright: '© 2019 Denis Pushkarev (zloirock.ru)'
    });
  });
  var functionToString = shared('native-function-to-string', Function.toString);
  var WeakMap = global_1.WeakMap;
  var nativeWeakMap = typeof WeakMap === 'function' && /native code/.test(functionToString.call(WeakMap));
  var id = 0;
  var postfix = Math.random();

  var uid = function uid(key) {
    return 'Symbol(' + String(key === undefined ? '' : key) + ')_' + (++id + postfix).toString(36);
  };

  var keys = shared('keys');

  var sharedKey = function sharedKey(key) {
    return keys[key] || (keys[key] = uid(key));
  };

  var hiddenKeys = {};
  var WeakMap$1 = global_1.WeakMap;
  var set, get, has$1;

  var enforce = function enforce(it) {
    return has$1(it) ? get(it) : set(it, {});
  };

  var getterFor = function getterFor(TYPE) {
    return function (it) {
      var state;

      if (!isObject(it) || (state = get(it)).type !== TYPE) {
        throw TypeError('Incompatible receiver, ' + TYPE + ' required');
      }

      return state;
    };
  };

  if (nativeWeakMap) {
    var store = new WeakMap$1();
    var wmget = store.get;
    var wmhas = store.has;
    var wmset = store.set;

    set = function set(it, metadata) {
      wmset.call(store, it, metadata);
      return metadata;
    };

    get = function get(it) {
      return wmget.call(store, it) || {};
    };

    has$1 = function has$1(it) {
      return wmhas.call(store, it);
    };
  } else {
    var STATE = sharedKey('state');
    hiddenKeys[STATE] = true;

    set = function set(it, metadata) {
      hide(it, STATE, metadata);
      return metadata;
    };

    get = function get(it) {
      return has(it, STATE) ? it[STATE] : {};
    };

    has$1 = function has$1(it) {
      return has(it, STATE);
    };
  }

  var internalState = {
    set: set,
    get: get,
    has: has$1,
    enforce: enforce,
    getterFor: getterFor
  };
  var redefine = createCommonjsModule(function (module) {
    var getInternalState = internalState.get;
    var enforceInternalState = internalState.enforce;
    var TEMPLATE = String(functionToString).split('toString');
    shared('inspectSource', function (it) {
      return functionToString.call(it);
    });
    (module.exports = function (O, key, value, options) {
      var unsafe = options ? !!options.unsafe : false;
      var simple = options ? !!options.enumerable : false;
      var noTargetGet = options ? !!options.noTargetGet : false;

      if (typeof value == 'function') {
        if (typeof key == 'string' && !has(value, 'name')) hide(value, 'name', key);
        enforceInternalState(value).source = TEMPLATE.join(typeof key == 'string' ? key : '');
      }

      if (O === global_1) {
        if (simple) O[key] = value;else setGlobal(key, value);
        return;
      } else if (!unsafe) {
        delete O[key];
      } else if (!noTargetGet && O[key]) {
        simple = true;
      }

      if (simple) O[key] = value;else hide(O, key, value); // add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
    })(Function.prototype, 'toString', function toString() {
      return typeof this == 'function' && getInternalState(this).source || functionToString.call(this);
    });
  });
  var path = global_1;

  var aFunction = function aFunction(variable) {
    return typeof variable == 'function' ? variable : undefined;
  };

  var getBuiltIn = function getBuiltIn(namespace, method) {
    return arguments.length < 2 ? aFunction(path[namespace]) || aFunction(global_1[namespace]) : path[namespace] && path[namespace][method] || global_1[namespace] && global_1[namespace][method];
  };

  var ceil = Math.ceil;
  var floor = Math.floor; // `ToInteger` abstract operation
  // https://tc39.github.io/ecma262/#sec-tointeger

  var toInteger = function toInteger(argument) {
    return isNaN(argument = +argument) ? 0 : (argument > 0 ? floor : ceil)(argument);
  };

  var min = Math.min; // `ToLength` abstract operation
  // https://tc39.github.io/ecma262/#sec-tolength

  var toLength = function toLength(argument) {
    return argument > 0 ? min(toInteger(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
  };

  var max = Math.max;
  var min$1 = Math.min; // Helper for a popular repeating case of the spec:
  // Let integer be ? ToInteger(index).
  // If integer < 0, let result be max((length + integer), 0); else let result be min(length, length).

  var toAbsoluteIndex = function toAbsoluteIndex(index, length) {
    var integer = toInteger(index);
    return integer < 0 ? max(integer + length, 0) : min$1(integer, length);
  }; // `Array.prototype.{ indexOf, includes }` methods implementation


  var createMethod = function createMethod(IS_INCLUDES) {
    return function ($this, el, fromIndex) {
      var O = toIndexedObject($this);
      var length = toLength(O.length);
      var index = toAbsoluteIndex(fromIndex, length);
      var value; // Array#includes uses SameValueZero equality algorithm
      // eslint-disable-next-line no-self-compare

      if (IS_INCLUDES && el != el) while (length > index) {
        value = O[index++]; // eslint-disable-next-line no-self-compare

        if (value != value) return true; // Array#indexOf ignores holes, Array#includes - not
      } else for (; length > index; index++) {
        if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
      }
      return !IS_INCLUDES && -1;
    };
  };

  var arrayIncludes = {
    // `Array.prototype.includes` method
    // https://tc39.github.io/ecma262/#sec-array.prototype.includes
    includes: createMethod(true),
    // `Array.prototype.indexOf` method
    // https://tc39.github.io/ecma262/#sec-array.prototype.indexof
    indexOf: createMethod(false)
  };
  var indexOf = arrayIncludes.indexOf;

  var objectKeysInternal = function objectKeysInternal(object, names) {
    var O = toIndexedObject(object);
    var i = 0;
    var result = [];
    var key;

    for (key in O) {
      !has(hiddenKeys, key) && has(O, key) && result.push(key);
    } // Don't enum bug & hidden keys


    while (names.length > i) {
      if (has(O, key = names[i++])) {
        ~indexOf(result, key) || result.push(key);
      }
    }

    return result;
  }; // IE8- don't enum bug keys


  var enumBugKeys = ['constructor', 'hasOwnProperty', 'isPrototypeOf', 'propertyIsEnumerable', 'toLocaleString', 'toString', 'valueOf'];
  var hiddenKeys$1 = enumBugKeys.concat('length', 'prototype'); // `Object.getOwnPropertyNames` method
  // https://tc39.github.io/ecma262/#sec-object.getownpropertynames

  var f$3 = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
    return objectKeysInternal(O, hiddenKeys$1);
  };

  var objectGetOwnPropertyNames = {
    f: f$3
  };
  var f$4 = Object.getOwnPropertySymbols;
  var objectGetOwnPropertySymbols = {
    f: f$4
  }; // all object keys, includes non-enumerable and symbols

  var ownKeys = getBuiltIn('Reflect', 'ownKeys') || function ownKeys(it) {
    var keys = objectGetOwnPropertyNames.f(anObject(it));
    var getOwnPropertySymbols = objectGetOwnPropertySymbols.f;
    return getOwnPropertySymbols ? keys.concat(getOwnPropertySymbols(it)) : keys;
  };

  var copyConstructorProperties = function copyConstructorProperties(target, source) {
    var keys = ownKeys(source);
    var defineProperty = objectDefineProperty.f;
    var getOwnPropertyDescriptor = objectGetOwnPropertyDescriptor.f;

    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      if (!has(target, key)) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
  };

  var replacement = /#|\.prototype\./;

  var isForced = function isForced(feature, detection) {
    var value = data[normalize(feature)];
    return value == POLYFILL ? true : value == NATIVE ? false : typeof detection == 'function' ? fails(detection) : !!detection;
  };

  var normalize = isForced.normalize = function (string) {
    return String(string).replace(replacement, '.').toLowerCase();
  };

  var data = isForced.data = {};
  var NATIVE = isForced.NATIVE = 'N';
  var POLYFILL = isForced.POLYFILL = 'P';
  var isForced_1 = isForced;
  var getOwnPropertyDescriptor$1 = objectGetOwnPropertyDescriptor.f;
  /*
    options.target      - name of the target object
    options.global      - target is the global object
    options.stat        - export as static methods of target
    options.proto       - export as prototype methods of target
    options.real        - real prototype method for the `pure` version
    options.forced      - export even if the native feature is available
    options.bind        - bind methods to the target, required for the `pure` version
    options.wrap        - wrap constructors to preventing global pollution, required for the `pure` version
    options.unsafe      - use the simple assignment of property instead of delete + defineProperty
    options.sham        - add a flag to not completely full polyfills
    options.enumerable  - export as enumerable property
    options.noTargetGet - prevent calling a getter on target
  */

  var _export = function _export(options, source) {
    var TARGET = options.target;
    var GLOBAL = options.global;
    var STATIC = options.stat;
    var FORCED, target, key, targetProperty, sourceProperty, descriptor;

    if (GLOBAL) {
      target = global_1;
    } else if (STATIC) {
      target = global_1[TARGET] || setGlobal(TARGET, {});
    } else {
      target = (global_1[TARGET] || {}).prototype;
    }

    if (target) for (key in source) {
      sourceProperty = source[key];

      if (options.noTargetGet) {
        descriptor = getOwnPropertyDescriptor$1(target, key);
        targetProperty = descriptor && descriptor.value;
      } else targetProperty = target[key];

      FORCED = isForced_1(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced); // contained in target

      if (!FORCED && targetProperty !== undefined) {
        if (_typeof2(sourceProperty) === _typeof2(targetProperty)) continue;
        copyConstructorProperties(sourceProperty, targetProperty);
      } // add a flag to not completely full polyfills


      if (options.sham || targetProperty && targetProperty.sham) {
        hide(sourceProperty, 'sham', true);
      } // extend global


      redefine(target, key, sourceProperty, options);
    }
  }; // `Object.keys` method
  // https://tc39.github.io/ecma262/#sec-object.keys


  var objectKeys = Object.keys || function keys(O) {
    return objectKeysInternal(O, enumBugKeys);
  }; // `ToObject` abstract operation
  // https://tc39.github.io/ecma262/#sec-toobject


  var toObject = function toObject(argument) {
    return Object(requireObjectCoercible(argument));
  };

  var nativeAssign = Object.assign; // `Object.assign` method
  // https://tc39.github.io/ecma262/#sec-object.assign
  // should work with symbols and should have deterministic property order (V8 bug)

  var objectAssign = !nativeAssign || fails(function () {
    var A = {};
    var B = {}; // eslint-disable-next-line no-undef

    var symbol = Symbol();
    var alphabet = 'abcdefghijklmnopqrst';
    A[symbol] = 7;
    alphabet.split('').forEach(function (chr) {
      B[chr] = chr;
    });
    return nativeAssign({}, A)[symbol] != 7 || objectKeys(nativeAssign({}, B)).join('') != alphabet;
  }) ? function assign(target, source) {
    // eslint-disable-line no-unused-vars
    var T = toObject(target);
    var argumentsLength = arguments.length;
    var index = 1;
    var getOwnPropertySymbols = objectGetOwnPropertySymbols.f;
    var propertyIsEnumerable = objectPropertyIsEnumerable.f;

    while (argumentsLength > index) {
      var S = indexedObject(arguments[index++]);
      var keys = getOwnPropertySymbols ? objectKeys(S).concat(getOwnPropertySymbols(S)) : objectKeys(S);
      var length = keys.length;
      var j = 0;
      var key;

      while (length > j) {
        key = keys[j++];
        if (!descriptors || propertyIsEnumerable.call(S, key)) T[key] = S[key];
      }
    }

    return T;
  } : nativeAssign; // `Object.assign` method
  // https://tc39.github.io/ecma262/#sec-object.assign

  _export({
    target: 'Object',
    stat: true,
    forced: Object.assign !== objectAssign
  }, {
    assign: objectAssign
  }); // `String.prototype.repeat` method implementation
  // https://tc39.github.io/ecma262/#sec-string.prototype.repeat


  var stringRepeat = ''.repeat || function repeat(count) {
    var str = String(requireObjectCoercible(this));
    var result = '';
    var n = toInteger(count);
    if (n < 0 || n == Infinity) throw RangeError('Wrong number of repetitions');

    for (; n > 0; (n >>>= 1) && (str += str)) {
      if (n & 1) result += str;
    }

    return result;
  }; // https://github.com/tc39/proposal-string-pad-start-end


  var ceil$1 = Math.ceil; // `String.prototype.{ padStart, padEnd }` methods implementation

  var createMethod$1 = function createMethod$1(IS_END) {
    return function ($this, maxLength, fillString) {
      var S = String(requireObjectCoercible($this));
      var stringLength = S.length;
      var fillStr = fillString === undefined ? ' ' : String(fillString);
      var intMaxLength = toLength(maxLength);
      var fillLen, stringFiller;
      if (intMaxLength <= stringLength || fillStr == '') return S;
      fillLen = intMaxLength - stringLength;
      stringFiller = stringRepeat.call(fillStr, ceil$1(fillLen / fillStr.length));
      if (stringFiller.length > fillLen) stringFiller = stringFiller.slice(0, fillLen);
      return IS_END ? S + stringFiller : stringFiller + S;
    };
  };

  var stringPad = {
    // `String.prototype.padStart` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.padstart
    start: createMethod$1(false),
    // `String.prototype.padEnd` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.padend
    end: createMethod$1(true)
  };
  var userAgent = getBuiltIn('navigator', 'userAgent') || ''; // https://github.com/zloirock/core-js/issues/280
  // eslint-disable-next-line unicorn/no-unsafe-regex

  var webkitStringPadBug = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(userAgent);
  var $padEnd = stringPad.end; // `String.prototype.padEnd` method
  // https://tc39.github.io/ecma262/#sec-string.prototype.padend

  _export({
    target: 'String',
    proto: true,
    forced: webkitStringPadBug
  }, {
    padEnd: function padEnd(maxLength
    /* , fillString = ' ' */
    ) {
      return $padEnd(this, maxLength, arguments.length > 1 ? arguments[1] : undefined);
    }
  });

  var $padStart = stringPad.start; // `String.prototype.padStart` method
  // https://tc39.github.io/ecma262/#sec-string.prototype.padstart

  _export({
    target: 'String',
    proto: true,
    forced: webkitStringPadBug
  }, {
    padStart: function padStart(maxLength
    /* , fillString = ' ' */
    ) {
      return $padStart(this, maxLength, arguments.length > 1 ? arguments[1] : undefined);
    }
  }); // `String.prototype.repeat` method
  // https://tc39.github.io/ecma262/#sec-string.prototype.repeat


  _export({
    target: 'String',
    proto: true
  }, {
    repeat: stringRepeat
  });

  function _typeof(obj) {
    if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
      _typeof = function _typeof(obj) {
        return _typeof2(obj);
      };
    } else {
      _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : _typeof2(obj);
      };
    }

    return _typeof(obj);
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
  }

  function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
      return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
  }

  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };

    return _setPrototypeOf(o, p);
  }

  function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;

    for (i = 0; i < sourceKeys.length; i++) {
      key = sourceKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      target[key] = source[key];
    }

    return target;
  }

  function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};

    var target = _objectWithoutPropertiesLoose(source, excluded);

    var key, i;

    if (Object.getOwnPropertySymbols) {
      var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

      for (i = 0; i < sourceSymbolKeys.length; i++) {
        key = sourceSymbolKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
      }
    }

    return target;
  }

  function _assertThisInitialized(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return self;
  }

  function _possibleConstructorReturn(self, call) {
    if (call && (_typeof2(call) === "object" || typeof call === "function")) {
      return call;
    }

    return _assertThisInitialized(self);
  }

  function _superPropBase(object, property) {
    while (!Object.prototype.hasOwnProperty.call(object, property)) {
      object = _getPrototypeOf(object);
      if (object === null) break;
    }

    return object;
  }

  function _get(target, property, receiver) {
    if (typeof Reflect !== "undefined" && Reflect.get) {
      _get = Reflect.get;
    } else {
      _get = function _get(target, property, receiver) {
        var base = _superPropBase(target, property);

        if (!base) return;
        var desc = Object.getOwnPropertyDescriptor(base, property);

        if (desc.get) {
          return desc.get.call(receiver);
        }

        return desc.value;
      };
    }

    return _get(target, property, receiver || target);
  }

  function set$1(target, property, value, receiver) {
    if (typeof Reflect !== "undefined" && Reflect.set) {
      set$1 = Reflect.set;
    } else {
      set$1 = function set(target, property, value, receiver) {
        var base = _superPropBase(target, property);

        var desc;

        if (base) {
          desc = Object.getOwnPropertyDescriptor(base, property);

          if (desc.set) {
            desc.set.call(receiver, value);
            return true;
          } else if (!desc.writable) {
            return false;
          }
        }

        desc = Object.getOwnPropertyDescriptor(receiver, property);

        if (desc) {
          if (!desc.writable) {
            return false;
          }

          desc.value = value;
          Object.defineProperty(receiver, property, desc);
        } else {
          _defineProperty(receiver, property, value);
        }

        return true;
      };
    }

    return set$1(target, property, value, receiver);
  }

  function _set(target, property, value, receiver, isStrict) {
    var s = set$1(target, property, value, receiver || target);

    if (!s && isStrict) {
      throw new Error('failed to set property');
    }

    return value;
  }

  function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
  }

  function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
  }

  function _iterableToArrayLimit(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"] != null) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance");
  }
  /** Checks if value is string */


  function isString(str) {
    return typeof str === 'string' || str instanceof String;
  }
  /**
    Direction
    @prop {string} NONE
    @prop {string} LEFT
    @prop {string} FORCE_LEFT
    @prop {string} RIGHT
    @prop {string} FORCE_RIGHT
   */


  var DIRECTION = {
    NONE: 'NONE',
    LEFT: 'LEFT',
    FORCE_LEFT: 'FORCE_LEFT',
    RIGHT: 'RIGHT',
    FORCE_RIGHT: 'FORCE_RIGHT'
    /**
       Direction
       @enum {string}
     */

  };
  /** */

  function forceDirection(direction) {
    switch (direction) {
      case DIRECTION.LEFT:
        return DIRECTION.FORCE_LEFT;

      case DIRECTION.RIGHT:
        return DIRECTION.FORCE_RIGHT;

      default:
        return direction;
    }
  }
  /** Escapes regular expression control chars */


  function escapeRegExp(str) {
    return str.replace(/([.*+?^=!:${}()|[\]/\\])/g, '\\$1');
  } // cloned from https://github.com/epoberezkin/fast-deep-equal with small changes


  function objectIncludes(b, a) {
    if (a === b) return true;
    var arrA = Array.isArray(a),
        arrB = Array.isArray(b),
        i;

    if (arrA && arrB) {
      if (a.length != b.length) return false;

      for (i = 0; i < a.length; i++) {
        if (!objectIncludes(a[i], b[i])) return false;
      }

      return true;
    }

    if (arrA != arrB) return false;

    if (a && b && _typeof(a) === 'object' && _typeof(b) === 'object') {
      var dateA = a instanceof Date,
          dateB = b instanceof Date;
      if (dateA && dateB) return a.getTime() == b.getTime();
      if (dateA != dateB) return false;
      var regexpA = a instanceof RegExp,
          regexpB = b instanceof RegExp;
      if (regexpA && regexpB) return a.toString() == b.toString();
      if (regexpA != regexpB) return false;
      var keys = Object.keys(a); // if (keys.length !== Object.keys(b).length) return false;

      for (i = 0; i < keys.length; i++) {
        if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
      }

      for (i = 0; i < keys.length; i++) {
        if (!objectIncludes(b[keys[i]], a[keys[i]])) return false;
      }

      return true;
    } else if (a && b && typeof a === 'function' && typeof b === 'function') {
      return a.toString() === b.toString();
    }

    return false;
  }
  /* eslint-disable no-undef */


  var g = typeof window !== 'undefined' && window || typeof global !== 'undefined' && global.global === global && global || typeof self !== 'undefined' && self.self === self && self || {};
  /* eslint-enable no-undef */

  /** Selection range */

  /** Provides details of changing input */

  var ActionDetails =
  /*#__PURE__*/
  function () {
    /** Current input value */

    /** Current cursor position */

    /** Old input value */

    /** Old selection */
    function ActionDetails(value, cursorPos, oldValue, oldSelection) {
      _classCallCheck(this, ActionDetails);

      this.value = value;
      this.cursorPos = cursorPos;
      this.oldValue = oldValue;
      this.oldSelection = oldSelection; // double check if left part was changed (autofilling, other non-standard input triggers)

      while (this.value.slice(0, this.startChangePos) !== this.oldValue.slice(0, this.startChangePos)) {
        --this.oldSelection.start;
      }
    }
    /**
    Start changing position
    @readonly
     */


    _createClass(ActionDetails, [{
      key: "startChangePos",
      get: function get() {
        return Math.min(this.cursorPos, this.oldSelection.start);
      }
      /**
      Inserted symbols count
      @readonly
       */

    }, {
      key: "insertedCount",
      get: function get() {
        return this.cursorPos - this.startChangePos;
      }
      /**
      Inserted symbols
      @readonly
       */

    }, {
      key: "inserted",
      get: function get() {
        return this.value.substr(this.startChangePos, this.insertedCount);
      }
      /**
      Removed symbols count
      @readonly
       */

    }, {
      key: "removedCount",
      get: function get() {
        // Math.max for opposite operation
        return Math.max(this.oldSelection.end - this.startChangePos || // for Delete
        this.oldValue.length - this.value.length, 0);
      }
      /**
      Removed symbols
      @readonly
       */

    }, {
      key: "removed",
      get: function get() {
        return this.oldValue.substr(this.startChangePos, this.removedCount);
      }
      /**
      Unchanged head symbols
      @readonly
       */

    }, {
      key: "head",
      get: function get() {
        return this.value.substring(0, this.startChangePos);
      }
      /**
      Unchanged tail symbols
      @readonly
       */

    }, {
      key: "tail",
      get: function get() {
        return this.value.substring(this.startChangePos + this.insertedCount);
      }
      /**
      Remove direction
      @readonly
       */

    }, {
      key: "removeDirection",
      get: function get() {
        if (!this.removedCount || this.insertedCount) return DIRECTION.NONE; // align right if delete at right or if range removed (event with backspace)

        return this.oldSelection.end === this.cursorPos || this.oldSelection.start === this.cursorPos ? DIRECTION.RIGHT : DIRECTION.LEFT;
      }
    }]);

    return ActionDetails;
  }();
  /**
    Provides details of changing model value
    @param {Object} [details]
    @param {string} [details.inserted] - Inserted symbols
    @param {boolean} [details.skip] - Can skip chars
    @param {number} [details.removeCount] - Removed symbols count
    @param {number} [details.tailShift] - Additional offset if any changes occurred before tail
   */


  var ChangeDetails =
  /*#__PURE__*/
  function () {
    /** Inserted symbols */

    /** Can skip chars */

    /** Additional offset if any changes occurred before tail */

    /** Raw inserted is used by dynamic mask */
    function ChangeDetails(details) {
      _classCallCheck(this, ChangeDetails);

      Object.assign(this, {
        inserted: '',
        rawInserted: '',
        skip: false,
        tailShift: 0
      }, details);
    }
    /**
    Aggregate changes
    @returns {ChangeDetails} `this`
     */


    _createClass(ChangeDetails, [{
      key: "aggregate",
      value: function aggregate(details) {
        this.rawInserted += details.rawInserted;
        this.skip = this.skip || details.skip;
        this.inserted += details.inserted;
        this.tailShift += details.tailShift;
        return this;
      }
      /** Total offset considering all changes */

    }, {
      key: "offset",
      get: function get() {
        return this.tailShift + this.inserted.length;
      }
    }]);

    return ChangeDetails;
  }();
  /** Provides details of continuous extracted tail */


  var ContinuousTailDetails =
  /*#__PURE__*/
  function () {
    /** Tail value as string */

    /** Tail start position */

    /** Start position */
    function ContinuousTailDetails() {
      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var stop = arguments.length > 2 ? arguments[2] : undefined;

      _classCallCheck(this, ContinuousTailDetails);

      this.value = value;
      this.from = from;
      this.stop = stop;
    }

    _createClass(ContinuousTailDetails, [{
      key: "toString",
      value: function toString() {
        return this.value;
      }
    }, {
      key: "extend",
      value: function extend(tail) {
        this.value += String(tail);
      }
    }, {
      key: "appendTo",
      value: function appendTo(masked) {
        return masked.append(this.toString(), {
          tail: true
        }).aggregate(masked._appendPlaceholder());
      }
    }, {
      key: "shiftBefore",
      value: function shiftBefore(pos) {
        if (this.from >= pos || !this.value.length) return '';
        var shiftChar = this.value[0];
        this.value = this.value.slice(1);
        return shiftChar;
      }
    }, {
      key: "state",
      get: function get() {
        return {
          value: this.value,
          from: this.from,
          stop: this.stop
        };
      },
      set: function set(state) {
        Object.assign(this, state);
      }
    }]);

    return ContinuousTailDetails;
  }();
  /** Provides common masking stuff */


  var Masked =
  /*#__PURE__*/
  function () {
    // $Shape<MaskedOptions>; TODO after fix https://github.com/facebook/flow/issues/4773

    /** @type {Mask} */

    /** */
    // $FlowFixMe no ideas

    /** Transforms value before mask processing */

    /** Validates if value is acceptable */

    /** Does additional processing in the end of editing */

    /** Enable characters overwriting */

    /** */
    function Masked(opts) {
      _classCallCheck(this, Masked);

      this._value = '';

      this._update(opts);

      this.isInitialized = true;
    }
    /** Sets and applies new options */


    _createClass(Masked, [{
      key: "updateOptions",
      value: function updateOptions(opts) {
        if (!Object.keys(opts).length) return;
        this.withValueRefresh(this._update.bind(this, opts));
      }
      /**
      Sets new options
      @protected
       */

    }, {
      key: "_update",
      value: function _update(opts) {
        Object.assign(this, opts);
      }
      /** Mask state */

    }, {
      key: "reset",

      /** Resets value */
      value: function reset() {
        this._value = '';
      }
      /** */

    }, {
      key: "resolve",

      /** Resolve new value */
      value: function resolve(value) {
        this.reset();
        this.append(value, {
          input: true
        }, '');
        this.doCommit();
        return this.value;
      }
      /** */

    }, {
      key: "nearestInputPos",

      /** Finds nearest input position in direction */
      value: function nearestInputPos(cursorPos, direction) {
        return cursorPos;
      }
      /** Extracts value in range considering flags */

    }, {
      key: "extractInput",
      value: function extractInput() {
        var fromPos = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        var toPos = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.value.length;
        return this.value.slice(fromPos, toPos);
      }
      /** Extracts tail in range */

    }, {
      key: "extractTail",
      value: function extractTail() {
        var fromPos = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        var toPos = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.value.length;
        return new ContinuousTailDetails(this.extractInput(fromPos, toPos), fromPos);
      }
      /** Appends tail */
      // $FlowFixMe no ideas

    }, {
      key: "appendTail",
      value: function appendTail(tail) {
        if (isString(tail)) tail = new ContinuousTailDetails(String(tail));
        return tail.appendTo(this);
      }
      /** Appends char */

    }, {
      key: "_appendCharRaw",
      value: function _appendCharRaw(ch) {
        var flags = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        ch = this.doPrepare(ch, flags);
        if (!ch) return new ChangeDetails();
        this._value += ch;
        return new ChangeDetails({
          inserted: ch,
          rawInserted: ch
        });
      }
      /** Appends char */

    }, {
      key: "_appendChar",
      value: function _appendChar(ch) {
        var flags = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var checkTail = arguments.length > 2 ? arguments[2] : undefined;
        var consistentState = this.state;

        var details = this._appendCharRaw(ch, flags);

        if (details.inserted) {
          var consistentTail;
          var appended = this.doValidate(flags) !== false;

          if (appended && checkTail != null) {
            // validation ok, check tail
            var beforeTailState = this.state;

            if (this.overwrite) {
              consistentTail = checkTail.state;
              checkTail.shiftBefore(this.value.length);
            }

            var tailDetails = this.appendTail(checkTail);
            appended = tailDetails.rawInserted === checkTail.toString(); // if ok, rollback state after tail

            if (appended && tailDetails.inserted) this.state = beforeTailState;
          } // revert all if something went wrong


          if (!appended) {
            details.rawInserted = details.inserted = '';
            this.state = consistentState;
            if (checkTail && consistentTail) checkTail.state = consistentTail;
          }
        }

        return details;
      }
      /** Appends optional placeholder at end */

    }, {
      key: "_appendPlaceholder",
      value: function _appendPlaceholder() {
        return new ChangeDetails();
      }
      /** Appends symbols considering flags */
      // $FlowFixMe no ideas

    }, {
      key: "append",
      value: function append(str, flags, tail) {
        if (!isString(str)) throw new Error('value should be string');
        var details = new ChangeDetails();
        var checkTail = isString(tail) ? new ContinuousTailDetails(String(tail)) : tail;
        if (flags.tail) flags._beforeTailState = this.state;

        for (var ci = 0; ci < str.length; ++ci) {
          details.aggregate(this._appendChar(str[ci], flags, checkTail));
        } // append tail but aggregate only tailShift


        if (checkTail != null) {
          details.tailShift += this.appendTail(checkTail).tailShift; // TODO it's a good idea to clear state after appending ends
          // but it causes bugs when one append calls another (when dynamic dispatch set rawInputValue)
          // this._resetBeforeTailState();
        }

        return details;
      }
      /** */

    }, {
      key: "remove",
      value: function remove() {
        var fromPos = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        var toPos = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.value.length;
        this._value = this.value.slice(0, fromPos) + this.value.slice(toPos);
        return new ChangeDetails();
      }
      /** Calls function and reapplies current value */

    }, {
      key: "withValueRefresh",
      value: function withValueRefresh(fn) {
        if (this._refreshing || !this.isInitialized) return fn();
        this._refreshing = true;
        var unmasked = this.unmaskedValue;
        var value = this.value;
        var ret = fn(); // try to update with raw value first to keep fixed chars

        if (this.resolve(value) !== value) {
          // or fallback to unmasked
          this.unmaskedValue = unmasked;
        }

        delete this._refreshing;
        return ret;
      }
      /**
      Prepares string before mask processing
      @protected
       */

    }, {
      key: "doPrepare",
      value: function doPrepare(str) {
        var flags = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return this.prepare ? this.prepare(str, this, flags) : str;
      }
      /**
      Validates if value is acceptable
      @protected
       */

    }, {
      key: "doValidate",
      value: function doValidate(flags) {
        return (!this.validate || this.validate(this.value, this, flags)) && (!this.parent || this.parent.doValidate(flags));
      }
      /**
      Does additional processing in the end of editing
      @protected
       */

    }, {
      key: "doCommit",
      value: function doCommit() {
        if (this.commit) this.commit(this.value, this);
      }
      /** */

    }, {
      key: "splice",
      value: function splice(start, deleteCount, inserted, removeDirection) {
        var tailPos = start + deleteCount;
        var tail = this.extractTail(tailPos);
        var startChangePos = this.nearestInputPos(start, removeDirection);
        var changeDetails = new ChangeDetails({
          tailShift: startChangePos - start // adjust tailShift if start was aligned

        }).aggregate(this.remove(startChangePos)).aggregate(this.append(inserted, {
          input: true
        }, tail));
        return changeDetails;
      }
    }, {
      key: "state",
      get: function get() {
        return {
          _value: this.value
        };
      },
      set: function set(state) {
        this._value = state._value;
      }
    }, {
      key: "value",
      get: function get() {
        return this._value;
      },
      set: function set(value) {
        this.resolve(value);
      }
    }, {
      key: "unmaskedValue",
      get: function get() {
        return this.value;
      },
      set: function set(value) {
        this.reset();
        this.append(value, {}, '');
        this.doCommit();
      }
      /** */

    }, {
      key: "typedValue",
      get: function get() {
        return this.unmaskedValue;
      },
      set: function set(value) {
        this.unmaskedValue = value;
      }
      /** Value that includes raw user input */

    }, {
      key: "rawInputValue",
      get: function get() {
        return this.extractInput(0, this.value.length, {
          raw: true
        });
      },
      set: function set(value) {
        this.reset();
        this.append(value, {
          raw: true
        }, '');
        this.doCommit();
      }
      /** */

    }, {
      key: "isComplete",
      get: function get() {
        return true;
      }
    }]);

    return Masked;
  }();
  /** Get Masked class by mask type */


  function maskedClass(mask) {
    if (mask == null) {
      throw new Error('mask property should be defined');
    }

    if (mask instanceof RegExp) return g.IMask.MaskedRegExp;
    if (isString(mask)) return g.IMask.MaskedPattern;
    if (mask instanceof Date || mask === Date) return g.IMask.MaskedDate;
    if (mask instanceof Number || typeof mask === 'number' || mask === Number) return g.IMask.MaskedNumber;
    if (Array.isArray(mask) || mask === Array) return g.IMask.MaskedDynamic; // $FlowFixMe

    if (mask.prototype instanceof g.IMask.Masked) return mask; // $FlowFixMe

    if (mask instanceof Function) return g.IMask.MaskedFunction;
    console.warn('Mask not found for mask', mask); // eslint-disable-line no-console

    return g.IMask.Masked;
  }
  /** Creates new {@link Masked} depending on mask type */


  function createMask(opts) {
    opts = Object.assign({}, opts);
    var mask = opts.mask;
    if (mask instanceof g.IMask.Masked) return mask;
    var MaskedClass = maskedClass(mask);
    return new MaskedClass(opts);
  }

  var DEFAULT_INPUT_DEFINITIONS = {
    '0': /\d/,
    'a': /[\u0041-\u005A\u0061-\u007A\u00AA\u00B5\u00BA\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u0527\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u08A0\u08A2-\u08AC\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0977\u0979-\u097F\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C33\u0C35-\u0C39\u0C3D\u0C58\u0C59\u0C60\u0C61\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D60\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F4\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191C\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19C1-\u19C7\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FCC\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA697\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA78E\uA790-\uA793\uA7A0-\uA7AA\uA7F8-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA80-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uABC0-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]/,
    // http://stackoverflow.com/a/22075070
    '*': /./
  };
  /** */

  var PatternInputDefinition =
  /*#__PURE__*/
  function () {
    /** */

    /** */

    /** */

    /** */

    /** */

    /** */
    function PatternInputDefinition(opts) {
      _classCallCheck(this, PatternInputDefinition);

      var mask = opts.mask,
          blockOpts = _objectWithoutProperties(opts, ["mask"]);

      this.masked = createMask({
        mask: mask
      });
      Object.assign(this, blockOpts);
    }

    _createClass(PatternInputDefinition, [{
      key: "reset",
      value: function reset() {
        this._isFilled = false;
        this.masked.reset();
      }
    }, {
      key: "remove",
      value: function remove() {
        var fromPos = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        var toPos = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.value.length;

        if (fromPos === 0 && toPos >= 1) {
          this._isFilled = false;
          return this.masked.remove(fromPos, toPos);
        }

        return new ChangeDetails();
      }
    }, {
      key: "_appendChar",
      value: function _appendChar(str) {
        var flags = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        if (this._isFilled) return new ChangeDetails();
        var state = this.masked.state; // simulate input

        var details = this.masked._appendChar(str, flags);

        if (details.inserted && this.doValidate(flags) === false) {
          details.inserted = details.rawInserted = '';
          this.masked.state = state;
        }

        if (!details.inserted && !this.isOptional && !this.lazy && !flags.input) {
          details.inserted = this.placeholderChar;
        }

        details.skip = !details.inserted && !this.isOptional;
        this._isFilled = Boolean(details.inserted);
        return details;
      }
    }, {
      key: "append",
      value: function append() {
        var _this$masked;

        return (_this$masked = this.masked).append.apply(_this$masked, arguments);
      }
    }, {
      key: "_appendPlaceholder",
      value: function _appendPlaceholder() {
        var details = new ChangeDetails();
        if (this._isFilled || this.isOptional) return details;
        this._isFilled = true;
        details.inserted = this.placeholderChar;
        return details;
      }
    }, {
      key: "extractTail",
      value: function extractTail() {
        var _this$masked2;

        return (_this$masked2 = this.masked).extractTail.apply(_this$masked2, arguments);
      }
    }, {
      key: "appendTail",
      value: function appendTail() {
        var _this$masked3;

        return (_this$masked3 = this.masked).appendTail.apply(_this$masked3, arguments);
      }
    }, {
      key: "extractInput",
      value: function extractInput() {
        var fromPos = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        var toPos = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.value.length;
        var flags = arguments.length > 2 ? arguments[2] : undefined;
        return this.masked.extractInput(fromPos, toPos, flags);
      }
    }, {
      key: "nearestInputPos",
      value: function nearestInputPos(cursorPos) {
        var direction = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DIRECTION.NONE;
        var minPos = 0;
        var maxPos = this.value.length;
        var boundPos = Math.min(Math.max(cursorPos, minPos), maxPos);

        switch (direction) {
          case DIRECTION.LEFT:
          case DIRECTION.FORCE_LEFT:
            return this.isComplete ? boundPos : minPos;

          case DIRECTION.RIGHT:
          case DIRECTION.FORCE_RIGHT:
            return this.isComplete ? boundPos : maxPos;

          case DIRECTION.NONE:
          default:
            return boundPos;
        }
      }
    }, {
      key: "doValidate",
      value: function doValidate() {
        var _this$masked4, _this$parent;

        return (_this$masked4 = this.masked).doValidate.apply(_this$masked4, arguments) && (!this.parent || (_this$parent = this.parent).doValidate.apply(_this$parent, arguments));
      }
    }, {
      key: "doCommit",
      value: function doCommit() {
        this.masked.doCommit();
      }
    }, {
      key: "value",
      get: function get() {
        return this.masked.value || (this._isFilled && !this.isOptional ? this.placeholderChar : '');
      }
    }, {
      key: "unmaskedValue",
      get: function get() {
        return this.masked.unmaskedValue;
      }
    }, {
      key: "isComplete",
      get: function get() {
        return Boolean(this.masked.value) || this.isOptional;
      }
    }, {
      key: "state",
      get: function get() {
        return {
          masked: this.masked.state,
          _isFilled: this._isFilled
        };
      },
      set: function set(state) {
        this.masked.state = state.masked;
        this._isFilled = state._isFilled;
      }
    }]);

    return PatternInputDefinition;
  }();

  var PatternFixedDefinition =
  /*#__PURE__*/
  function () {
    /** */

    /** */

    /** */

    /** */
    function PatternFixedDefinition(opts) {
      _classCallCheck(this, PatternFixedDefinition);

      Object.assign(this, opts);
      this._value = '';
    }

    _createClass(PatternFixedDefinition, [{
      key: "reset",
      value: function reset() {
        this._isRawInput = false;
        this._value = '';
      }
    }, {
      key: "remove",
      value: function remove() {
        var fromPos = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        var toPos = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this._value.length;
        this._value = this._value.slice(0, fromPos) + this._value.slice(toPos);
        if (!this._value) this._isRawInput = false;
        return new ChangeDetails();
      }
    }, {
      key: "nearestInputPos",
      value: function nearestInputPos(cursorPos) {
        var direction = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DIRECTION.NONE;
        var minPos = 0;
        var maxPos = this._value.length;

        switch (direction) {
          case DIRECTION.LEFT:
          case DIRECTION.FORCE_LEFT:
            return minPos;

          case DIRECTION.NONE:
          case DIRECTION.RIGHT:
          case DIRECTION.FORCE_RIGHT:
          default:
            return maxPos;
        }
      }
    }, {
      key: "extractInput",
      value: function extractInput() {
        var fromPos = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        var toPos = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this._value.length;
        var flags = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        return flags.raw && this._isRawInput && this._value.slice(fromPos, toPos) || '';
      }
    }, {
      key: "_appendChar",
      value: function _appendChar(str) {
        var flags = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var details = new ChangeDetails();
        if (this._value) return details;
        var appended = this["char"] === str[0];
        var isResolved = appended && (this.isUnmasking || flags.input || flags.raw) && !flags.tail;
        if (isResolved) details.rawInserted = this["char"];
        this._value = details.inserted = this["char"];
        this._isRawInput = isResolved && (flags.raw || flags.input);
        return details;
      }
    }, {
      key: "_appendPlaceholder",
      value: function _appendPlaceholder() {
        var details = new ChangeDetails();
        if (this._value) return details;
        this._value = details.inserted = this["char"];
        return details;
      }
    }, {
      key: "extractTail",
      value: function extractTail() {
        var toPos = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.value.length;
        return new ContinuousTailDetails('');
      } // $FlowFixMe no ideas

    }, {
      key: "appendTail",
      value: function appendTail(tail) {
        if (isString(tail)) tail = new ContinuousTailDetails(String(tail));
        return tail.appendTo(this);
      }
    }, {
      key: "append",
      value: function append(str, flags, tail) {
        var details = this._appendChar(str, flags);

        if (tail != null) {
          details.tailShift += this.appendTail(tail).tailShift;
        }

        return details;
      }
    }, {
      key: "doCommit",
      value: function doCommit() {}
    }, {
      key: "value",
      get: function get() {
        return this._value;
      }
    }, {
      key: "unmaskedValue",
      get: function get() {
        return this.isUnmasking ? this.value : '';
      }
    }, {
      key: "isComplete",
      get: function get() {
        return true;
      }
    }, {
      key: "state",
      get: function get() {
        return {
          _value: this._value,
          _isRawInput: this._isRawInput
        };
      },
      set: function set(state) {
        Object.assign(this, state);
      }
    }]);

    return PatternFixedDefinition;
  }();

  var ChunksTailDetails =
  /*#__PURE__*/
  function () {
    /** */
    function ChunksTailDetails() {
      var chunks = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      _classCallCheck(this, ChunksTailDetails);

      this.chunks = chunks;
      this.from = from;
    }

    _createClass(ChunksTailDetails, [{
      key: "toString",
      value: function toString() {
        return this.chunks.map(String).join('');
      } // $FlowFixMe no ideas

    }, {
      key: "extend",
      value: function extend(tailChunk) {
        if (!String(tailChunk)) return;
        if (isString(tailChunk)) tailChunk = new ContinuousTailDetails(String(tailChunk));
        var lastChunk = this.chunks[this.chunks.length - 1];
        var extendLast = lastChunk && ( // if stops are same or tail has no stop
        lastChunk.stop === tailChunk.stop || tailChunk.stop == null) && // if tail chunk goes just after last chunk
        tailChunk.from === lastChunk.from + lastChunk.toString().length;

        if (tailChunk instanceof ContinuousTailDetails) {
          // check the ability to extend previous chunk
          if (extendLast) {
            // extend previous chunk
            lastChunk.extend(tailChunk.toString());
          } else {
            // append new chunk
            this.chunks.push(tailChunk);
          }
        } else if (tailChunk instanceof ChunksTailDetails) {
          if (tailChunk.stop == null) {
            // unwrap floating chunks to parent, keeping `from` pos
            var firstTailChunk;

            while (tailChunk.chunks.length && tailChunk.chunks[0].stop == null) {
              firstTailChunk = tailChunk.chunks.shift();
              firstTailChunk.from += tailChunk.from;
              this.extend(firstTailChunk);
            }
          } // if tail chunk still has value


          if (tailChunk.toString()) {
            // if chunks contains stops, then popup stop to container
            tailChunk.stop = tailChunk.blockIndex;
            this.chunks.push(tailChunk);
          }
        }
      }
    }, {
      key: "appendTo",
      value: function appendTo(masked) {
        if (!(masked instanceof g.IMask.MaskedPattern)) {
          var tail = new ContinuousTailDetails(this.toString());
          return tail.appendTo(masked);
        }

        var details = new ChangeDetails();

        for (var ci = 0; ci < this.chunks.length && !details.skip; ++ci) {
          var chunk = this.chunks[ci];

          var lastBlockIter = masked._mapPosToBlock(masked.value.length);

          var stop = chunk.stop;
          var chunkBlock = void 0;

          if (stop && ( // if block not found or stop is behind lastBlock
          !lastBlockIter || lastBlockIter.index <= stop)) {
            if (chunk instanceof ChunksTailDetails || // for continuous block also check if stop is exist
            masked._stops.indexOf(stop) >= 0) {
              details.aggregate(masked._appendPlaceholder(stop));
            }

            chunkBlock = chunk instanceof ChunksTailDetails && masked._blocks[stop];
          }

          if (chunkBlock) {
            var tailDetails = chunkBlock.appendTail(chunk);
            tailDetails.skip = false; // always ignore skip, it will be set on last

            details.aggregate(tailDetails);
            masked._value += tailDetails.inserted; // get not inserted chars

            var remainChars = chunk.toString().slice(tailDetails.rawInserted.length);
            if (remainChars) details.aggregate(masked.append(remainChars, {
              tail: true
            }));
          } else {
            details.aggregate(masked.append(chunk.toString(), {
              tail: true
            }));
          }
        }

        return details;
      }
    }, {
      key: "shiftBefore",
      value: function shiftBefore(pos) {
        if (this.from >= pos || !this.chunks.length) return '';
        var chunkShiftPos = pos - this.from;
        var ci = 0;

        while (ci < this.chunks.length) {
          var chunk = this.chunks[ci];
          var shiftChar = chunk.shiftBefore(chunkShiftPos);

          if (chunk.toString()) {
            // chunk still contains value
            // but not shifted - means no more available chars to shift
            if (!shiftChar) break;
            ++ci;
          } else {
            // clean if chunk has no value
            this.chunks.splice(ci, 1);
          }

          if (shiftChar) return shiftChar;
        }

        return '';
      }
    }, {
      key: "state",
      get: function get() {
        return {
          chunks: this.chunks.map(function (c) {
            return c.state;
          }),
          from: this.from,
          stop: this.stop,
          blockIndex: this.blockIndex
        };
      },
      set: function set(state) {
        var chunks = state.chunks,
            props = _objectWithoutProperties(state, ["chunks"]);

        Object.assign(this, props);
        this.chunks = chunks.map(function (cstate) {
          var chunk = "chunks" in cstate ? new ChunksTailDetails() : new ContinuousTailDetails(); // $FlowFixMe already checked above

          chunk.state = cstate;
          return chunk;
        });
      }
    }]);

    return ChunksTailDetails;
  }();
  /**
    Pattern mask
    @param {Object} opts
    @param {Object} opts.blocks
    @param {Object} opts.definitions
    @param {string} opts.placeholderChar
    @param {boolean} opts.lazy
   */


  var MaskedPattern =
  /*#__PURE__*/
  function (_Masked) {
    _inherits(MaskedPattern, _Masked);
    /** */

    /** */

    /** Single char for empty input */

    /** Show placeholder only when needed */


    function MaskedPattern() {
      var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      _classCallCheck(this, MaskedPattern); // TODO type $Shape<MaskedPatternOptions>={} does not work


      opts.definitions = Object.assign({}, DEFAULT_INPUT_DEFINITIONS, opts.definitions);
      return _possibleConstructorReturn(this, _getPrototypeOf(MaskedPattern).call(this, Object.assign({}, MaskedPattern.DEFAULTS, {}, opts)));
    }
    /**
    @override
    @param {Object} opts
     */


    _createClass(MaskedPattern, [{
      key: "_update",
      value: function _update() {
        var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        opts.definitions = Object.assign({}, this.definitions, opts.definitions);

        _get(_getPrototypeOf(MaskedPattern.prototype), "_update", this).call(this, opts);

        this._rebuildMask();
      }
      /** */

    }, {
      key: "_rebuildMask",
      value: function _rebuildMask() {
        var _this = this;

        var defs = this.definitions;
        this._blocks = [];
        this._stops = [];
        this._maskedBlocks = {};
        var pattern = this.mask;
        if (!pattern || !defs) return;
        var unmaskingBlock = false;
        var optionalBlock = false;

        for (var i = 0; i < pattern.length; ++i) {
          if (this.blocks) {
            var _ret = function () {
              var p = pattern.slice(i);
              var bNames = Object.keys(_this.blocks).filter(function (bName) {
                return p.indexOf(bName) === 0;
              }); // order by key length

              bNames.sort(function (a, b) {
                return b.length - a.length;
              }); // use block name with max length

              var bName = bNames[0];

              if (bName) {
                var maskedBlock = createMask(Object.assign({
                  parent: _this,
                  lazy: _this.lazy,
                  placeholderChar: _this.placeholderChar,
                  overwrite: _this.overwrite
                }, _this.blocks[bName]));

                if (maskedBlock) {
                  _this._blocks.push(maskedBlock); // store block index


                  if (!_this._maskedBlocks[bName]) _this._maskedBlocks[bName] = [];

                  _this._maskedBlocks[bName].push(_this._blocks.length - 1);
                }

                i += bName.length - 1;
                return "continue";
              }
            }();

            if (_ret === "continue") continue;
          }

          var _char = pattern[i];

          var _isInput = _char in defs;

          if (_char === MaskedPattern.STOP_CHAR) {
            this._stops.push(this._blocks.length);

            continue;
          }

          if (_char === '{' || _char === '}') {
            unmaskingBlock = !unmaskingBlock;
            continue;
          }

          if (_char === '[' || _char === ']') {
            optionalBlock = !optionalBlock;
            continue;
          }

          if (_char === MaskedPattern.ESCAPE_CHAR) {
            ++i;
            _char = pattern[i];
            if (!_char) break;
            _isInput = false;
          }

          var def = _isInput ? new PatternInputDefinition({
            parent: this,
            lazy: this.lazy,
            placeholderChar: this.placeholderChar,
            mask: defs[_char],
            isOptional: optionalBlock
          }) : new PatternFixedDefinition({
            "char": _char,
            isUnmasking: unmaskingBlock
          });

          this._blocks.push(def);
        }
      }
      /**
      @override
       */

    }, {
      key: "reset",

      /**
      @override
       */
      value: function reset() {
        _get(_getPrototypeOf(MaskedPattern.prototype), "reset", this).call(this);

        this._blocks.forEach(function (b) {
          return b.reset();
        });
      }
      /**
      @override
       */

    }, {
      key: "doCommit",

      /**
      @override
       */
      value: function doCommit() {
        this._blocks.forEach(function (b) {
          return b.doCommit();
        });

        _get(_getPrototypeOf(MaskedPattern.prototype), "doCommit", this).call(this);
      }
      /**
      @override
       */

    }, {
      key: "appendTail",

      /**
      @override
       */
      value: function appendTail(tail) {
        return _get(_getPrototypeOf(MaskedPattern.prototype), "appendTail", this).call(this, tail).aggregate(this._appendPlaceholder());
      }
      /**
      @override
       */

    }, {
      key: "_appendCharRaw",
      value: function _appendCharRaw(ch) {
        var flags = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        ch = this.doPrepare(ch, flags);

        var blockIter = this._mapPosToBlock(this.value.length);

        var details = new ChangeDetails();
        if (!blockIter) return details;

        for (var bi = blockIter.index;; ++bi) {
          var _block = this._blocks[bi];
          if (!_block) break;

          var blockDetails = _block._appendChar(ch, flags);

          var skip = blockDetails.skip;
          details.aggregate(blockDetails);
          if (skip || blockDetails.rawInserted) break; // go next char
        }

        return details;
      }
      /**
      @override
       */

    }, {
      key: "extractTail",
      value: function extractTail() {
        var _this2 = this;

        var fromPos = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        var toPos = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.value.length;
        var chunkTail = new ChunksTailDetails();
        if (fromPos === toPos) return chunkTail;

        this._forEachBlocksInRange(fromPos, toPos, function (b, bi, bFromPos, bToPos) {
          var blockChunk = b.extractTail(bFromPos, bToPos);
          blockChunk.stop = _this2._findStopBefore(bi);
          blockChunk.from = _this2._blockStartPos(bi);
          if (blockChunk instanceof ChunksTailDetails) blockChunk.blockIndex = bi;
          chunkTail.extend(blockChunk);
        });

        return chunkTail;
      }
      /**
      @override
       */

    }, {
      key: "extractInput",
      value: function extractInput() {
        var fromPos = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        var toPos = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.value.length;
        var flags = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        if (fromPos === toPos) return '';
        var input = '';

        this._forEachBlocksInRange(fromPos, toPos, function (b, _, fromPos, toPos) {
          input += b.extractInput(fromPos, toPos, flags);
        });

        return input;
      }
    }, {
      key: "_findStopBefore",
      value: function _findStopBefore(blockIndex) {
        var stopBefore;

        for (var si = 0; si < this._stops.length; ++si) {
          var stop = this._stops[si];
          if (stop <= blockIndex) stopBefore = stop;else break;
        }

        return stopBefore;
      }
      /** Appends placeholder depending on laziness */

    }, {
      key: "_appendPlaceholder",
      value: function _appendPlaceholder(toBlockIndex) {
        var _this3 = this;

        var details = new ChangeDetails();
        if (this.lazy && toBlockIndex == null) return details;

        var startBlockIter = this._mapPosToBlock(this.value.length);

        if (!startBlockIter) return details;
        var startBlockIndex = startBlockIter.index;
        var endBlockIndex = toBlockIndex != null ? toBlockIndex : this._blocks.length;

        this._blocks.slice(startBlockIndex, endBlockIndex).forEach(function (b) {
          if (!b.lazy || toBlockIndex != null) {
            // $FlowFixMe `_blocks` may not be present
            var args = b._blocks != null ? [b._blocks.length] : [];

            var bDetails = b._appendPlaceholder.apply(b, args);

            _this3._value += bDetails.inserted;
            details.aggregate(bDetails);
          }
        });

        return details;
      }
      /** Finds block in pos */

    }, {
      key: "_mapPosToBlock",
      value: function _mapPosToBlock(pos) {
        var accVal = '';

        for (var bi = 0; bi < this._blocks.length; ++bi) {
          var _block2 = this._blocks[bi];
          var blockStartPos = accVal.length;
          accVal += _block2.value;

          if (pos <= accVal.length) {
            return {
              index: bi,
              offset: pos - blockStartPos
            };
          }
        }
      }
      /** */

    }, {
      key: "_blockStartPos",
      value: function _blockStartPos(blockIndex) {
        return this._blocks.slice(0, blockIndex).reduce(function (pos, b) {
          return pos += b.value.length;
        }, 0);
      }
      /** */

    }, {
      key: "_forEachBlocksInRange",
      value: function _forEachBlocksInRange(fromPos) {
        var toPos = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.value.length;
        var fn = arguments.length > 2 ? arguments[2] : undefined;

        var fromBlockIter = this._mapPosToBlock(fromPos);

        if (fromBlockIter) {
          var toBlockIter = this._mapPosToBlock(toPos); // process first block


          var isSameBlock = toBlockIter && fromBlockIter.index === toBlockIter.index;
          var fromBlockStartPos = fromBlockIter.offset;
          var fromBlockEndPos = toBlockIter && isSameBlock ? toBlockIter.offset : this._blocks[fromBlockIter.index].value.length;
          fn(this._blocks[fromBlockIter.index], fromBlockIter.index, fromBlockStartPos, fromBlockEndPos);

          if (toBlockIter && !isSameBlock) {
            // process intermediate blocks
            for (var bi = fromBlockIter.index + 1; bi < toBlockIter.index; ++bi) {
              fn(this._blocks[bi], bi, 0, this._blocks[bi].value.length);
            } // process last block


            fn(this._blocks[toBlockIter.index], toBlockIter.index, 0, toBlockIter.offset);
          }
        }
      }
      /**
      @override
       */

    }, {
      key: "remove",
      value: function remove() {
        var fromPos = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        var toPos = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.value.length;

        var removeDetails = _get(_getPrototypeOf(MaskedPattern.prototype), "remove", this).call(this, fromPos, toPos);

        this._forEachBlocksInRange(fromPos, toPos, function (b, _, bFromPos, bToPos) {
          removeDetails.aggregate(b.remove(bFromPos, bToPos));
        });

        return removeDetails;
      }
      /**
      @override
       */

    }, {
      key: "nearestInputPos",
      value: function nearestInputPos(cursorPos) {
        var direction = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DIRECTION.NONE; // TODO refactor - extract alignblock

        var beginBlockData = this._mapPosToBlock(cursorPos) || {
          index: 0,
          offset: 0
        };
        var beginBlockOffset = beginBlockData.offset,
            beginBlockIndex = beginBlockData.index;
        var beginBlock = this._blocks[beginBlockIndex];
        if (!beginBlock) return cursorPos;
        var beginBlockCursorPos = beginBlockOffset; // if position inside block - try to adjust it

        if (beginBlockCursorPos !== 0 && beginBlockCursorPos < beginBlock.value.length) {
          beginBlockCursorPos = beginBlock.nearestInputPos(beginBlockOffset, forceDirection(direction));
        }

        var cursorAtRight = beginBlockCursorPos === beginBlock.value.length;
        var cursorAtLeft = beginBlockCursorPos === 0; //  cursor is INSIDE first block (not at bounds)

        if (!cursorAtLeft && !cursorAtRight) return this._blockStartPos(beginBlockIndex) + beginBlockCursorPos;
        var searchBlockIndex = cursorAtRight ? beginBlockIndex + 1 : beginBlockIndex;

        if (direction === DIRECTION.NONE) {
          // NONE direction used to calculate start input position if no chars were removed
          // FOR NONE:
          // -
          // input|any
          // ->
          //  any|input
          // <-
          //  filled-input|any
          // check if first block at left is input
          if (searchBlockIndex > 0) {
            var blockIndexAtLeft = searchBlockIndex - 1;
            var blockAtLeft = this._blocks[blockIndexAtLeft];
            var blockInputPos = blockAtLeft.nearestInputPos(0, DIRECTION.NONE); // is input

            if (!blockAtLeft.value.length || blockInputPos !== blockAtLeft.value.length) {
              return this._blockStartPos(searchBlockIndex);
            }
          } // ->


          var firstInputAtRight = searchBlockIndex;

          for (var bi = firstInputAtRight; bi < this._blocks.length; ++bi) {
            var blockAtRight = this._blocks[bi];

            var _blockInputPos = blockAtRight.nearestInputPos(0, DIRECTION.NONE);

            if (!blockAtRight.value.length || _blockInputPos !== blockAtRight.value.length) {
              return this._blockStartPos(bi) + _blockInputPos;
            }
          } // <-
          // find first non-fixed symbol


          for (var _bi = searchBlockIndex - 1; _bi >= 0; --_bi) {
            var _block3 = this._blocks[_bi];

            var _blockInputPos2 = _block3.nearestInputPos(0, DIRECTION.NONE); // is input


            if (!_block3.value.length || _blockInputPos2 !== _block3.value.length) {
              return this._blockStartPos(_bi) + _block3.value.length;
            }
          }

          return cursorPos;
        }

        if (direction === DIRECTION.LEFT || direction === DIRECTION.FORCE_LEFT) {
          // -
          //  any|filled-input
          // <-
          //  any|first not empty is not-len-aligned
          //  not-0-aligned|any
          // ->
          //  any|not-len-aligned or end
          // check if first block at right is filled input
          var firstFilledBlockIndexAtRight;

          for (var _bi2 = searchBlockIndex; _bi2 < this._blocks.length; ++_bi2) {
            if (this._blocks[_bi2].value) {
              firstFilledBlockIndexAtRight = _bi2;
              break;
            }
          }

          if (firstFilledBlockIndexAtRight != null) {
            var filledBlock = this._blocks[firstFilledBlockIndexAtRight];

            var _blockInputPos3 = filledBlock.nearestInputPos(0, DIRECTION.RIGHT);

            if (_blockInputPos3 === 0 && filledBlock.unmaskedValue.length) {
              // filled block is input
              return this._blockStartPos(firstFilledBlockIndexAtRight) + _blockInputPos3;
            }
          } // <-
          // find this vars


          var firstFilledInputBlockIndex = -1;
          var firstEmptyInputBlockIndex; // TODO consider nested empty inputs

          for (var _bi3 = searchBlockIndex - 1; _bi3 >= 0; --_bi3) {
            var _block4 = this._blocks[_bi3];

            var _blockInputPos4 = _block4.nearestInputPos(_block4.value.length, DIRECTION.FORCE_LEFT);

            if (!_block4.value || _blockInputPos4 !== 0) firstEmptyInputBlockIndex = _bi3;

            if (_blockInputPos4 !== 0) {
              if (_blockInputPos4 !== _block4.value.length) {
                // aligned inside block - return immediately
                return this._blockStartPos(_bi3) + _blockInputPos4;
              } else {
                // found filled
                firstFilledInputBlockIndex = _bi3;
                break;
              }
            }
          }

          if (direction === DIRECTION.LEFT) {
            // try find first empty input before start searching position only when not forced
            for (var _bi4 = firstFilledInputBlockIndex + 1; _bi4 <= Math.min(searchBlockIndex, this._blocks.length - 1); ++_bi4) {
              var _block5 = this._blocks[_bi4];

              var _blockInputPos5 = _block5.nearestInputPos(0, DIRECTION.NONE);

              var blockAlignedPos = this._blockStartPos(_bi4) + _blockInputPos5;

              if (blockAlignedPos > cursorPos) break; // if block is not lazy input

              if (_blockInputPos5 !== _block5.value.length) return blockAlignedPos;
            }
          } // process overflow


          if (firstFilledInputBlockIndex >= 0) {
            return this._blockStartPos(firstFilledInputBlockIndex) + this._blocks[firstFilledInputBlockIndex].value.length;
          } // for lazy if has aligned left inside fixed and has came to the start - use start position


          if (direction === DIRECTION.FORCE_LEFT || this.lazy && !this.extractInput() && !isInput(this._blocks[searchBlockIndex])) {
            return 0;
          }

          if (firstEmptyInputBlockIndex != null) {
            return this._blockStartPos(firstEmptyInputBlockIndex);
          } // find first input


          for (var _bi5 = searchBlockIndex; _bi5 < this._blocks.length; ++_bi5) {
            var _block6 = this._blocks[_bi5];

            var _blockInputPos6 = _block6.nearestInputPos(0, DIRECTION.NONE); // is input


            if (!_block6.value.length || _blockInputPos6 !== _block6.value.length) {
              return this._blockStartPos(_bi5) + _blockInputPos6;
            }
          }

          return 0;
        }

        if (direction === DIRECTION.RIGHT || direction === DIRECTION.FORCE_RIGHT) {
          // ->
          //  any|not-len-aligned and filled
          //  any|not-len-aligned
          // <-
          //  not-0-aligned or start|any
          var firstInputBlockAlignedIndex;
          var firstInputBlockAlignedPos;

          for (var _bi6 = searchBlockIndex; _bi6 < this._blocks.length; ++_bi6) {
            var _block7 = this._blocks[_bi6];

            var _blockInputPos7 = _block7.nearestInputPos(0, DIRECTION.NONE);

            if (_blockInputPos7 !== _block7.value.length) {
              firstInputBlockAlignedPos = this._blockStartPos(_bi6) + _blockInputPos7;
              firstInputBlockAlignedIndex = _bi6;
              break;
            }
          }

          if (firstInputBlockAlignedIndex != null && firstInputBlockAlignedPos != null) {
            for (var _bi7 = firstInputBlockAlignedIndex; _bi7 < this._blocks.length; ++_bi7) {
              var _block8 = this._blocks[_bi7];

              var _blockInputPos8 = _block8.nearestInputPos(0, DIRECTION.FORCE_RIGHT);

              if (_blockInputPos8 !== _block8.value.length) {
                return this._blockStartPos(_bi7) + _blockInputPos8;
              }
            }

            return direction === DIRECTION.FORCE_RIGHT ? this.value.length : firstInputBlockAlignedPos;
          }

          for (var _bi8 = Math.min(searchBlockIndex, this._blocks.length - 1); _bi8 >= 0; --_bi8) {
            var _block9 = this._blocks[_bi8];

            var _blockInputPos9 = _block9.nearestInputPos(_block9.value.length, DIRECTION.LEFT);

            if (_blockInputPos9 !== 0) {
              var alignedPos = this._blockStartPos(_bi8) + _blockInputPos9;

              if (alignedPos >= cursorPos) return alignedPos;
              break;
            }
          }
        }

        return cursorPos;
      }
      /** Get block by name */

    }, {
      key: "maskedBlock",
      value: function maskedBlock(name) {
        return this.maskedBlocks(name)[0];
      }
      /** Get all blocks by name */

    }, {
      key: "maskedBlocks",
      value: function maskedBlocks(name) {
        var _this4 = this;

        var indices = this._maskedBlocks[name];
        if (!indices) return [];
        return indices.map(function (gi) {
          return _this4._blocks[gi];
        });
      }
    }, {
      key: "state",
      get: function get() {
        return Object.assign({}, _get(_getPrototypeOf(MaskedPattern.prototype), "state", this), {
          _blocks: this._blocks.map(function (b) {
            return b.state;
          })
        });
      },
      set: function set(state) {
        var _blocks = state._blocks,
            maskedState = _objectWithoutProperties(state, ["_blocks"]);

        this._blocks.forEach(function (b, bi) {
          return b.state = _blocks[bi];
        });

        _set(_getPrototypeOf(MaskedPattern.prototype), "state", maskedState, this, true);
      }
    }, {
      key: "isComplete",
      get: function get() {
        return this._blocks.every(function (b) {
          return b.isComplete;
        });
      }
    }, {
      key: "unmaskedValue",
      get: function get() {
        return this._blocks.reduce(function (str, b) {
          return str += b.unmaskedValue;
        }, '');
      },
      set: function set(unmaskedValue) {
        _set(_getPrototypeOf(MaskedPattern.prototype), "unmaskedValue", unmaskedValue, this, true);
      }
      /**
      @override
       */

    }, {
      key: "value",
      get: function get() {
        // TODO return _value when not in change?
        return this._blocks.reduce(function (str, b) {
          return str += b.value;
        }, '');
      },
      set: function set(value) {
        _set(_getPrototypeOf(MaskedPattern.prototype), "value", value, this, true);
      }
    }]);

    return MaskedPattern;
  }(Masked);

  MaskedPattern.DEFAULTS = {
    lazy: true,
    placeholderChar: '_'
  };
  MaskedPattern.STOP_CHAR = '`';
  MaskedPattern.ESCAPE_CHAR = '\\';
  MaskedPattern.InputDefinition = PatternInputDefinition;
  MaskedPattern.FixedDefinition = PatternFixedDefinition;

  function isInput(block) {
    if (!block) return false;
    var value = block.value;
    return !value || block.nearestInputPos(0, DIRECTION.NONE) !== value.length;
  }
  /** Pattern which accepts ranges */


  var MaskedRange =
  /*#__PURE__*/
  function (_MaskedPattern) {
    _inherits(MaskedRange, _MaskedPattern);

    function MaskedRange() {
      _classCallCheck(this, MaskedRange);

      return _possibleConstructorReturn(this, _getPrototypeOf(MaskedRange).apply(this, arguments));
    }

    _createClass(MaskedRange, [{
      key: "_update",

      /**
      @override
       */
      value: function _update(opts) {
        // TODO type
        opts = Object.assign({
          to: this.to || 0,
          from: this.from || 0
        }, opts);
        var maxLength = String(opts.to).length;
        if (opts.maxLength != null) maxLength = Math.max(maxLength, opts.maxLength);
        opts.maxLength = maxLength;
        var fromStr = String(opts.from).padStart(maxLength, '0');
        var toStr = String(opts.to).padStart(maxLength, '0');
        var sameCharsCount = 0;

        while (sameCharsCount < toStr.length && toStr[sameCharsCount] === fromStr[sameCharsCount]) {
          ++sameCharsCount;
        }

        opts.mask = toStr.slice(0, sameCharsCount).replace(/0/g, '\\0') + '0'.repeat(maxLength - sameCharsCount);

        _get(_getPrototypeOf(MaskedRange.prototype), "_update", this).call(this, opts);
      }
      /**
      @override
       */

    }, {
      key: "boundaries",
      value: function boundaries(str) {
        var minstr = '';
        var maxstr = '';

        var _ref = str.match(/^(\D*)(\d*)(\D*)/) || [],
            _ref2 = _slicedToArray(_ref, 3),
            placeholder = _ref2[1],
            num = _ref2[2];

        if (num) {
          minstr = '0'.repeat(placeholder.length) + num;
          maxstr = '9'.repeat(placeholder.length) + num;
        }

        minstr = minstr.padEnd(this.maxLength, '0');
        maxstr = maxstr.padEnd(this.maxLength, '9');
        return [minstr, maxstr];
      }
      /**
      @override
       */

    }, {
      key: "doPrepare",
      value: function doPrepare(str) {
        var flags = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        str = _get(_getPrototypeOf(MaskedRange.prototype), "doPrepare", this).call(this, str, flags).replace(/\D/g, '');
        if (!this.autofix) return str;
        var fromStr = String(this.from).padStart(this.maxLength, '0');
        var toStr = String(this.to).padStart(this.maxLength, '0');
        var val = this.value;
        var prepStr = '';

        for (var ci = 0; ci < str.length; ++ci) {
          var nextVal = val + prepStr + str[ci];

          var _this$boundaries = this.boundaries(nextVal),
              _this$boundaries2 = _slicedToArray(_this$boundaries, 2),
              minstr = _this$boundaries2[0],
              maxstr = _this$boundaries2[1];

          if (Number(maxstr) < this.from) prepStr += fromStr[nextVal.length - 1];else if (Number(minstr) > this.to) prepStr += toStr[nextVal.length - 1];else prepStr += str[ci];
        }

        return prepStr;
      }
      /**
      @override
       */

    }, {
      key: "doValidate",
      value: function doValidate() {
        var _get2;

        var str = this.value;
        var firstNonZero = str.search(/[^0]/);
        if (firstNonZero === -1 && str.length <= this._matchFrom) return true;

        var _this$boundaries3 = this.boundaries(str),
            _this$boundaries4 = _slicedToArray(_this$boundaries3, 2),
            minstr = _this$boundaries4[0],
            maxstr = _this$boundaries4[1];

        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return this.from <= Number(maxstr) && Number(minstr) <= this.to && (_get2 = _get(_getPrototypeOf(MaskedRange.prototype), "doValidate", this)).call.apply(_get2, [this].concat(args));
      }
    }, {
      key: "_matchFrom",

      /**
      Optionally sets max length of pattern.
      Used when pattern length is longer then `to` param length. Pads zeros at start in this case.
       */

      /** Min bound */

      /** Max bound */

      /** */
      get: function get() {
        return this.maxLength - String(this.from).length;
      }
    }, {
      key: "isComplete",
      get: function get() {
        return _get(_getPrototypeOf(MaskedRange.prototype), "isComplete", this) && Boolean(this.value);
      }
    }]);

    return MaskedRange;
  }(MaskedPattern);
  /** Date mask */


  var MaskedDate =
  /*#__PURE__*/
  function (_MaskedPattern) {
    _inherits(MaskedDate, _MaskedPattern);
    /** Parse string to Date */

    /** Format Date to string */

    /** Pattern mask for date according to {@link MaskedDate#format} */

    /** Start date */

    /** End date */

    /** */

    /**
    @param {Object} opts
     */


    function MaskedDate(opts) {
      _classCallCheck(this, MaskedDate);

      return _possibleConstructorReturn(this, _getPrototypeOf(MaskedDate).call(this, Object.assign({}, MaskedDate.DEFAULTS, {}, opts)));
    }
    /**
    @override
     */


    _createClass(MaskedDate, [{
      key: "_update",
      value: function _update(opts) {
        if (opts.mask === Date) delete opts.mask;
        if (opts.pattern) opts.mask = opts.pattern;
        var blocks = opts.blocks;
        opts.blocks = Object.assign({}, MaskedDate.GET_DEFAULT_BLOCKS()); // adjust year block

        if (opts.min) opts.blocks.Y.from = opts.min.getFullYear();
        if (opts.max) opts.blocks.Y.to = opts.max.getFullYear();

        if (opts.min && opts.max && opts.blocks.Y.from === opts.blocks.Y.to) {
          opts.blocks.m.from = opts.min.getMonth() + 1;
          opts.blocks.m.to = opts.max.getMonth() + 1;

          if (opts.blocks.m.from === opts.blocks.m.to) {
            opts.blocks.d.from = opts.min.getDate();
            opts.blocks.d.to = opts.max.getDate();
          }
        }

        Object.assign(opts.blocks, blocks); // add autofix

        Object.keys(opts.blocks).forEach(function (bk) {
          var b = opts.blocks[bk];
          if (!('autofix' in b)) b.autofix = opts.autofix;
        });

        _get(_getPrototypeOf(MaskedDate.prototype), "_update", this).call(this, opts);
      }
      /**
      @override
       */

    }, {
      key: "doValidate",
      value: function doValidate() {
        var _get2;

        var date = this.date;

        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return (_get2 = _get(_getPrototypeOf(MaskedDate.prototype), "doValidate", this)).call.apply(_get2, [this].concat(args)) && (!this.isComplete || this.isDateExist(this.value) && date != null && (this.min == null || this.min <= date) && (this.max == null || date <= this.max));
      }
      /** Checks if date is exists */

    }, {
      key: "isDateExist",
      value: function isDateExist(str) {
        return this.format(this.parse(str)) === str;
      }
      /** Parsed Date */

    }, {
      key: "date",
      get: function get() {
        return this.isComplete ? this.parse(this.value) : null;
      },
      set: function set(date) {
        this.value = this.format(date);
      }
      /**
      @override
       */

    }, {
      key: "typedValue",
      get: function get() {
        return this.date;
      },
      set: function set(value) {
        this.date = value;
      }
    }]);

    return MaskedDate;
  }(MaskedPattern);

  MaskedDate.DEFAULTS = {
    pattern: 'd{.}`m{.}`Y',
    format: function format(date) {
      var day = String(date.getDate()).padStart(2, '0');
      var month = String(date.getMonth() + 1).padStart(2, '0');
      var year = date.getFullYear();
      return [day, month, year].join('.');
    },
    parse: function parse(str) {
      var _str$split = str.split('.'),
          _str$split2 = _slicedToArray(_str$split, 3),
          day = _str$split2[0],
          month = _str$split2[1],
          year = _str$split2[2];

      return new Date(year, month - 1, day);
    }
  };

  MaskedDate.GET_DEFAULT_BLOCKS = function () {
    return {
      d: {
        mask: MaskedRange,
        from: 1,
        to: 31,
        maxLength: 2
      },
      m: {
        mask: MaskedRange,
        from: 1,
        to: 12,
        maxLength: 2
      },
      Y: {
        mask: MaskedRange,
        from: 1900,
        to: 9999
      }
    };
  };
  /**
    Generic element API to use with mask
    @interface
   */


  var MaskElement =
  /*#__PURE__*/
  function () {
    function MaskElement() {
      _classCallCheck(this, MaskElement);
    }

    _createClass(MaskElement, [{
      key: "select",

      /** Safely sets element selection */
      value: function select(start, end) {
        if (start == null || end == null || start === this.selectionStart && end === this.selectionEnd) return;

        try {
          this._unsafeSelect(start, end);
        } catch (e) {}
      }
      /** Should be overriden in subclasses */

    }, {
      key: "_unsafeSelect",
      value: function _unsafeSelect(start, end) {}
      /** Should be overriden in subclasses */

    }, {
      key: "bindEvents",

      /** Should be overriden in subclasses */
      value: function bindEvents(handlers) {}
      /** Should be overriden in subclasses */

    }, {
      key: "unbindEvents",
      value: function unbindEvents() {}
    }, {
      key: "selectionStart",

      /** */

      /** */

      /** */

      /** Safely returns selection start */
      get: function get() {
        var start;

        try {
          start = this._unsafeSelectionStart;
        } catch (e) {}

        return start != null ? start : this.value.length;
      }
      /** Safely returns selection end */

    }, {
      key: "selectionEnd",
      get: function get() {
        var end;

        try {
          end = this._unsafeSelectionEnd;
        } catch (e) {}

        return end != null ? end : this.value.length;
      }
    }, {
      key: "isActive",
      get: function get() {
        return false;
      }
    }]);

    return MaskElement;
  }();
  /** Bridge between HTMLElement and {@link Masked} */


  var HTMLMaskElement =
  /*#__PURE__*/
  function (_MaskElement) {
    _inherits(HTMLMaskElement, _MaskElement);
    /** Mapping between HTMLElement events and mask internal events */

    /** HTMLElement to use mask on */

    /**
    @param {HTMLInputElement|HTMLTextAreaElement} input
     */


    function HTMLMaskElement(input) {
      var _this;

      _classCallCheck(this, HTMLMaskElement);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(HTMLMaskElement).call(this));
      _this.input = input;
      _this._handlers = {};
      return _this;
    }
    /**
    Is element in focus
    @readonly
     */


    _createClass(HTMLMaskElement, [{
      key: "_unsafeSelect",

      /**
      Sets HTMLElement selection
      @override
       */
      value: function _unsafeSelect(start, end) {
        this.input.setSelectionRange(start, end);
      }
      /**
      HTMLElement value
      @override
       */

    }, {
      key: "bindEvents",

      /**
      Binds HTMLElement events to mask internal events
      @override
       */
      value: function bindEvents(handlers) {
        var _this2 = this;

        Object.keys(handlers).forEach(function (event) {
          return _this2._toggleEventHandler(HTMLMaskElement.EVENTS_MAP[event], handlers[event]);
        });
      }
      /**
      Unbinds HTMLElement events to mask internal events
      @override
       */

    }, {
      key: "unbindEvents",
      value: function unbindEvents() {
        var _this3 = this;

        Object.keys(this._handlers).forEach(function (event) {
          return _this3._toggleEventHandler(event);
        });
      }
      /** */

    }, {
      key: "_toggleEventHandler",
      value: function _toggleEventHandler(event, handler) {
        if (this._handlers[event]) {
          this.input.removeEventListener(event, this._handlers[event]);
          delete this._handlers[event];
        }

        if (handler) {
          this.input.addEventListener(event, handler);
          this._handlers[event] = handler;
        }
      }
    }, {
      key: "isActive",
      get: function get() {
        return this.input === document.activeElement;
      }
      /**
      Returns HTMLElement selection start
      @override
       */

    }, {
      key: "_unsafeSelectionStart",
      get: function get() {
        return this.input.selectionStart;
      }
      /**
      Returns HTMLElement selection end
      @override
       */

    }, {
      key: "_unsafeSelectionEnd",
      get: function get() {
        return this.input.selectionEnd;
      }
    }, {
      key: "value",
      get: function get() {
        return this.input.value;
      },
      set: function set(value) {
        this.input.value = value;
      }
    }]);

    return HTMLMaskElement;
  }(MaskElement);

  HTMLMaskElement.EVENTS_MAP = {
    selectionChange: 'keydown',
    input: 'input',
    drop: 'drop',
    click: 'click',
    focus: 'focus',
    commit: 'blur'
  };
  /** Listens to element events and controls changes between element and {@link Masked} */

  var InputMask =
  /*#__PURE__*/
  function () {
    /**
    View element
    @readonly
     */

    /**
    Internal {@link Masked} model
    @readonly
     */

    /**
    @param {MaskElement|HTMLInputElement|HTMLTextAreaElement} el
    @param {Object} opts
     */
    function InputMask(el, opts) {
      _classCallCheck(this, InputMask);

      this.el = el instanceof MaskElement ? el : new HTMLMaskElement(el);
      this.masked = createMask(opts);
      this._listeners = {};
      this._value = '';
      this._unmaskedValue = '';
      this._saveSelection = this._saveSelection.bind(this);
      this._onInput = this._onInput.bind(this);
      this._onChange = this._onChange.bind(this);
      this._onDrop = this._onDrop.bind(this);
      this._onFocus = this._onFocus.bind(this);
      this.alignCursor = this.alignCursor.bind(this);
      this.alignCursorFriendly = this.alignCursorFriendly.bind(this);

      this._bindEvents(); // refresh


      this.updateValue();

      this._onChange();
    }
    /** Read or update mask */


    _createClass(InputMask, [{
      key: "maskEquals",
      value: function maskEquals(mask) {
        return mask == null || mask === this.masked.mask || mask === Date && this.masked instanceof MaskedDate;
      }
    }, {
      key: "_bindEvents",

      /**
      Starts listening to element events
      @protected
       */
      value: function _bindEvents() {
        this.el.bindEvents({
          selectionChange: this._saveSelection,
          input: this._onInput,
          drop: this._onDrop,
          click: this.alignCursorFriendly,
          focus: this._onFocus,
          commit: this._onChange
        });
      }
      /**
      Stops listening to element events
      @protected
       */

    }, {
      key: "_unbindEvents",
      value: function _unbindEvents() {
        this.el.unbindEvents();
      }
      /**
      Fires custom event
      @protected
       */

    }, {
      key: "_fireEvent",
      value: function _fireEvent(ev) {
        var listeners = this._listeners[ev];
        if (!listeners) return;
        listeners.forEach(function (l) {
          return l();
        });
      }
      /**
      Current selection start
      @readonly
       */

    }, {
      key: "_saveSelection",

      /**
      Stores current selection
      @protected
       */
      value: function _saveSelection()
      /* ev */
      {
        if (this.value !== this.el.value) {//console.warn( 'Element value was changed outside of mask. Syncronize mask using `mask.updateValue()` to work properly.' ); // eslint-disable-line no-console
        }

        this._selection = {
          start: this.selectionStart,
          end: this.cursorPos
        };
      }
      /** Syncronizes model value from view */

    }, {
      key: "updateValue",
      value: function updateValue() {
        this.masked.value = this.el.value;
        this._value = this.masked.value;
      }
      /** Syncronizes view from model value, fires change events */

    }, {
      key: "updateControl",
      value: function updateControl() {
        var newUnmaskedValue = this.masked.unmaskedValue;
        var newValue = this.masked.value;
        var isChanged = this.unmaskedValue !== newUnmaskedValue || this.value !== newValue;
        this._unmaskedValue = newUnmaskedValue;
        this._value = newValue;
        if (this.el.value !== newValue) this.el.value = newValue;
        if (isChanged) this._fireChangeEvents();
      }
      /** Updates options with deep equal check, recreates @{link Masked} model if mask type changes */

    }, {
      key: "updateOptions",
      value: function updateOptions(opts) {
        var mask = opts.mask,
            restOpts = _objectWithoutProperties(opts, ["mask"]);

        var updateMask = !this.maskEquals(mask);
        var updateOpts = !objectIncludes(this.masked, restOpts);
        if (updateMask) this.mask = mask;
        if (updateOpts) this.masked.updateOptions(restOpts);
        if (updateMask || updateOpts) this.updateControl();
      }
      /** Updates cursor */

    }, {
      key: "updateCursor",
      value: function updateCursor(cursorPos) {
        if (cursorPos == null) return;
        this.cursorPos = cursorPos; // also queue change cursor for mobile browsers

        this._delayUpdateCursor(cursorPos);
      }
      /**
      Delays cursor update to support mobile browsers
      @private
       */

    }, {
      key: "_delayUpdateCursor",
      value: function _delayUpdateCursor(cursorPos) {
        var _this = this;

        this._abortUpdateCursor();

        this._changingCursorPos = cursorPos;
        this._cursorChanging = setTimeout(function () {
          if (!_this.el) return; // if was destroyed

          _this.cursorPos = _this._changingCursorPos;

          _this._abortUpdateCursor();
        }, 10);
      }
      /**
      Fires custom events
      @protected
       */

    }, {
      key: "_fireChangeEvents",
      value: function _fireChangeEvents() {
        this._fireEvent('accept');

        if (this.masked.isComplete) this._fireEvent('complete');
      }
      /**
      Aborts delayed cursor update
      @private
       */

    }, {
      key: "_abortUpdateCursor",
      value: function _abortUpdateCursor() {
        if (this._cursorChanging) {
          clearTimeout(this._cursorChanging);
          delete this._cursorChanging;
        }
      }
      /** Aligns cursor to nearest available position */

    }, {
      key: "alignCursor",
      value: function alignCursor() {
        this.cursorPos = this.masked.nearestInputPos(this.cursorPos, DIRECTION.LEFT);
      }
      /** Aligns cursor only if selection is empty */

    }, {
      key: "alignCursorFriendly",
      value: function alignCursorFriendly() {
        if (this.selectionStart !== this.cursorPos) return; // skip if range is selected

        this.alignCursor();
      }
      /** Adds listener on custom event */

    }, {
      key: "on",
      value: function on(ev, handler) {
        if (!this._listeners[ev]) this._listeners[ev] = [];

        this._listeners[ev].push(handler);

        return this;
      }
      /** Removes custom event listener */

    }, {
      key: "off",
      value: function off(ev, handler) {
        if (!this._listeners[ev]) return this;

        if (!handler) {
          delete this._listeners[ev];
          return this;
        }

        var hIndex = this._listeners[ev].indexOf(handler);

        if (hIndex >= 0) this._listeners[ev].splice(hIndex, 1);
        return this;
      }
      /** Handles view input event */

    }, {
      key: "_onInput",
      value: function _onInput() {
        this._abortUpdateCursor(); // fix strange IE behavior


        if (!this._selection) return this.updateValue();
        var details = new ActionDetails( // new state
        this.el.value, this.cursorPos, // old state
        this.value, this._selection);
        var oldRawValue = this.masked.rawInputValue;
        var offset = this.masked.splice(details.startChangePos, details.removed.length, details.inserted, details.removeDirection).offset; // force align in remove direction only if no input chars were removed
        // otherwise we still need to align with NONE (to get out from fixed symbols for instance)

        var removeDirection = oldRawValue === this.masked.rawInputValue ? details.removeDirection : DIRECTION.NONE;
        var cursorPos = this.masked.nearestInputPos(details.startChangePos + offset, removeDirection);
        this.updateControl();
        this.updateCursor(cursorPos);
      }
      /** Handles view change event and commits model value */

    }, {
      key: "_onChange",
      value: function _onChange() {
        if (this.value !== this.el.value) {
          this.updateValue();
        }

        this.masked.doCommit();
        this.updateControl();

        this._saveSelection();
      }
      /** Handles view drop event, prevents by default */

    }, {
      key: "_onDrop",
      value: function _onDrop(ev) {
        ev.preventDefault();
        ev.stopPropagation();
      }
      /** Restore last selection on focus */

    }, {
      key: "_onFocus",
      value: function _onFocus(ev) {
        if (this.selectionStart !== this.cursorPos) return; // skip if range is selected

        if (this._selection) this.cursorPos = this._selection.end;
        this.alignCursorFriendly();
      }
      /** Unbind view events and removes element reference */

    }, {
      key: "destroy",
      value: function destroy() {
        this._unbindEvents(); // $FlowFixMe why not do so?


        this._listeners.length = 0;
        delete this.el;
      }
    }, {
      key: "mask",
      get: function get() {
        return this.masked.mask;
      },
      set: function set(mask) {
        if (this.maskEquals(mask)) return;

        if (this.masked.constructor === maskedClass(mask)) {
          this.masked.updateOptions({
            mask: mask
          });
          return;
        }

        var masked = createMask({
          mask: mask
        });
        masked.unmaskedValue = this.masked.unmaskedValue;
        this.masked = masked;
      }
      /** Raw value */

    }, {
      key: "value",
      get: function get() {
        return this._value;
      },
      set: function set(str) {
        this.masked.value = str;
        this.updateControl();
        this.alignCursor();
      }
      /** Unmasked value */

    }, {
      key: "unmaskedValue",
      get: function get() {
        return this._unmaskedValue;
      },
      set: function set(str) {
        this.masked.unmaskedValue = str;
        this.updateControl();
        this.alignCursor();
      }
      /** Typed unmasked value */

    }, {
      key: "typedValue",
      get: function get() {
        return this.masked.typedValue;
      },
      set: function set(val) {
        this.masked.typedValue = val;
        this.updateControl();
        this.alignCursor();
      }
    }, {
      key: "selectionStart",
      get: function get() {
        return this._cursorChanging ? this._changingCursorPos : this.el.selectionStart;
      }
      /** Current cursor position */

    }, {
      key: "cursorPos",
      get: function get() {
        return this._cursorChanging ? this._changingCursorPos : this.el.selectionEnd;
      },
      set: function set(pos) {
        if (!this.el.isActive) return;
        this.el.select(pos, pos);

        this._saveSelection();
      }
    }]);

    return InputMask;
  }();
  /** Pattern which validates enum values */


  var MaskedEnum =
  /*#__PURE__*/
  function (_MaskedPattern) {
    _inherits(MaskedEnum, _MaskedPattern);

    function MaskedEnum() {
      _classCallCheck(this, MaskedEnum);

      return _possibleConstructorReturn(this, _getPrototypeOf(MaskedEnum).apply(this, arguments));
    }

    _createClass(MaskedEnum, [{
      key: "_update",

      /**
      @override
      @param {Object} opts
       */
      value: function _update(opts) {
        // TODO type
        if (opts["enum"]) opts.mask = '*'.repeat(opts["enum"][0].length);

        _get(_getPrototypeOf(MaskedEnum.prototype), "_update", this).call(this, opts);
      }
      /**
      @override
       */

    }, {
      key: "doValidate",
      value: function doValidate() {
        var _this = this,
            _get2;

        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return this["enum"].some(function (e) {
          return e.indexOf(_this.unmaskedValue) >= 0;
        }) && (_get2 = _get(_getPrototypeOf(MaskedEnum.prototype), "doValidate", this)).call.apply(_get2, [this].concat(args));
      }
    }]);

    return MaskedEnum;
  }(MaskedPattern);
  /**
    Number mask
    @param {Object} opts
    @param {string} opts.radix - Single char
    @param {string} opts.thousandsSeparator - Single char
    @param {Array<string>} opts.mapToRadix - Array of single chars
    @param {number} opts.min
    @param {number} opts.max
    @param {number} opts.scale - Digits after point
    @param {boolean} opts.signed - Allow negative
    @param {boolean} opts.normalizeZeros - Flag to remove leading and trailing zeros in the end of editing
    @param {boolean} opts.padFractionalZeros - Flag to pad trailing zeros after point in the end of editing
   */


  var MaskedNumber =
  /*#__PURE__*/
  function (_Masked) {
    _inherits(MaskedNumber, _Masked);
    /** Single char */

    /** Single char */

    /** Array of single chars */

    /** */

    /** */

    /** Digits after point */

    /** */

    /** Flag to remove leading and trailing zeros in the end of editing */

    /** Flag to pad trailing zeros after point in the end of editing */


    function MaskedNumber(opts) {
      _classCallCheck(this, MaskedNumber);

      return _possibleConstructorReturn(this, _getPrototypeOf(MaskedNumber).call(this, Object.assign({}, MaskedNumber.DEFAULTS, {}, opts)));
    }
    /**
    @override
     */


    _createClass(MaskedNumber, [{
      key: "_update",
      value: function _update(opts) {
        _get(_getPrototypeOf(MaskedNumber.prototype), "_update", this).call(this, opts);

        this._updateRegExps();
      }
      /** */

    }, {
      key: "_updateRegExps",
      value: function _updateRegExps() {
        // use different regexp to process user input (more strict, input suffix) and tail shifting
        var start = '^' + (this.allowNegative ? '[+|\\-]?' : '');
        var midInput = '(0|([1-9]+\\d*))?';
        var mid = '\\d*';
        var end = (this.scale ? '(' + escapeRegExp(this.radix) + '\\d{0,' + this.scale + '})?' : '') + '$';
        this._numberRegExpInput = new RegExp(start + midInput + end);
        this._numberRegExp = new RegExp(start + mid + end);
        this._mapToRadixRegExp = new RegExp('[' + this.mapToRadix.map(escapeRegExp).join('') + ']', 'g');
        this._thousandsSeparatorRegExp = new RegExp(escapeRegExp(this.thousandsSeparator), 'g');
      }
      /** */

    }, {
      key: "_removeThousandsSeparators",
      value: function _removeThousandsSeparators(value) {
        return value.replace(this._thousandsSeparatorRegExp, '');
      }
      /** */

    }, {
      key: "_insertThousandsSeparators",
      value: function _insertThousandsSeparators(value) {
        // https://stackoverflow.com/questions/2901102/how-to-print-a-number-with-commas-as-thousands-separators-in-javascript
        var parts = value.split(this.radix);
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, this.thousandsSeparator);
        return parts.join(this.radix);
      }
      /**
      @override
       */

    }, {
      key: "doPrepare",
      value: function doPrepare(str) {
        var _get2;

        for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          args[_key - 1] = arguments[_key];
        }

        return (_get2 = _get(_getPrototypeOf(MaskedNumber.prototype), "doPrepare", this)).call.apply(_get2, [this, this._removeThousandsSeparators(str.replace(this._mapToRadixRegExp, this.radix))].concat(args));
      }
      /** */

    }, {
      key: "_separatorsCount",
      value: function _separatorsCount(to) {
        var extendOnSeparators = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        var count = 0;

        for (var pos = 0; pos < to; ++pos) {
          if (this._value.indexOf(this.thousandsSeparator, pos) === pos) {
            ++count;
            if (extendOnSeparators) to += this.thousandsSeparator.length;
          }
        }

        return count;
      }
      /** */

    }, {
      key: "_separatorsCountFromSlice",
      value: function _separatorsCountFromSlice() {
        var slice = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this._value;
        return this._separatorsCount(this._removeThousandsSeparators(slice).length, true);
      }
      /**
      @override
       */

    }, {
      key: "extractInput",
      value: function extractInput() {
        var fromPos = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        var toPos = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.value.length;
        var flags = arguments.length > 2 ? arguments[2] : undefined;

        var _this$_adjustRangeWit = this._adjustRangeWithSeparators(fromPos, toPos);

        var _this$_adjustRangeWit2 = _slicedToArray(_this$_adjustRangeWit, 2);

        fromPos = _this$_adjustRangeWit2[0];
        toPos = _this$_adjustRangeWit2[1];
        return this._removeThousandsSeparators(_get(_getPrototypeOf(MaskedNumber.prototype), "extractInput", this).call(this, fromPos, toPos, flags));
      }
      /**
      @override
       */

    }, {
      key: "_appendCharRaw",
      value: function _appendCharRaw(ch) {
        var flags = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        if (!this.thousandsSeparator) return _get(_getPrototypeOf(MaskedNumber.prototype), "_appendCharRaw", this).call(this, ch, flags);
        var prevBeforeTailValue = flags.tail && flags._beforeTailState ? flags._beforeTailState._value : this._value;

        var prevBeforeTailSeparatorsCount = this._separatorsCountFromSlice(prevBeforeTailValue);

        this._value = this._removeThousandsSeparators(this.value);

        var appendDetails = _get(_getPrototypeOf(MaskedNumber.prototype), "_appendCharRaw", this).call(this, ch, flags);

        this._value = this._insertThousandsSeparators(this._value);
        var beforeTailValue = flags.tail && flags._beforeTailState ? flags._beforeTailState._value : this._value;

        var beforeTailSeparatorsCount = this._separatorsCountFromSlice(beforeTailValue);

        appendDetails.tailShift += (beforeTailSeparatorsCount - prevBeforeTailSeparatorsCount) * this.thousandsSeparator.length;
        return appendDetails;
      }
      /** */

    }, {
      key: "_findSeparatorAround",
      value: function _findSeparatorAround(pos) {
        if (this.thousandsSeparator) {
          var searchFrom = pos - this.thousandsSeparator.length + 1;
          var separatorPos = this.value.indexOf(this.thousandsSeparator, searchFrom);
          if (separatorPos <= pos) return separatorPos;
        }

        return -1;
      }
    }, {
      key: "_adjustRangeWithSeparators",
      value: function _adjustRangeWithSeparators(from, to) {
        var separatorAroundFromPos = this._findSeparatorAround(from);

        if (separatorAroundFromPos >= 0) from = separatorAroundFromPos;

        var separatorAroundToPos = this._findSeparatorAround(to);

        if (separatorAroundToPos >= 0) to = separatorAroundToPos + this.thousandsSeparator.length;
        return [from, to];
      }
      /**
      @override
       */

    }, {
      key: "remove",
      value: function remove() {
        var fromPos = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        var toPos = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.value.length;

        var _this$_adjustRangeWit3 = this._adjustRangeWithSeparators(fromPos, toPos);

        var _this$_adjustRangeWit4 = _slicedToArray(_this$_adjustRangeWit3, 2);

        fromPos = _this$_adjustRangeWit4[0];
        toPos = _this$_adjustRangeWit4[1];
        var valueBeforePos = this.value.slice(0, fromPos);
        var valueAfterPos = this.value.slice(toPos);

        var prevBeforeTailSeparatorsCount = this._separatorsCount(valueBeforePos.length);

        this._value = this._insertThousandsSeparators(this._removeThousandsSeparators(valueBeforePos + valueAfterPos));

        var beforeTailSeparatorsCount = this._separatorsCountFromSlice(valueBeforePos);

        return new ChangeDetails({
          tailShift: (beforeTailSeparatorsCount - prevBeforeTailSeparatorsCount) * this.thousandsSeparator.length
        });
      }
      /**
      @override
       */

    }, {
      key: "nearestInputPos",
      value: function nearestInputPos(cursorPos, direction) {
        if (!this.thousandsSeparator) return cursorPos;

        switch (direction) {
          case DIRECTION.NONE:
          case DIRECTION.LEFT:
          case DIRECTION.FORCE_LEFT:
            {
              var separatorAtLeftPos = this._findSeparatorAround(cursorPos - 1);

              if (separatorAtLeftPos >= 0) {
                var separatorAtLeftEndPos = separatorAtLeftPos + this.thousandsSeparator.length;

                if (cursorPos < separatorAtLeftEndPos || this.value.length <= separatorAtLeftEndPos || direction === DIRECTION.FORCE_LEFT) {
                  return separatorAtLeftPos;
                }
              }

              break;
            }

          case DIRECTION.RIGHT:
          case DIRECTION.FORCE_RIGHT:
            {
              var separatorAtRightPos = this._findSeparatorAround(cursorPos);

              if (separatorAtRightPos >= 0) {
                return separatorAtRightPos + this.thousandsSeparator.length;
              }
            }
        }

        return cursorPos;
      }
      /**
      @override
       */

    }, {
      key: "doValidate",
      value: function doValidate(flags) {
        var regexp = flags.input ? this._numberRegExpInput : this._numberRegExp; // validate as string

        var valid = regexp.test(this._removeThousandsSeparators(this.value));

        if (valid) {
          // validate as number
          var number = this.number;
          valid = valid && !isNaN(number) && ( // check min bound for negative values
          this.min == null || this.min >= 0 || this.min <= this.number) && ( // check max bound for positive values
          this.max == null || this.max <= 0 || this.number <= this.max);
        }

        return valid && _get(_getPrototypeOf(MaskedNumber.prototype), "doValidate", this).call(this, flags);
      }
      /**
      @override
       */

    }, {
      key: "doCommit",
      value: function doCommit() {
        if (this.value) {
          var number = this.number;
          var validnum = number; // check bounds

          if (this.min != null) validnum = Math.max(validnum, this.min);
          if (this.max != null) validnum = Math.min(validnum, this.max);
          if (validnum !== number) this.unmaskedValue = String(validnum);
          var formatted = this.value;
          if (this.normalizeZeros) formatted = this._normalizeZeros(formatted);
          if (this.padFractionalZeros) formatted = this._padFractionalZeros(formatted);
          this._value = formatted;
        }

        _get(_getPrototypeOf(MaskedNumber.prototype), "doCommit", this).call(this);
      }
      /** */

    }, {
      key: "_normalizeZeros",
      value: function _normalizeZeros(value) {
        var parts = this._removeThousandsSeparators(value).split(this.radix); // remove leading zeros


        parts[0] = parts[0].replace(/^(\D*)(0*)(\d*)/, function (match, sign, zeros, num) {
          return sign + num;
        }); // add leading zero

        if (value.length && !/\d$/.test(parts[0])) parts[0] = parts[0] + '0';

        if (parts.length > 1) {
          parts[1] = parts[1].replace(/0*$/, ''); // remove trailing zeros

          if (!parts[1].length) parts.length = 1; // remove fractional
        }

        return this._insertThousandsSeparators(parts.join(this.radix));
      }
      /** */

    }, {
      key: "_padFractionalZeros",
      value: function _padFractionalZeros(value) {
        if (!value) return value;
        var parts = value.split(this.radix);
        if (parts.length < 2) parts.push('');
        parts[1] = parts[1].padEnd(this.scale, '0');
        return parts.join(this.radix);
      }
      /**
      @override
       */

    }, {
      key: "unmaskedValue",
      get: function get() {
        return this._removeThousandsSeparators(this._normalizeZeros(this.value)).replace(this.radix, '.');
      },
      set: function set(unmaskedValue) {
        _set(_getPrototypeOf(MaskedNumber.prototype), "unmaskedValue", unmaskedValue.replace('.', this.radix), this, true);
      }
      /** Parsed Number */

    }, {
      key: "number",
      get: function get() {
        return Number(this.unmaskedValue);
      },
      set: function set(number) {
        this.unmaskedValue = String(number);
      }
      /**
      @override
       */

    }, {
      key: "typedValue",
      get: function get() {
        return this.number;
      },
      set: function set(value) {
        this.number = value;
      }
      /**
      Is negative allowed
      @readonly
       */

    }, {
      key: "allowNegative",
      get: function get() {
        return this.signed || this.min != null && this.min < 0 || this.max != null && this.max < 0;
      }
    }]);

    return MaskedNumber;
  }(Masked);

  MaskedNumber.DEFAULTS = {
    radix: ',',
    thousandsSeparator: '',
    mapToRadix: ['.'],
    scale: 2,
    signed: false,
    normalizeZeros: true,
    padFractionalZeros: false
  };
  /** Masking by RegExp */

  var MaskedRegExp =
  /*#__PURE__*/
  function (_Masked) {
    _inherits(MaskedRegExp, _Masked);

    function MaskedRegExp() {
      _classCallCheck(this, MaskedRegExp);

      return _possibleConstructorReturn(this, _getPrototypeOf(MaskedRegExp).apply(this, arguments));
    }

    _createClass(MaskedRegExp, [{
      key: "_update",

      /**
      @override
      @param {Object} opts
       */
      value: function _update(opts) {
        if (opts.mask) opts.validate = function (value) {
          return value.search(opts.mask) >= 0;
        };

        _get(_getPrototypeOf(MaskedRegExp.prototype), "_update", this).call(this, opts);
      }
    }]);

    return MaskedRegExp;
  }(Masked);
  /** Masking by custom Function */


  var MaskedFunction =
  /*#__PURE__*/
  function (_Masked) {
    _inherits(MaskedFunction, _Masked);

    function MaskedFunction() {
      _classCallCheck(this, MaskedFunction);

      return _possibleConstructorReturn(this, _getPrototypeOf(MaskedFunction).apply(this, arguments));
    }

    _createClass(MaskedFunction, [{
      key: "_update",

      /**
      @override
      @param {Object} opts
       */
      value: function _update(opts) {
        if (opts.mask) opts.validate = opts.mask;

        _get(_getPrototypeOf(MaskedFunction.prototype), "_update", this).call(this, opts);
      }
    }]);

    return MaskedFunction;
  }(Masked);
  /** Dynamic mask for choosing apropriate mask in run-time */


  var MaskedDynamic =
  /*#__PURE__*/
  function (_Masked) {
    _inherits(MaskedDynamic, _Masked);
    /** Currently chosen mask */

    /** Compliled {@link Masked} options */

    /** Chooses {@link Masked} depending on input value */

    /**
    @param {Object} opts
     */


    function MaskedDynamic(opts) {
      var _this;

      _classCallCheck(this, MaskedDynamic);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(MaskedDynamic).call(this, Object.assign({}, MaskedDynamic.DEFAULTS, {}, opts)));
      _this.currentMask = null;
      return _this;
    }
    /**
    @override
     */


    _createClass(MaskedDynamic, [{
      key: "_update",
      value: function _update(opts) {
        _get(_getPrototypeOf(MaskedDynamic.prototype), "_update", this).call(this, opts);

        if ('mask' in opts) {
          // mask could be totally dynamic with only `dispatch` option
          this.compiledMasks = Array.isArray(opts.mask) ? opts.mask.map(function (m) {
            return createMask(m);
          }) : [];
        }
      }
      /**
      @override
       */

    }, {
      key: "_appendCharRaw",
      value: function _appendCharRaw() {
        var details = this._applyDispatch.apply(this, arguments);

        if (this.currentMask) {
          var _this$currentMask;

          details.aggregate((_this$currentMask = this.currentMask)._appendChar.apply(_this$currentMask, arguments));
        }

        return details;
      }
    }, {
      key: "_applyDispatch",
      value: function _applyDispatch() {
        var appended = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
        var flags = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var prevValueBeforeTail = flags.tail && flags._beforeTailState != null ? flags._beforeTailState._value : this.value;
        var inputValue = this.rawInputValue;
        var insertValue = flags.tail && flags._beforeTailState != null ? // $FlowFixMe - tired to fight with type system
        flags._beforeTailState._rawInputValue : inputValue;
        var tailValue = inputValue.slice(insertValue.length);
        var prevMask = this.currentMask;
        var details = new ChangeDetails();
        var prevMaskState = prevMask && prevMask.state; // clone flags to prevent overwriting `_beforeTailState`

        this.currentMask = this.doDispatch(appended, Object.assign({}, flags)); // restore state after dispatch

        if (this.currentMask) {
          if (this.currentMask !== prevMask) {
            // if mask changed reapply input
            this.currentMask.reset(); // $FlowFixMe - it's ok, we don't change current mask above

            var d = this.currentMask.append(insertValue, {
              raw: true
            });
            details.tailShift = d.inserted.length - prevValueBeforeTail.length;

            if (tailValue) {
              // $FlowFixMe - it's ok, we don't change current mask above
              details.tailShift += this.currentMask.append(tailValue, {
                raw: true,
                tail: true
              }).tailShift;
            }
          } else {
            // Dispatch can do something bad with state, so
            // restore prev mask state
            this.currentMask.state = prevMaskState;
          }
        }

        return details;
      }
    }, {
      key: "_appendPlaceholder",
      value: function _appendPlaceholder() {
        var details = this._applyDispatch.apply(this, arguments);

        if (this.currentMask) {
          details.aggregate(this.currentMask._appendPlaceholder());
        }

        return details;
      }
      /**
      @override
       */

    }, {
      key: "doDispatch",
      value: function doDispatch(appended) {
        var flags = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return this.dispatch(appended, this, flags);
      }
      /**
      @override
       */

    }, {
      key: "doValidate",
      value: function doValidate() {
        var _get2, _this$currentMask2;

        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return (_get2 = _get(_getPrototypeOf(MaskedDynamic.prototype), "doValidate", this)).call.apply(_get2, [this].concat(args)) && (!this.currentMask || (_this$currentMask2 = this.currentMask).doValidate.apply(_this$currentMask2, args));
      }
      /**
      @override
       */

    }, {
      key: "reset",
      value: function reset() {
        if (this.currentMask) this.currentMask.reset();
        this.compiledMasks.forEach(function (m) {
          return m.reset();
        });
      }
      /**
      @override
       */

    }, {
      key: "remove",

      /**
      @override
       */
      value: function remove() {
        var details = new ChangeDetails();

        if (this.currentMask) {
          var _this$currentMask3;

          details.aggregate((_this$currentMask3 = this.currentMask).remove.apply(_this$currentMask3, arguments)) // update with dispatch
          .aggregate(this._applyDispatch());
        }

        return details;
      }
      /**
      @override
       */

    }, {
      key: "extractInput",

      /**
      @override
       */
      value: function extractInput() {
        var _this$currentMask4;

        return this.currentMask ? (_this$currentMask4 = this.currentMask).extractInput.apply(_this$currentMask4, arguments) : '';
      }
      /**
      @override
       */

    }, {
      key: "extractTail",
      value: function extractTail() {
        var _this$currentMask5, _get3;

        for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }

        return this.currentMask ? (_this$currentMask5 = this.currentMask).extractTail.apply(_this$currentMask5, args) : (_get3 = _get(_getPrototypeOf(MaskedDynamic.prototype), "extractTail", this)).call.apply(_get3, [this].concat(args));
      }
      /**
      @override
       */

    }, {
      key: "doCommit",
      value: function doCommit() {
        if (this.currentMask) this.currentMask.doCommit();

        _get(_getPrototypeOf(MaskedDynamic.prototype), "doCommit", this).call(this);
      }
      /**
      @override
       */

    }, {
      key: "nearestInputPos",
      value: function nearestInputPos() {
        var _this$currentMask6, _get4;

        for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
          args[_key3] = arguments[_key3];
        }

        return this.currentMask ? (_this$currentMask6 = this.currentMask).nearestInputPos.apply(_this$currentMask6, args) : (_get4 = _get(_getPrototypeOf(MaskedDynamic.prototype), "nearestInputPos", this)).call.apply(_get4, [this].concat(args));
      }
    }, {
      key: "value",
      get: function get() {
        return this.currentMask ? this.currentMask.value : '';
      },
      set: function set(value) {
        _set(_getPrototypeOf(MaskedDynamic.prototype), "value", value, this, true);
      }
      /**
      @override
       */

    }, {
      key: "unmaskedValue",
      get: function get() {
        return this.currentMask ? this.currentMask.unmaskedValue : '';
      },
      set: function set(unmaskedValue) {
        _set(_getPrototypeOf(MaskedDynamic.prototype), "unmaskedValue", unmaskedValue, this, true);
      }
      /**
      @override
       */

    }, {
      key: "typedValue",
      get: function get() {
        return this.currentMask ? this.currentMask.typedValue : '';
      } // probably typedValue should not be used with dynamic
      ,
      set: function set(value) {
        var unmaskedValue = String(value); // double check it

        if (this.currentMask) {
          this.currentMask.typedValue = value;
          unmaskedValue = this.currentMask.unmaskedValue;
        }

        this.unmaskedValue = unmaskedValue;
      }
      /**
      @override
       */

    }, {
      key: "isComplete",
      get: function get() {
        return !!this.currentMask && this.currentMask.isComplete;
      }
    }, {
      key: "state",
      get: function get() {
        return Object.assign({}, _get(_getPrototypeOf(MaskedDynamic.prototype), "state", this), {
          _rawInputValue: this.rawInputValue,
          compiledMasks: this.compiledMasks.map(function (m) {
            return m.state;
          }),
          currentMaskRef: this.currentMask,
          currentMask: this.currentMask && this.currentMask.state
        });
      },
      set: function set(state) {
        var compiledMasks = state.compiledMasks,
            currentMaskRef = state.currentMaskRef,
            currentMask = state.currentMask,
            maskedState = _objectWithoutProperties(state, ["compiledMasks", "currentMaskRef", "currentMask"]);

        this.compiledMasks.forEach(function (m, mi) {
          return m.state = compiledMasks[mi];
        });

        if (currentMaskRef != null) {
          this.currentMask = currentMaskRef;
          this.currentMask.state = currentMask;
        }

        _set(_getPrototypeOf(MaskedDynamic.prototype), "state", maskedState, this, true);
      }
    }, {
      key: "overwrite",
      get: function get() {
        return this.currentMask ? this.currentMask.overwrite : _get(_getPrototypeOf(MaskedDynamic.prototype), "overwrite", this);
      },
      set: function set(overwrite) {
        console.warn('"overwrite" option is not available in dynamic mask, use this option in siblings');
      }
    }]);

    return MaskedDynamic;
  }(Masked);

  MaskedDynamic.DEFAULTS = {
    dispatch: function dispatch(appended, masked, flags) {
      if (!masked.compiledMasks.length) return;
      var inputValue = masked.rawInputValue; // simulate input

      var inputs = masked.compiledMasks.map(function (m, index) {
        m.reset();
        m.append(inputValue, {
          raw: true
        });
        m.append(appended, flags);
        var weight = m.rawInputValue.length;
        return {
          weight: weight,
          index: index
        };
      }); // pop masks with longer values first

      inputs.sort(function (i1, i2) {
        return i2.weight - i1.weight;
      });
      return masked.compiledMasks[inputs[0].index];
    }
  };
  /**
   * Applies mask on element.
   * @constructor
   * @param {HTMLInputElement|HTMLTextAreaElement|MaskElement} el - Element to apply mask
   * @param {Object} opts - Custom mask options
   * @return {InputMask}
   */

  function IMask(el) {
    var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}; // currently available only for input-like elements

    return new InputMask(el, opts);
  }
  /** {@link InputMask} */


  IMask.InputMask = InputMask;
  /** {@link Masked} */

  IMask.Masked = Masked;
  /** {@link MaskedPattern} */

  IMask.MaskedPattern = MaskedPattern;
  /** {@link MaskedEnum} */

  IMask.MaskedEnum = MaskedEnum;
  /** {@link MaskedRange} */

  IMask.MaskedRange = MaskedRange;
  /** {@link MaskedNumber} */

  IMask.MaskedNumber = MaskedNumber;
  /** {@link MaskedDate} */

  IMask.MaskedDate = MaskedDate;
  /** {@link MaskedRegExp} */

  IMask.MaskedRegExp = MaskedRegExp;
  /** {@link MaskedFunction} */

  IMask.MaskedFunction = MaskedFunction;
  /** {@link MaskedDynamic} */

  IMask.MaskedDynamic = MaskedDynamic;
  /** {@link createMask} */

  IMask.createMask = createMask;
  /** {@link MaskElement} */

  IMask.MaskElement = MaskElement;
  /** {@link HTMLMaskElement} */

  IMask.HTMLMaskElement = HTMLMaskElement;
  g.IMask = IMask;
  exports.HTMLMaskElement = HTMLMaskElement;
  exports.InputMask = InputMask;
  exports.MaskElement = MaskElement;
  exports.Masked = Masked;
  exports.MaskedDate = MaskedDate;
  exports.MaskedDynamic = MaskedDynamic;
  exports.MaskedEnum = MaskedEnum;
  exports.MaskedFunction = MaskedFunction;
  exports.MaskedNumber = MaskedNumber;
  exports.MaskedPattern = MaskedPattern;
  exports.MaskedRange = MaskedRange;
  exports.MaskedRegExp = MaskedRegExp;
  exports.createMask = createMask;
  exports["default"] = IMask;
  Object.defineProperty(exports, '__esModule', {
    value: true
  });
});
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/*!
 * Datepicker v1.0.9
 * https://fengyuanchen.github.io/datepicker
 *
 * Copyright 2014-present Chen Fengyuan
 * Released under the MIT license
 *
 * Date: 2019-09-21T06:57:34.100Z
 */
(function (global, factory) {
  (typeof exports === "undefined" ? "undefined" : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(require('jquery')) : typeof define === 'function' && define.amd ? define(['jquery'], factory) : (global = global || self, factory(global.jQuery));
})(this, function ($) {
  'use strict';

  $ = $ && $.hasOwnProperty('default') ? $['default'] : $;

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
  }

  var CHAR = {
    prev: '❮',
    next: '❯'
  };
  var DEFAULTS = {
    // Force Position
    position: null,
    // Show the datepicker automatically when initialized
    autoShow: false,
    // Hide the datepicker automatically when picked
    autoHide: false,
    // Pick the initial date automatically when initialized
    autoPick: false,
    // Enable inline mode
    inline: false,
    // A element (or selector) for putting the datepicker
    container: null,
    // A element (or selector) for triggering the datepicker
    trigger: null,
    // The ISO language code (built-in: en-US)
    language: '',
    // The date string format
    format: 'mm/dd/yyyy',
    // The initial date
    date: null,
    // The start view date
    startDate: null,
    // The end view date
    endDate: null,
    // The start view when initialized
    startView: 0,
    // 0 for days, 1 for months, 2 for years
    // The start day of the week
    // 0 for Sunday, 1 for Monday, 2 for Tuesday, 3 for Wednesday,
    // 4 for Thursday, 5 for Friday, 6 for Saturday
    weekStart: 0,
    // Show year before month on the datepicker header
    yearFirst: false,
    // A string suffix to the year number.
    yearSuffix: '',
    // Days' name of the week.
    days: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
    // Shorter days' name
    daysShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
    // Shortest days' name
    daysMin: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
    // Months' name
    months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
    // Shorter months' name
    monthsShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
    // A element tag for each item of years, months and days
    itemTag: 'li',
    // A class (CSS) for muted date item
    mutedClass: 'muted',
    // A class (CSS) for picked date item
    pickedClass: 'picked',
    // A class (CSS) for disabled date item
    disabledClass: 'disabled',
    // A class (CSS) for highlight date item
    highlightedClass: 'highlighted',
    // The template of the datepicker
    template: '<div class="datepicker-container">' + '<div class="datepicker-panel" data-view="years picker">' + '<ul>' + '<li data-view="years prev">' + CHAR.prev + '</li>' + '<li data-view="years current"></li>' + '<li data-view="years next">' + CHAR.next + '</li>' + '</ul>' + '<ul data-view="years"></ul>' + '</div>' + '<div class="datepicker-panel" data-view="months picker">' + '<ul>' + '<li data-view="year prev">' + CHAR.prev + '</li>' + '<li data-view="year current"></li>' + '<li data-view="year next">' + CHAR.next + '</li>' + '</ul>' + '<ul data-view="months"></ul>' + '</div>' + '<div class="datepicker-panel" data-view="days picker">' + '<ul>' + '<li data-view="month prev">' + CHAR.prev + '</li>' + '<li data-view="month current"></li>' + '<li data-view="month next">' + CHAR.next + '</li>' + '</ul>' + '<ul data-view="week"></ul>' + '<ul data-view="days"></ul>' + '</div>' + '</div>',
    // The offset top or bottom of the datepicker from the element
    offset: 10,
    // The `z-index` of the datepicker
    zIndex: 1000,
    // Filter each date item (return `false` to disable a date item)
    filter: null,
    // Event shortcuts
    show: null,
    hide: null,
    pick: null
  };
  var IS_BROWSER = typeof window !== 'undefined';
  var WINDOW = IS_BROWSER ? window : {};
  var IS_TOUCH_DEVICE = IS_BROWSER ? 'ontouchstart' in WINDOW.document.documentElement : false;
  var NAMESPACE = 'datepicker';
  var EVENT_CLICK = "click.".concat(NAMESPACE);
  var EVENT_FOCUS = "focus.".concat(NAMESPACE);
  var EVENT_HIDE = "hide.".concat(NAMESPACE);
  var EVENT_KEYUP = "keyup.".concat(NAMESPACE);
  var EVENT_PICK = "pick.".concat(NAMESPACE);
  var EVENT_RESIZE = "resize.".concat(NAMESPACE);
  var EVENT_SCROLL = "scroll.".concat(NAMESPACE);
  var EVENT_SHOW = "show.".concat(NAMESPACE);
  var EVENT_TOUCH_START = "touchstart.".concat(NAMESPACE);
  var CLASS_HIDE = "".concat(NAMESPACE, "-hide");
  var LANGUAGES = {};
  var VIEWS = {
    DAYS: 0,
    MONTHS: 1,
    YEARS: 2
  };
  var toString = Object.prototype.toString;

  function typeOf(obj) {
    return toString.call(obj).slice(8, -1).toLowerCase();
  }

  function isString(value) {
    return typeof value === 'string';
  }

  var isNaN = Number.isNaN || WINDOW.isNaN;

  function isNumber(value) {
    return typeof value === 'number' && !isNaN(value);
  }

  function isUndefined(value) {
    return typeof value === 'undefined';
  }

  function isDate(value) {
    return typeOf(value) === 'date' && !isNaN(value.getTime());
  }

  function proxy(fn, context) {
    for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
      args[_key - 2] = arguments[_key];
    }

    return function () {
      for (var _len2 = arguments.length, args2 = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args2[_key2] = arguments[_key2];
      }

      return fn.apply(context, args.concat(args2));
    };
  }

  function selectorOf(view) {
    return "[data-view=\"".concat(view, "\"]");
  }

  function isLeapYear(year) {
    return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
  }

  function getDaysInMonth(year, month) {
    return [31, isLeapYear(year) ? 29 : 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31][month];
  }

  function getMinDay(year, month, day) {
    return Math.min(day, getDaysInMonth(year, month));
  }

  var formatParts = /(y|m|d)+/g;

  function parseFormat(format) {
    var source = String(format).toLowerCase();
    var parts = source.match(formatParts);

    if (!parts || parts.length === 0) {
      throw new Error('Invalid date format.');
    }

    format = {
      source: source,
      parts: parts
    };
    $.each(parts, function (i, part) {
      switch (part) {
        case 'dd':
        case 'd':
          format.hasDay = true;
          break;

        case 'mm':
        case 'm':
          format.hasMonth = true;
          break;

        case 'yyyy':
        case 'yy':
          format.hasYear = true;
          break;

        default:
      }
    });
    return format;
  }

  function getScrollParent(element) {
    var includeHidden = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var $element = $(element);
    var position = $element.css('position');
    var excludeStaticParent = position === 'absolute';
    var overflowRegex = includeHidden ? /auto|scroll|hidden/ : /auto|scroll/;
    var scrollParent = $element.parents().filter(function (index, parent) {
      var $parent = $(parent);

      if (excludeStaticParent && $parent.css('position') === 'static') {
        return false;
      }

      return overflowRegex.test($parent.css('overflow') + $parent.css('overflow-y') + $parent.css('overflow-x'));
    }).eq(0);
    return position === 'fixed' || !scrollParent.length ? $(element.ownerDocument || document) : scrollParent;
  }
  /**
   * Add leading zeroes to the given value
   * @param {number} value - The value to add.
   * @param {number} [length=1] - The expected value length.
   * @returns {string} Returns converted value.
   */


  function addLeadingZero(value) {
    var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    var str = String(Math.abs(value));
    var i = str.length;
    var result = '';

    if (value < 0) {
      result += '-';
    }

    while (i < length) {
      i += 1;
      result += '0';
    }

    return result + str;
  }

  var REGEXP_DIGITS = /\d+/g;
  var methods = {
    // Show the datepicker
    show: function show() {
      if (!this.built) {
        this.build();
      }

      if (this.shown) {
        return;
      }

      if (this.trigger(EVENT_SHOW).isDefaultPrevented()) {
        return;
      }

      this.shown = true;
      this.$picker.removeClass(CLASS_HIDE).on(EVENT_CLICK, $.proxy(this.click, this));
      this.showView(this.options.startView);

      if (!this.inline) {
        //console.warn( this.$scrollParent );
        this.$scrollParent.on(EVENT_SCROLL, $.proxy(this.place, this)); //$('.ph-app').on( EVENT_SCROLL, $.proxy( this.place, this ) );

        $(window).on(EVENT_RESIZE, this.onResize = proxy(this.place, this));
        $(document).on(EVENT_CLICK, this.onGlobalClick = proxy(this.globalClick, this));
        $(document).on(EVENT_KEYUP, this.onGlobalKeyup = proxy(this.globalKeyup, this));

        if (IS_TOUCH_DEVICE) {
          $(document).on(EVENT_TOUCH_START, this.onTouchStart = proxy(this.touchstart, this));
        }

        this.place();
      }
    },
    // Hide the datepicker
    hide: function hide() {
      //console.warn('hide');
      if (!this.shown) {
        return;
      }

      if (this.trigger(EVENT_HIDE).isDefaultPrevented()) {
        return;
      }

      this.shown = false;
      this.$picker.addClass(CLASS_HIDE).off(EVENT_CLICK, this.click);

      if (!this.inline) {
        this.$scrollParent.off(EVENT_SCROLL, this.place);
        $(window).off(EVENT_RESIZE, this.onResize);
        $(document).off(EVENT_CLICK, this.onGlobalClick);
        $(document).off(EVENT_KEYUP, this.onGlobalKeyup);

        if (IS_TOUCH_DEVICE) {
          $(document).off(EVENT_TOUCH_START, this.onTouchStart);
        }
      }
    },
    toggle: function toggle() {
      if (this.shown) {
        this.hide();
      } else {
        this.show();
      }
    },
    // Update the datepicker with the current input value
    update: function update() {
      var value = this.getValue();

      if (value === this.oldValue) {
        return;
      }

      this.setDate(value, true);
      this.oldValue = value;
    },

    /**
     * Pick the current date to the element
     *
     * @param {String} _view (private)
     */
    pick: function pick(_view) {
      var $this = this.$element;
      var date = this.date;

      if (this.trigger(EVENT_PICK, {
        view: _view || '',
        date: date
      }).isDefaultPrevented()) {
        return;
      }

      date = this.formatDate(this.date);
      this.setValue(date);

      if (this.isInput) {
        $this.trigger('input');
        $this.trigger('change');
      }
    },
    // Reset the datepicker
    reset: function reset() {
      this.setDate(this.initialDate, true);
      this.setValue(this.initialValue);

      if (this.shown) {
        this.showView(this.options.startView);
      }
    },

    /**
     * Get the month name with given argument or the current date
     *
     * @param {Number} month (optional)
     * @param {Boolean} shortForm (optional)
     * @return {String} (month name)
     */
    getMonthName: function getMonthName(month, shortForm) {
      var options = this.options;
      var monthsShort = options.monthsShort;
      var months = options.months;

      if ($.isNumeric(month)) {
        month = Number(month);
      } else if (isUndefined(shortForm)) {
        shortForm = month;
      }

      if (shortForm === true) {
        months = monthsShort;
      }

      return months[isNumber(month) ? month : this.date.getMonth()];
    },

    /**
     * Get the day name with given argument or the current date
     *
     * @param {Number} day (optional)
     * @param {Boolean} shortForm (optional)
     * @param {Boolean} min (optional)
     * @return {String} (day name)
     */
    getDayName: function getDayName(day, shortForm, min) {
      var options = this.options;
      var days = options.days;

      if ($.isNumeric(day)) {
        day = Number(day);
      } else {
        if (isUndefined(min)) {
          min = shortForm;
        }

        if (isUndefined(shortForm)) {
          shortForm = day;
        }
      }

      if (min) {
        days = options.daysMin;
      } else if (shortForm) {
        days = options.daysShort;
      }

      return days[isNumber(day) ? day : this.date.getDay()];
    },

    /**
     * Get the current date
     *
     * @param {Boolean} formatted (optional)
     * @return {Date|String} (date)
     */
    getDate: function getDate(formatted) {
      var date = this.date;
      return formatted ? this.formatDate(date) : new Date(date);
    },

    /**
     * Set the current date with a new date
     *
     * @param {Date} date
     * @param {Boolean} _updated (private)
     */
    setDate: function setDate(date, _updated) {
      var filter = this.options.filter;

      if (isDate(date) || isString(date)) {
        date = this.parseDate(date);

        if ($.isFunction(filter) && filter.call(this.$element, date, 'day') === false) {
          return;
        }

        this.date = date;
        this.viewDate = new Date(date);

        if (!_updated) {
          this.pick();
        }

        if (this.built) {
          this.render();
        }
      }
    },

    /**
     * Set the start view date with a new date
     *
     * @param {Date|string|null} date
     */
    setStartDate: function setStartDate(date) {
      if (isDate(date) || isString(date)) {
        this.startDate = this.parseDate(date);
      } else {
        this.startDate = null;
      }

      if (this.built) {
        this.render();
      }
    },

    /**
     * Set the end view date with a new date
     *
     * @param {Date|string|null} date
     */
    setEndDate: function setEndDate(date) {
      if (isDate(date) || isString(date)) {
        this.endDate = this.parseDate(date);
      } else {
        this.endDate = null;
      }

      if (this.built) {
        this.render();
      }
    },

    /**
     * Parse a date string with the set date format
     *
     * @param {String} date
     * @return {Date} (parsed date)
     */
    parseDate: function parseDate(date) {
      var format = this.format;
      var parts = [];

      if (!isDate(date)) {
        if (isString(date)) {
          parts = date.match(REGEXP_DIGITS) || [];
        }

        date = date ? new Date(date) : new Date();

        if (!isDate(date)) {
          date = new Date();
        }

        if (parts.length === format.parts.length) {
          // Set year and month first
          $.each(parts, function (i, part) {
            var value = parseInt(part, 10);

            switch (format.parts[i]) {
              case 'yy':
                date.setFullYear(2000 + value);
                break;

              case 'yyyy':
                // Converts 2-digit year to 2000+
                date.setFullYear(part.length === 2 ? 2000 + value : value);
                break;

              case 'mm':
              case 'm':
                date.setMonth(value - 1);
                break;

              default:
            }
          }); // Set day in the last to avoid converting `31/10/2019` to `01/10/2019`

          $.each(parts, function (i, part) {
            var value = parseInt(part, 10);

            switch (format.parts[i]) {
              case 'dd':
              case 'd':
                date.setDate(value);
                break;

              default:
            }
          });
        }
      } // Ignore hours, minutes, seconds and milliseconds to avoid side effect (#192)


      return new Date(date.getFullYear(), date.getMonth(), date.getDate());
    },

    /**
     * Format a date object to a string with the set date format
     *
     * @param {Date} date
     * @return {String} (formatted date)
     */
    formatDate: function formatDate(date) {
      var format = this.format;
      var formatted = '';

      if (isDate(date)) {
        var year = date.getFullYear();
        var month = date.getMonth();
        var day = date.getDate();
        var values = {
          d: day,
          dd: addLeadingZero(day, 2),
          m: month + 1,
          mm: addLeadingZero(month + 1, 2),
          yy: String(year).substring(2),
          yyyy: addLeadingZero(year, 4)
        };
        formatted = format.source;
        $.each(format.parts, function (i, part) {
          formatted = formatted.replace(part, values[part]);
        });
      }

      return formatted;
    },
    // Destroy the datepicker and remove the instance from the target element
    destroy: function destroy() {
      this.unbind();
      this.unbuild();
      this.$element.removeData(NAMESPACE);
    }
  };
  var handlers = {
    click: function click(e) {
      var $target = $(e.target);
      var options = this.options,
          date = this.date,
          viewDate = this.viewDate,
          format = this.format;
      e.stopPropagation();
      e.preventDefault();

      if ($target.hasClass('disabled')) {
        return;
      }

      var view = $target.data('view');
      var viewYear = viewDate.getFullYear();
      var viewMonth = viewDate.getMonth();
      var viewDay = viewDate.getDate();

      switch (view) {
        case 'years prev':
        case 'years next':
          {
            viewYear = view === 'years prev' ? viewYear - 10 : viewYear + 10;
            viewDate.setFullYear(viewYear);
            viewDate.setDate(getMinDay(viewYear, viewMonth, viewDay));
            this.renderYears();
            break;
          }

        case 'year prev':
        case 'year next':
          viewYear = view === 'year prev' ? viewYear - 1 : viewYear + 1;
          viewDate.setFullYear(viewYear);
          viewDate.setDate(getMinDay(viewYear, viewMonth, viewDay));
          this.renderMonths();
          break;

        case 'year current':
          if (format.hasYear) {
            this.showView(VIEWS.YEARS);
          }

          break;

        case 'year picked':
          if (format.hasMonth) {
            this.showView(VIEWS.MONTHS);
          } else {
            $target.siblings(".".concat(options.pickedClass)).removeClass(options.pickedClass).data('view', 'year');
            this.hideView();
          }

          this.pick('year');
          break;

        case 'year':
          viewYear = parseInt($target.text(), 10); // Set date first to avoid month changing (#195)

          date.setDate(getMinDay(viewYear, viewMonth, viewDay));
          date.setFullYear(viewYear);
          viewDate.setDate(getMinDay(viewYear, viewMonth, viewDay));
          viewDate.setFullYear(viewYear);

          if (format.hasMonth) {
            this.showView(VIEWS.MONTHS);
          } else {
            $target.addClass(options.pickedClass).data('view', 'year picked').siblings(".".concat(options.pickedClass)).removeClass(options.pickedClass).data('view', 'year');
            this.hideView();
          }

          this.pick('year');
          break;

        case 'month prev':
        case 'month next':
          viewMonth = view === 'month prev' ? viewMonth - 1 : viewMonth + 1;

          if (viewMonth < 0) {
            viewYear -= 1;
            viewMonth += 12;
          } else if (viewMonth > 11) {
            viewYear += 1;
            viewMonth -= 12;
          }

          viewDate.setFullYear(viewYear);
          viewDate.setDate(getMinDay(viewYear, viewMonth, viewDay));
          viewDate.setMonth(viewMonth);
          this.renderDays();
          break;

        case 'month current':
          if (format.hasMonth) {
            this.showView(VIEWS.MONTHS);
          }

          break;

        case 'month picked':
          if (format.hasDay) {
            this.showView(VIEWS.DAYS);
          } else {
            $target.siblings(".".concat(options.pickedClass)).removeClass(options.pickedClass).data('view', 'month');
            this.hideView();
          }

          this.pick('month');
          break;

        case 'month':
          viewMonth = $.inArray($target.text(), options.monthsShort);
          date.setFullYear(viewYear); // Set date before month to avoid month changing (#195)

          date.setDate(getMinDay(viewYear, viewMonth, viewDay));
          date.setMonth(viewMonth);
          viewDate.setFullYear(viewYear);
          viewDate.setDate(getMinDay(viewYear, viewMonth, viewDay));
          viewDate.setMonth(viewMonth);

          if (format.hasDay) {
            this.showView(VIEWS.DAYS);
          } else {
            $target.addClass(options.pickedClass).data('view', 'month picked').siblings(".".concat(options.pickedClass)).removeClass(options.pickedClass).data('view', 'month');
            this.hideView();
          }

          this.pick('month');
          break;

        case 'day prev':
        case 'day next':
        case 'day':
          if (view === 'day prev') {
            viewMonth -= 1;
          } else if (view === 'day next') {
            viewMonth += 1;
          }

          viewDay = parseInt($target.text(), 10); // Set date to 1 to avoid month changing (#195)

          date.setDate(1);
          date.setFullYear(viewYear);
          date.setMonth(viewMonth);
          date.setDate(viewDay);
          viewDate.setDate(1);
          viewDate.setFullYear(viewYear);
          viewDate.setMonth(viewMonth);
          viewDate.setDate(viewDay);
          this.renderDays();

          if (view === 'day') {
            this.hideView();
          }

          this.pick('day');
          break;

        case 'day picked':
          this.hideView();
          this.pick('day');
          break;

        default:
      }
    },
    globalClick: function globalClick(_ref) {
      var target = _ref.target;
      var element = this.element,
          $trigger = this.$trigger;
      var trigger = $trigger[0];
      var hidden = true;

      while (target !== document) {
        if (target === trigger || target === element) {
          hidden = false;
          break;
        }

        target = target.parentNode;
      }

      if (hidden) {
        this.hide();
      }
    },
    keyup: function keyup() {
      this.update();
    },
    globalKeyup: function globalKeyup(_ref2) {
      var target = _ref2.target,
          key = _ref2.key,
          keyCode = _ref2.keyCode;

      if (this.isInput && target !== this.element && this.shown && (key === 'Tab' || keyCode === 9)) {
        this.hide();
      }
    },
    touchstart: function touchstart(_ref3) {
      var target = _ref3.target; // Emulate click in touch devices to support hiding the picker automatically (#197).

      if (this.isInput && target !== this.element && !$.contains(this.$picker[0], target)) {
        this.hide();
        this.element.blur();
      }
    }
  };
  var render = {
    render: function render() {
      this.renderYears();
      this.renderMonths();
      this.renderDays();
    },
    renderWeek: function renderWeek() {
      var _this = this;

      var items = [];
      var _this$options = this.options,
          weekStart = _this$options.weekStart,
          daysMin = _this$options.daysMin;
      weekStart = parseInt(weekStart, 10) % 7;
      daysMin = daysMin.slice(weekStart).concat(daysMin.slice(0, weekStart));
      $.each(daysMin, function (i, day) {
        items.push(_this.createItem({
          text: day
        }));
      });
      this.$week.html(items.join(''));
    },
    renderYears: function renderYears() {
      var options = this.options,
          startDate = this.startDate,
          endDate = this.endDate;
      var disabledClass = options.disabledClass,
          noeventsClass = options.disabledClass + '-noevents',
          filter = options.filter,
          yearSuffix = options.yearSuffix;
      var viewYear = this.viewDate.getFullYear();
      var now = new Date();
      var thisYear = now.getFullYear();
      var year = this.date.getFullYear();
      var start = -5;
      var end = 6;
      var items = [];
      var prevDisabled = false;
      var nextDisabled = false;
      var i;

      for (i = start; i <= end; i += 1) {
        var date = new Date(viewYear + i, 1, 1);
        var disabled = false;

        if (startDate) {
          disabled = date.getFullYear() < startDate.getFullYear();

          if (i === start) {
            prevDisabled = disabled;
          }
        }

        if (!disabled && endDate) {
          disabled = date.getFullYear() > endDate.getFullYear();

          if (i === end) {
            nextDisabled = disabled;
          }
        }

        if (!disabled && filter) {
          disabled = filter.call(this.$element, date, 'year') === false;
        }

        var picked = viewYear + i === year;
        var view = picked ? 'year picked' : 'year';
        items.push(this.createItem({
          picked: picked,
          disabled: disabled,
          text: viewYear + i,
          view: disabled ? 'year disabled' : view,
          highlighted: date.getFullYear() === thisYear
        }));
      }

      this.$yearsPrev.toggleClass(disabledClass, prevDisabled);
      this.$yearsNext.toggleClass(disabledClass, nextDisabled); //this.$yearsCurrent.toggleClass( disabledClass, true ).html( "".concat( viewYear + start + yearSuffix, " - " ).concat( viewYear + end ).concat( yearSuffix ) );

      this.$yearsCurrent.toggleClass(disabledClass, true).html("".concat(viewYear + start + yearSuffix, " - ").concat(viewYear + end).concat(yearSuffix));
      this.$years.html(items.join(''));
    },
    renderMonths: function renderMonths() {
      var options = this.options,
          startDate = this.startDate,
          endDate = this.endDate,
          viewDate = this.viewDate;
      var disabledClass = options.disabledClass || '';
      var months = options.monthsShort;
      var filter = $.isFunction(options.filter) && options.filter;
      var viewYear = viewDate.getFullYear();
      var now = new Date();
      var thisYear = now.getFullYear();
      var thisMonth = now.getMonth();
      var year = this.date.getFullYear();
      var month = this.date.getMonth();
      var items = [];
      var prevDisabled = false;
      var nextDisabled = false;
      var i;

      for (i = 0; i <= 11; i += 1) {
        var date = new Date(viewYear, i, 1);
        var disabled = false;

        if (startDate) {
          prevDisabled = date.getFullYear() === startDate.getFullYear();
          disabled = prevDisabled && date.getMonth() < startDate.getMonth();
        }

        if (!disabled && endDate) {
          nextDisabled = date.getFullYear() === endDate.getFullYear();
          disabled = nextDisabled && date.getMonth() > endDate.getMonth();
        }

        if (!disabled && filter) {
          disabled = filter.call(this.$element, date, 'month') === false;
        }

        var picked = viewYear === year && i === month;
        var view = picked ? 'month picked' : 'month';
        items.push(this.createItem({
          disabled: disabled,
          picked: picked,
          highlighted: viewYear === thisYear && date.getMonth() === thisMonth,
          index: i,
          text: months[i],
          view: disabled ? 'month disabled' : view
        }));
      }

      this.$yearPrev.toggleClass(disabledClass, prevDisabled);
      this.$yearNext.toggleClass(disabledClass, nextDisabled);
      this.$yearCurrent.toggleClass(disabledClass, prevDisabled && nextDisabled).html(viewYear + options.yearSuffix || '');
      this.$months.html(items.join(''));
    },
    renderDays: function renderDays() {
      var $element = this.$element,
          options = this.options,
          startDate = this.startDate,
          endDate = this.endDate,
          viewDate = this.viewDate,
          currentDate = this.date;
      var disabledClass = options.disabledClass,
          filter = options.filter,
          months = options.months,
          weekStart = options.weekStart,
          yearSuffix = options.yearSuffix;
      var viewYear = viewDate.getFullYear();
      var viewMonth = viewDate.getMonth();
      var now = new Date();
      var thisYear = now.getFullYear();
      var thisMonth = now.getMonth();
      var thisDay = now.getDate();
      var year = currentDate.getFullYear();
      var month = currentDate.getMonth();
      var day = currentDate.getDate();
      var length;
      var i;
      var n; // Days of prev month
      // -----------------------------------------------------------------------

      var prevItems = [];
      var prevViewYear = viewYear;
      var prevViewMonth = viewMonth;
      var prevDisabled = false;

      if (viewMonth === 0) {
        prevViewYear -= 1;
        prevViewMonth = 11;
      } else {
        prevViewMonth -= 1;
      } // The length of the days of prev month


      length = getDaysInMonth(prevViewYear, prevViewMonth); // The first day of current month

      var firstDay = new Date(viewYear, viewMonth, 1); // The visible length of the days of prev month
      // [0,1,2,3,4,5,6] - [0,1,2,3,4,5,6] => [-6,-5,-4,-3,-2,-1,0,1,2,3,4,5,6]

      n = firstDay.getDay() - parseInt(weekStart, 10) % 7; // [-6,-5,-4,-3,-2,-1,0,1,2,3,4,5,6] => [1,2,3,4,5,6,7]

      if (n <= 0) {
        n += 7;
      }

      if (startDate) {
        prevDisabled = firstDay.getTime() <= startDate.getTime();
      }

      for (i = length - (n - 1); i <= length; i += 1) {
        var prevViewDate = new Date(prevViewYear, prevViewMonth, i);
        var disabled = false;

        if (startDate) {
          disabled = prevViewDate.getTime() < startDate.getTime();
        }

        if (!disabled && filter) {
          disabled = filter.call($element, prevViewDate, 'day') === false;
        }

        prevItems.push(this.createItem({
          disabled: disabled,
          highlighted: prevViewYear === thisYear && prevViewMonth === thisMonth && prevViewDate.getDate() === thisDay,
          muted: true,
          picked: prevViewYear === year && prevViewMonth === month && i === day,
          text: i,
          view: 'day prev'
        }));
      } // Days of next month
      // -----------------------------------------------------------------------


      var nextItems = [];
      var nextViewYear = viewYear;
      var nextViewMonth = viewMonth;
      var nextDisabled = false;

      if (viewMonth === 11) {
        nextViewYear += 1;
        nextViewMonth = 0;
      } else {
        nextViewMonth += 1;
      } // The length of the days of current month


      length = getDaysInMonth(viewYear, viewMonth); // The visible length of next month (42 means 6 rows and 7 columns)

      n = 42 - (prevItems.length + length); // The last day of current month

      var lastDate = new Date(viewYear, viewMonth, length);

      if (endDate) {
        nextDisabled = lastDate.getTime() >= endDate.getTime();
      }

      for (i = 1; i <= n; i += 1) {
        var date = new Date(nextViewYear, nextViewMonth, i);
        var picked = nextViewYear === year && nextViewMonth === month && i === day;
        var _disabled = false;

        if (endDate) {
          _disabled = date.getTime() > endDate.getTime();
        }

        if (!_disabled && filter) {
          _disabled = filter.call($element, date, 'day') === false;
        }

        nextItems.push(this.createItem({
          disabled: _disabled,
          picked: picked,
          highlighted: nextViewYear === thisYear && nextViewMonth === thisMonth && date.getDate() === thisDay,
          muted: true,
          text: i,
          view: 'day next'
        }));
      } // Days of current month
      // -----------------------------------------------------------------------


      var items = [];

      for (i = 1; i <= length; i += 1) {
        var _date = new Date(viewYear, viewMonth, i);

        var _disabled2 = false;

        if (startDate) {
          _disabled2 = _date.getTime() < startDate.getTime();
        }

        if (!_disabled2 && endDate) {
          _disabled2 = _date.getTime() > endDate.getTime();
        }

        if (!_disabled2 && filter) {
          _disabled2 = filter.call($element, _date, 'day') === false;
        }

        var _picked = viewYear === year && viewMonth === month && i === day;

        var view = _picked ? 'day picked' : 'day';
        items.push(this.createItem({
          disabled: _disabled2,
          picked: _picked,
          highlighted: viewYear === thisYear && viewMonth === thisMonth && _date.getDate() === thisDay,
          text: i,
          view: _disabled2 ? 'day disabled' : view
        }));
      } // Render days picker
      // -----------------------------------------------------------------------


      this.$monthPrev.toggleClass(disabledClass, prevDisabled);
      this.$monthNext.toggleClass(disabledClass, nextDisabled);
      this.$monthCurrent.toggleClass(disabledClass, prevDisabled && nextDisabled).html(options.yearFirst ? "".concat(viewYear + yearSuffix, " ").concat(months[viewMonth]) : "".concat(months[viewMonth], " ").concat(viewYear).concat(yearSuffix));
      this.$days.html(prevItems.join('') + items.join('') + nextItems.join(''));
    }
  };
  var CLASS_TOP_LEFT = "".concat(NAMESPACE, "-top-left");
  var CLASS_TOP_RIGHT = "".concat(NAMESPACE, "-top-right");
  var CLASS_BOTTOM_LEFT = "".concat(NAMESPACE, "-bottom-left");
  var CLASS_BOTTOM_RIGHT = "".concat(NAMESPACE, "-bottom-right");
  var CLASS_PLACEMENTS = [CLASS_TOP_LEFT, CLASS_TOP_RIGHT, CLASS_BOTTOM_LEFT, CLASS_BOTTOM_RIGHT].join(' ');

  var Datepicker =
  /*#__PURE__*/
  function () {
    function Datepicker(element) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      _classCallCheck(this, Datepicker);

      this.$element = $(element);
      this.element = element;
      this.options = $.extend({}, DEFAULTS, LANGUAGES[options.language], $.isPlainObject(options) && options);
      this.$scrollParent = getScrollParent(element, true);
      this.built = false;
      this.shown = false;
      this.isInput = false;
      this.inline = false;
      this.initialValue = '';
      this.initialDate = null;
      this.startDate = null;
      this.endDate = null;
      this.init();
    }

    _createClass(Datepicker, [{
      key: "init",
      value: function init() {
        var $this = this.$element,
            options = this.options;
        var startDate = options.startDate,
            endDate = options.endDate,
            date = options.date;
        this.$trigger = $(options.trigger);
        this.isInput = $this.is('input') || $this.is('textarea');
        this.inline = options.inline && (options.container || !this.isInput);
        this.format = parseFormat(options.format);
        var initialValue = this.getValue();
        this.initialValue = initialValue;
        this.oldValue = initialValue;
        date = this.parseDate(date || initialValue);

        if (startDate) {
          startDate = this.parseDate(startDate);

          if (date.getTime() < startDate.getTime()) {
            date = new Date(startDate);
          }

          this.startDate = startDate;
        }

        if (endDate) {
          endDate = this.parseDate(endDate);

          if (startDate && endDate.getTime() < startDate.getTime()) {
            endDate = new Date(startDate);
          }

          if (date.getTime() > endDate.getTime()) {
            date = new Date(endDate);
          }

          this.endDate = endDate;
        }

        this.date = date;
        this.viewDate = new Date(date);
        this.initialDate = new Date(this.date);
        this.bind();

        if (options.autoShow || this.inline) {
          this.show();
        }

        if (options.autoPick) {
          this.pick();
        }
      }
    }, {
      key: "build",
      value: function build() {
        if (this.built) {
          return;
        }

        this.built = true;
        var $this = this.$element,
            options = this.options;
        var $picker = $(options.template);
        this.$picker = $picker;
        this.$week = $picker.find(selectorOf('week')); // Years view

        this.$yearsPicker = $picker.find(selectorOf('years picker'));
        this.$yearsPrev = $picker.find(selectorOf('years prev'));
        this.$yearsNext = $picker.find(selectorOf('years next'));
        this.$yearsCurrent = $picker.find(selectorOf('years current'));
        this.$years = $picker.find(selectorOf('years')); // Months view

        this.$monthsPicker = $picker.find(selectorOf('months picker'));
        this.$yearPrev = $picker.find(selectorOf('year prev'));
        this.$yearNext = $picker.find(selectorOf('year next'));
        this.$yearCurrent = $picker.find(selectorOf('year current'));
        this.$months = $picker.find(selectorOf('months')); // Days view

        this.$daysPicker = $picker.find(selectorOf('days picker'));
        this.$monthPrev = $picker.find(selectorOf('month prev'));
        this.$monthNext = $picker.find(selectorOf('month next'));
        this.$monthCurrent = $picker.find(selectorOf('month current'));
        this.$days = $picker.find(selectorOf('days'));

        if (this.inline) {
          $(options.container || $this).append($picker.addClass("".concat(NAMESPACE, "-inline")));
        } else {
          $(document.body).append($picker.addClass("".concat(NAMESPACE, "-dropdown")));
          $picker.addClass(CLASS_HIDE).css({
            zIndex: parseInt(options.zIndex, 10)
          });
        }

        this.renderWeek();
      }
    }, {
      key: "unbuild",
      value: function unbuild() {
        if (!this.built) {
          return;
        }

        this.built = false;
        this.$picker.remove();
      }
    }, {
      key: "bind",
      value: function bind() {
        var options = this.options,
            $this = this.$element;

        if ($.isFunction(options.show)) {
          $this.on(EVENT_SHOW, options.show);
        }

        if ($.isFunction(options.hide)) {
          $this.on(EVENT_HIDE, options.hide);
        }

        if ($.isFunction(options.pick)) {
          $this.on(EVENT_PICK, options.pick);
        }

        if (this.isInput) {
          $this.on(EVENT_KEYUP, $.proxy(this.keyup, this));
        }

        if (!this.inline) {
          if (options.trigger) {
            this.$trigger.on(EVENT_CLICK, $.proxy(this.toggle, this));
          } else if (this.isInput) {
            $this.on(EVENT_FOCUS, $.proxy(this.show, this));
          } else {
            $this.on(EVENT_CLICK, $.proxy(this.show, this));
          }
        }
      }
    }, {
      key: "unbind",
      value: function unbind() {
        var $this = this.$element,
            options = this.options;

        if ($.isFunction(options.show)) {
          $this.off(EVENT_SHOW, options.show);
        }

        if ($.isFunction(options.hide)) {
          $this.off(EVENT_HIDE, options.hide);
        }

        if ($.isFunction(options.pick)) {
          $this.off(EVENT_PICK, options.pick);
        }

        if (this.isInput) {
          $this.off(EVENT_KEYUP, this.keyup);
        }

        if (!this.inline) {
          if (options.trigger) {
            this.$trigger.off(EVENT_CLICK, this.toggle);
          } else if (this.isInput) {
            $this.off(EVENT_FOCUS, this.show);
          } else {
            $this.off(EVENT_CLICK, this.show);
          }
        }
      }
    }, {
      key: "showView",
      value: function showView(view) {
        var $yearsPicker = this.$yearsPicker,
            $monthsPicker = this.$monthsPicker,
            $daysPicker = this.$daysPicker,
            format = this.format;

        if (format.hasYear || format.hasMonth || format.hasDay) {
          switch (Number(view)) {
            case VIEWS.YEARS:
              $monthsPicker.addClass(CLASS_HIDE);
              $daysPicker.addClass(CLASS_HIDE);

              if (format.hasYear) {
                this.renderYears();
                $yearsPicker.removeClass(CLASS_HIDE);
                this.place();
              } else {
                this.showView(VIEWS.DAYS);
              }

              break;

            case VIEWS.MONTHS:
              $yearsPicker.addClass(CLASS_HIDE);
              $daysPicker.addClass(CLASS_HIDE);

              if (format.hasMonth) {
                this.renderMonths();
                $monthsPicker.removeClass(CLASS_HIDE);
                this.place();
              } else {
                this.showView(VIEWS.YEARS);
              }

              break;
            // case VIEWS.DAYS:

            default:
              $yearsPicker.addClass(CLASS_HIDE);
              $monthsPicker.addClass(CLASS_HIDE);

              if (format.hasDay) {
                this.renderDays();
                $daysPicker.removeClass(CLASS_HIDE);
                this.place();
              } else {
                this.showView(VIEWS.MONTHS);
              }

          }
        }
      }
    }, {
      key: "hideView",
      value: function hideView() {
        if (!this.inline && this.options.autoHide) {
          this.hide();
        }
      }
    }, {
      key: "place",
      value: function place() {
        if (this.inline) {
          return;
        }

        var $this = this.$element,
            options = this.options,
            $picker = this.$picker;
        var containerWidth = $(document).outerWidth();
        var containerHeight = $(document).outerHeight();
        var elementWidth = $this.outerWidth();
        var elementHeight = $this.outerHeight();
        var width = $picker.width();
        var height = $picker.height();

        var _$this$offset = $this.offset(),
            left = _$this$offset.left,
            top = _$this$offset.top;

        var offset = parseFloat(options.offset);
        var placement = CLASS_TOP_LEFT;

        if (isNaN(offset)) {
          offset = 10;
        }

        if (options.position) {
          placement = "".concat(NAMESPACE, "-", options.position);
        }

        if (!options.position && top > height && top + elementHeight + height > containerHeight || options.position === 'bottom-left' || options.position === 'bottom-right') {
          top -= height + offset;
          placement = CLASS_BOTTOM_LEFT;
        } else {
          top += elementHeight + offset;
        }

        if (left + width > containerWidth) {
          left += elementWidth - width;
          placement = placement.replace('left', 'right');
        }

        $picker.removeClass(CLASS_PLACEMENTS).addClass(placement).css({
          top: top,
          left: left
        });
      } // A shortcut for triggering custom events

    }, {
      key: "trigger",
      value: function trigger(type, data) {
        var e = $.Event(type, data);
        this.$element.trigger(e);
        return e;
      }
    }, {
      key: "createItem",
      value: function createItem(data) {
        var options = this.options;
        var itemTag = options.itemTag;
        var item = {
          text: '',
          view: '',
          muted: false,
          picked: false,
          disabled: false,
          highlighted: false
        };
        var classes = [];
        $.extend(item, data);

        if (item.muted) {
          classes.push(options.mutedClass);
        }

        if (item.highlighted) {
          classes.push(options.highlightedClass);
        }

        if (item.picked) {
          classes.push(options.pickedClass);
        }

        if (item.disabled) {
          classes.push(options.disabledClass);
        }

        return "<".concat(itemTag, " class=\"").concat(classes.join(' '), "\" data-view=\"").concat(item.view, "\">").concat(item.text, "</").concat(itemTag, ">");
      }
    }, {
      key: "getValue",
      value: function getValue() {
        var $this = this.$element;
        return this.isInput ? $this.val() : $this.text();
      }
    }, {
      key: "setValue",
      value: function setValue() {
        var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
        var $this = this.$element;

        if (this.isInput) {
          $this.val(value);
        } else if (!this.inline || this.options.container) {
          $this.text(value);
        }
      }
    }], [{
      key: "setDefaults",
      value: function setDefaults() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        $.extend(DEFAULTS, LANGUAGES[options.language], $.isPlainObject(options) && options);
      }
    }]);

    return Datepicker;
  }();

  if ($.extend) {
    $.extend(Datepicker.prototype, render, handlers, methods);
  }

  if ($.fn) {
    var AnotherDatepicker = $.fn.datepicker;

    $.fn.datepicker = function jQueryDatepicker(option) {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      var result;
      this.each(function (i, element) {
        var $element = $(element);
        var isDestroy = option === 'destroy';
        var datepicker = $element.data(NAMESPACE);

        if (!datepicker) {
          if (isDestroy) {
            return;
          }

          var options = $.extend({}, $element.data(), $.isPlainObject(option) && option);
          datepicker = new Datepicker(element, options);
          $element.data(NAMESPACE, datepicker);
        }

        if (isString(option)) {
          var fn = datepicker[option];

          if ($.isFunction(fn)) {
            result = fn.apply(datepicker, args);

            if (isDestroy) {
              $element.removeData(NAMESPACE);
            }
          }
        }
      });
      return !isUndefined(result) ? result : this;
    };

    $.fn.datepicker.Constructor = Datepicker;
    $.fn.datepicker.languages = LANGUAGES;
    $.fn.datepicker.setDefaults = Datepicker.setDefaults;

    $.fn.datepicker.noConflict = function noConflict() {
      $.fn.datepicker = AnotherDatepicker;
      return this;
    };
  }

  $.fn.datepicker.languages['ru-RU'] = {
    format: 'dd.mm.YYYY',
    days: ['Воскресенье', 'Понедельник', 'Вторник', 'Среда', 'Четверг', 'Пятница', 'Суббота'],
    daysShort: ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
    daysMin: ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
    months: ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'],
    monthsShort: ['Янв', 'Фев', 'Мар', 'Апр', 'Май', 'Июн', 'Июл', 'Авг', 'Сен', 'Окт', 'Ноя', 'Дек'],
    weekStart: 1,
    startView: 0,
    yearFirst: false,
    yearSuffix: ''
  };
  $.fn.datepicker.languages['en-US'] = {
    format: 'mm/dd/yyyy'
  };
});
/*!
 * LABELAUTY jQuery Plugin
 *
 * @file: jquery-labelauty.js
 * @author: Francisco Neves (@fntneves)
 * @site: www.francisconeves.com
 * @license: MIT License
 */
(function ($) {
  $.fn.labelauty = function (options) {
    /*
     * Our default settings
     * Hope you don't need to change anything, with these settings
     */
    var settings = $.extend({
      // Development Mode - This will activate console debug messages
      development: false,
      // Trigger Class - This class will be used to apply styles
      "class": 'labelauty',
      extra_class: '',
      // Use icon? If false, then only a text label represents the input
      icon: true,
      // Use text label? If false, then only an icon represents the input
      label: true,
      // Separator between labels' messages - If you use this separator for anything, choose a new one
      separator: '|',
      // Default Checked Message - This message will be visible when input is checked
      checked_label: 'Checked',
      // Default UnChecked Message - This message will be visible when input is unchecked
      unchecked_label: 'Unchecked',
      // Force random - ID's Replace original ID's with random ID's,
      force_random_id: false,
      // Minimum Label Width - This value will be used to apply a minimum width to the text labels
      minimum_width: false,
      // Use the greatest width between two text labels ? If this has a true value, then label width will be the greatest between labels
      same_width: true
    }, options);
    /*
     * Let's create the core function
     * It will try to cover all settings and mistakes of using
     */

    return this.each(function () {
      var $object = $(this),
          selected = $object.is(':checked'),
          type = $object.attr('type');
      var use_icons = true,
          use_labels = true,
          labels,
          labels_object,
          input_id; //Get the aria label from the input element

      var aria_label = $object.attr("aria-label"); // Hide the object form screen readers

      $object.attr("aria-hidden", '1'); // Test if object is a check input
      // Don't mess me up, come on

      if ($object.is(":checkbox") === false && $object.is(":radio") === false) {
        return this;
      } // Add "labelauty" class to all checkboxes
      // So you can apply some custom styles


      $object.addClass(settings["class"]);
      $object.addClass(settings["extra_class"]);
      $object.addClass($object.is(":checkbox") ? 'is-checkbox' : ''); // Get the value of "data-labelauty" attribute
      // Then, we have the labels for each case (or not, as we will see)

      labels = $object.attr("data-labelauty") ? $object.attr("data-labelauty") : $object.attr("title");
      use_labels = settings.label;
      use_icons = settings.icon; // It's time to check if it's going to the right way
      // Null values, more labels than expected or no labels will be handled here

      if (use_labels === true) {
        if (labels == null || labels.length === 0) {
          // If attribute has no label and we want to use, then use the default labels
          labels_object = [settings.unchecked_label, settings.checked_label];
        } else {
          // Ok, ok, it's time to split Checked and Unchecked labels
          // We split, by the "settings.separator" option
          labels_object = labels.split(settings.separator); // Now, let's check if exist _only_ two labels
          // If there's more than two, then we do not use labels :(
          // Else, do some additional tests

          if (labels_object.length > 2) {
            use_labels = false; //debug( settings.development, "There's more than two labels. LABELAUTY will not use labels." );
          } else {
            // If there's just one label (no split by "settings.separator"), it will be used for both cases
            // Here, we have the possibility of use the same label for both cases
            if (labels_object.length === 1) {//debug( settings.development, "There's just one label. LABELAUTY will use this one for both cases." );
            }
          }
        }
      }
      /*
       * Let's begin the beauty
       */
      // Start hiding ugly checkboxes
      // Obviously, we don't need native checkboxes :O


      $object.css({
        display: "none"
      }); // We don't need more data-labelauty attributes!
      // Ok, ok, it's just for beauty improvement

      $object.removeAttr("data-labelauty"); // Now, grab checkbox ID Attribute for "label" tag use
      // If there's no ID Attribute, then generate a new one

      input_id = $object.attr("id");

      if (settings.force_random_id || input_id == null || input_id.trim() === "") {
        var input_id_number = 1 + Math.floor(Math.random() * 1024000);
        input_id = "labelauty-" + input_id_number; // Is there any element with this random ID ?
        // If exists, then increment until get an unused ID

        while ($(input_id).length !== 0) {
          input_id_number++;
          input_id = "labelauty-" + input_id_number; //debug( settings.development, "Trying again." );
        }

        $object.attr("id", input_id);
      } // Now, add necessary tags to make this work
      // Here, we're going to test some control variables and act properly


      var element = jQuery(create(input_id, aria_label, selected, type, labels_object, use_labels, use_icons, settings.extra_class));
      element.on('click', function () {
        if ($object.is(':checked')) {
          $(element).attr('aria-checked', '');
        } else {
          $(element).attr('aria-checked', '1');
        }
      });
      element.on('keypress', function (event) {
        event.preventDefault();

        if (event.keyCode === 32 || event.keyCode === 13) {
          if ($object.is(':checked')) {
            $object.prop('checked', false);
            $(element).attr('aria-checked', '');
          } else {
            $object.prop('checked', true);
            $(element).attr('aria-checked', '');
          }
        }
      });
      $object.after(element); // Now, add "min-width" to label
      // Let's say the truth, a fixed width is more beautiful than a variable width

      if (settings.minimum_width !== false) {
        $object.next("label[for=" + input_id + "]").css({
          "min-width": settings.minimum_width
        });
      } // Now, add "min-width" to label
      // Let's say the truth, a fixed width is more beautiful than a variable width


      if (settings.same_width !== false && settings.label === true) {
        var label_object = $object.next("label[for=" + input_id + "]"),
            unchecked_width = getRealWidth(label_object.find("span.labelauty-unchecked")),
            checked_width = getRealWidth(label_object.find("span.labelauty-checked"));

        if (unchecked_width > checked_width) {
          label_object.find("span.labelauty-checked").width(unchecked_width);
        } else {
          label_object.find("span.labelauty-unchecked").width(checked_width);
        }
      }
    });
  };
  /*
   * Tricky code to work with hidden elements, like tabs.
   * Note: This code is based on jquery.actual plugin.
   * https://github.com/dreamerslab/jquery.actual
   */


  function getRealWidth(element) {
    var width,
        $target = element,
        css_class = 'offset2calcwidth';
    $target = $target.clone().attr('class', css_class).appendTo('body');
    width = $target.width(true);
    $target.remove();
    return width;
  }

  function debug(debug, message) {
    if (debug && window.console && window.console.log) {//window.console.log( "jQuery-LABELAUTY: " + message );
    }
  }

  function create(input_id, aria_label, selected, type, messages_object, label, icon, extra_class) {
    var block, unchecked_message, checked_message, aria;

    if (messages_object == null) {
      unchecked_message = checked_message = "";
    } else {
      unchecked_message = messages_object[0]; // If checked message is null, then put the same text of unchecked message

      if (messages_object[1] == null) {
        checked_message = unchecked_message;
      } else {
        checked_message = messages_object[1];
      }
    }

    if (aria_label == null) {
      aria = "";
    } else {
      aria = 'tabindex="0" role="' + type + '" aria-checked="' + selected + '" aria-label="' + aria_label + '"';
    }

    if (extra_class == null) {
      extra_class = "";
    } else {
      extra_class = ' class="' + extra_class + '" ';
    }

    if (label === true && icon === true) {
      block = '<label' + extra_class + 'for="' + input_id + '" ' + aria + (' data-ctrl-type="' + type + '" ') + '>' + '<span class="labelauty-unchecked-image"></span>' + '<span class="labelauty-unchecked">' + unchecked_message + '</span>' + '<span class="labelauty-checked-image"></span>' + '<span class="labelauty-checked">' + checked_message + '</span>' + '</label>';
    } else if (label === true) {
      block = '<label' + extra_class + 'for="' + input_id + '" ' + aria + (' data-ctrl-type="' + type + '" ') + '>' + '<span class="labelauty-unchecked">' + unchecked_message + '</span>' + '<span class="labelauty-checked">' + checked_message + '</span>' + '</label>';
    } else {
      block = '<label' + extra_class + 'for="' + input_id + '" ' + aria + (' data-ctrl-type="' + type + '" ') + '>' + '<span class="labelauty-unchecked-image"></span>' + '<span class="labelauty-checked-image"></span>' + '</label>';
    }

    return block;
  }
})(jQuery);
/*  jQuery Nice Select - v1.1.0
    https://github.com/hernansartorio/jquery-nice-select
    Made by Hernán Sartorio  */
(function ($) {
  $.fn.niceSelect = function (method) {
    // Methods
    if (typeof method == 'string') {
      if (method === 'update') {
        this.each(function () {
          var $select = $(this);
          var $dropdown = $(this).next('.nice-select');
          var open = $dropdown.hasClass('open');

          if ($dropdown.length) {
            $dropdown.remove();
            create_nice_select($select);

            if (open) {
              $select.next().trigger('click');
            }
          }
        });
      } else if (method === 'destroy') {
        this.each(function () {
          var $select = $(this);
          var $dropdown = $(this).next('.nice-select');

          if ($dropdown.length) {
            $dropdown.remove();
            $select.css('display', '');
          }
        });

        if ($('.nice-select').length === 0) {
          $(document).off('.nice_select');
        }
      } else {}

      return this;
    } // Hide native select


    this.hide(); // Create custom markup

    this.each(function () {
      var $select = $(this);

      if (!$select.next().hasClass('nice-select')) {
        create_nice_select($select);
      }
    });

    function create_nice_select($select) {
      $select.after($('<div></div>').addClass('nice-select').addClass($select.attr('class') || '').addClass($select.attr('disabled') ? 'disabled' : '').attr('tabindex', $select.attr('disabled') ? null : '1').html('<span class="current"></span><ul class="list"></ul>'));
      var $dropdown = $select.next();
      var $options = $select.find('option');
      $options.each(function (i) {
        var $option = $(this),
            display = $option.data('display'),
            className = $option.prop('class'),
            extra = $option.data('extra');
        var $option_text = $option.text();
        $option_text = $option_text.replace(/\((\d*)\)/g, '<span class="counter">$1</span>');
        $dropdown.find('ul').append($('<li></li>').attr('data-value', $option.val()).attr('data-display', display || null).attr('data-extra', extra || null).prop('class', className).addClass('option' + ($option.is(':selected') ? ' selected' : '') + ($option.is(':disabled') ? ' disabled' : '')).html('<span class="option-label">' + $option_text + '</span>'));
      });
      var $selected = $select.find('option:selected');
      var $selected_text = $selected.length ? $selected.html().replace(/\(([1-9]\d*)\)/g, '<span class="counter">$1</span>') : '';
      $dropdown.find('.current').html($selected.data('display') || '<span class="current-label">' + $selected_text + '</span>');
    }
    /* Event listeners */
    // Unbind existing events in case that the plugin has been initialized before


    $(document).off('.nice_select'); // Open/close

    $(document).on('click.nice_select', '.nice-select', function (event) {
      var $dropdown = $(this);
      $('.nice-select').not($dropdown).removeClass('open');
      $dropdown.toggleClass('open');

      if ($dropdown.hasClass('open')) {
        $dropdown.find('.option');
        $dropdown.find('.focus').removeClass('focus');
        $dropdown.find('.selected').addClass('focus');
      } else {
        $dropdown.focus();
      }
    }); // Close when clicking outside

    $(document).on('click.nice_select', function (event) {
      if ($(event.target).closest('.nice-select').length === 0) {
        $('.nice-select').removeClass('open').find('.option');
      }
    }); // Option click

    $(document).on('click.nice_select', '.nice-select .option:not(.disabled)', function (event) {
      var $option = $(this);
      var $dropdown = $option.closest('.nice-select');
      $dropdown.find('.selected').removeClass('selected');
      $option.addClass('selected');
      var text = $option.data('display') || $option.html();
      text = text.replace(/\(([1-9]\d*)\)/g, '<span class="counter">$1</span>');
      $dropdown.find('.current').html('<span class="current-label">' + text + '</span>');
      $dropdown.prev('select').val($option.data('value')).trigger('change');
    }); // Keyboard events

    $(document).on('keydown.nice_select', '.nice-select', function (event) {
      var $dropdown = $(this);
      var $focused_option = $($dropdown.find('.focus') || $dropdown.find('.list .option.selected')); // Space or Enter

      if (event.keyCode === 32 || event.keyCode === 13) {
        if ($dropdown.hasClass('open')) {
          $focused_option.trigger('click');
        } else {
          $dropdown.trigger('click');
        }

        return false; // Down
      } else if (event.keyCode === 40) {
        if (!$dropdown.hasClass('open')) {
          $dropdown.trigger('click');
        } else {
          var $next = $focused_option.nextAll('.option:not(.disabled)').first();

          if ($next.length > 0) {
            $dropdown.find('.focus').removeClass('focus');
            $next.addClass('focus');
          }
        }

        return false; // Up
      } else if (event.keyCode === 38) {
        if (!$dropdown.hasClass('open')) {
          $dropdown.trigger('click');
        } else {
          var $prev = $focused_option.prevAll('.option:not(.disabled)').first();

          if ($prev.length > 0) {
            $dropdown.find('.focus').removeClass('focus');
            $prev.addClass('focus');
          }
        }

        return false; // Esc
      } else if (event.keyCode === 27) {
        if ($dropdown.hasClass('open')) {
          $dropdown.trigger('click');
        } // Tab

      } else if (event.keyCode === 9) {
        if ($dropdown.hasClass('open')) {
          return false;
        }
      }
    }); // Detect CSS pointer-events support, for IE <= 10. From Modernizr.

    var style = document.createElement('a').style;
    style.cssText = 'pointer-events:auto';

    if (style.pointerEvents !== 'auto') {
      $('html').addClass('no-csspointerevents');
    }

    return this;
  };
})(jQuery);
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

// Ion.RangeSlider
// version 2.3.0 Build: 381
// © Denis Ineshin, 2018
// https://github.com/IonDen
//
// Project page:    http://ionden.com/a/plugins/ion.rangeSlider/en.html
// GitHub page:     https://github.com/IonDen/ion.rangeSlider
//
// Released under MIT licence:
// http://ionden.com/a/plugins/licence-en.html
// =====================================================================================================================
;

(function (factory) {
  if (!jQuery && typeof define === "function" && define.amd) {
    define(["jquery"], function (jQuery) {
      return factory(jQuery, document, window, navigator);
    });
  } else if (!jQuery && (typeof exports === "undefined" ? "undefined" : _typeof(exports)) === "object") {
    factory(require("jquery"), document, window, navigator);
  } else {
    factory(jQuery, document, window, navigator);
  }
})(function ($, document, window, navigator, undefined) {
  "use strict"; // =================================================================================================================
  // Service

  var plugin_count = 0; // IE8 fix

  var is_old_ie = function () {
    var n = navigator.userAgent,
        r = /msie\s\d+/i,
        v;

    if (n.search(r) > 0) {
      v = r.exec(n).toString();
      v = v.split(" ")[1];

      if (v < 9) {
        $("html").addClass("lt-ie9");
        return true;
      }
    }

    return false;
  }();

  if (!Function.prototype.bind) {
    Function.prototype.bind = function bind(that) {
      var target = this;
      var slice = [].slice;

      if (typeof target != "function") {
        throw new TypeError();
      }

      var args = slice.call(arguments, 1),
          bound = function bound() {
        if (this instanceof bound) {
          var F = function F() {};

          F.prototype = target.prototype;
          var self = new F();
          var result = target.apply(self, args.concat(slice.call(arguments)));

          if (Object(result) === result) {
            return result;
          }

          return self;
        } else {
          return target.apply(that, args.concat(slice.call(arguments)));
        }
      };

      return bound;
    };
  }

  if (!Array.prototype.indexOf) {
    Array.prototype.indexOf = function (searchElement, fromIndex) {
      var k;

      if (this == null) {
        throw new TypeError('"this" is null or not defined');
      }

      var O = Object(this);
      var len = O.length >>> 0;

      if (len === 0) {
        return -1;
      }

      var n = +fromIndex || 0;

      if (Math.abs(n) === Infinity) {
        n = 0;
      }

      if (n >= len) {
        return -1;
      }

      k = Math.max(n >= 0 ? n : len - Math.abs(n), 0);

      while (k < len) {
        if (k in O && O[k] === searchElement) {
          return k;
        }

        k++;
      }

      return -1;
    };
  } // =================================================================================================================
  // Template


  var base_html = '<span class="irs">' + '<span class="irs-line" tabindex="0"></span>' + '<span class="irs-min">0</span><span class="irs-max">1</span>' + '<span class="irs-from">0</span><span class="irs-to">0</span><span class="irs-single">0</span>' + '</span>' + '<span class="irs-grid"></span>';
  var single_html = '<span class="irs-bar irs-bar--single"></span>' + '<span class="irs-shadow shadow-single"></span>' + '<span class="irs-handle single"><i></i><i></i><i></i></span>';
  var double_html = '<span class="irs-bar"></span>' + '<span class="irs-shadow shadow-from"></span>' + '<span class="irs-shadow shadow-to"></span>' + '<span class="irs-handle from"><i></i><i></i><i></i></span>' + '<span class="irs-handle to"><i></i><i></i><i></i></span>';
  var disable_html = '<span class="irs-disable-mask"></span>'; // =================================================================================================================
  // Core

  /**
   * Main plugin constructor
   *
   * @param input {Object} link to base input element
   * @param options {Object} slider config
   * @param plugin_count {Number}
   * @constructor
   */

  var IonRangeSlider = function IonRangeSlider(input, options, plugin_count) {
    this.VERSION = "2.3.0";
    this.input = input;
    this.plugin_count = plugin_count;
    this.current_plugin = 0;
    this.calc_count = 0;
    this.update_tm = 0;
    this.old_from = 0;
    this.old_to = 0;
    this.old_min_interval = null;
    this.raf_id = null;
    this.dragging = false;
    this.force_redraw = false;
    this.no_diapason = false;
    this.has_tab_index = true;
    this.is_key = false;
    this.is_update = false;
    this.is_start = true;
    this.is_finish = false;
    this.is_active = false;
    this.is_resize = false;
    this.is_click = false;
    options = options || {}; // cache for links to all DOM elements

    this.$cache = {
      win: $(window),
      body: $(document.body),
      input: $(input),
      cont: null,
      rs: null,
      min: null,
      max: null,
      from: null,
      to: null,
      single: null,
      bar: null,
      line: null,
      s_single: null,
      s_from: null,
      s_to: null,
      shad_single: null,
      shad_from: null,
      shad_to: null,
      edge: null,
      grid: null,
      grid_labels: []
    }; // storage for measure variables

    this.coords = {
      // left
      x_gap: 0,
      x_pointer: 0,
      // width
      w_rs: 0,
      w_rs_old: 0,
      w_handle: 0,
      // percents
      p_gap: 0,
      p_gap_left: 0,
      p_gap_right: 0,
      p_step: 0,
      p_pointer: 0,
      p_handle: 0,
      p_single_fake: 0,
      p_single_real: 0,
      p_from_fake: 0,
      p_from_real: 0,
      p_to_fake: 0,
      p_to_real: 0,
      p_bar_x: 0,
      p_bar_w: 0,
      // grid
      grid_gap: 0,
      big_num: 0,
      big: [],
      big_w: [],
      big_p: [],
      big_x: []
    }; // storage for labels measure variables

    this.labels = {
      // width
      w_min: 0,
      w_max: 0,
      w_from: 0,
      w_to: 0,
      w_single: 0,
      // percents
      p_min: 0,
      p_max: 0,
      p_from_fake: 0,
      p_from_left: 0,
      p_to_fake: 0,
      p_to_left: 0,
      p_single_fake: 0,
      p_single_left: 0
    };
    /**
     * get and validate config
     */

    var $inp = this.$cache.input,
        val = $inp.prop("value"),
        config,
        config_from_data,
        prop; // default config

    config = {
      skin: "flat",
      type: "single",
      min: 10,
      max: 100,
      from: null,
      to: null,
      step: 1,
      min_interval: 0,
      max_interval: 0,
      drag_interval: false,
      values: [],
      p_values: [],
      from_fixed: false,
      from_min: null,
      from_max: null,
      from_shadow: false,
      to_fixed: false,
      to_min: null,
      to_max: null,
      to_shadow: false,
      prettify_enabled: true,
      prettify_separator: " ",
      prettify: null,
      force_edges: false,
      keyboard: true,
      grid: false,
      grid_margin: true,
      grid_num: 4,
      grid_snap: false,
      hide_min_max: false,
      hide_from_to: false,
      prefix: "",
      postfix: "",
      max_postfix: "",
      decorate_both: true,
      values_separator: " — ",
      input_values_separator: ";",
      disable: false,
      block: false,
      extra_classes: "",
      scope: null,
      onStart: null,
      onChange: null,
      onFinish: null,
      onUpdate: null
    }; // check if base element is input

    if ($inp[0].nodeName !== "INPUT") {
      console && console.warn && console.warn("Base element should be <input>!", $inp[0]);
    } // config from data-attributes extends js config


    config_from_data = {
      skin: $inp.data("skin"),
      type: $inp.data("type"),
      min: $inp.data("min"),
      max: $inp.data("max"),
      from: $inp.data("from"),
      to: $inp.data("to"),
      step: $inp.data("step"),
      min_interval: $inp.data("minInterval"),
      max_interval: $inp.data("maxInterval"),
      drag_interval: $inp.data("dragInterval"),
      values: $inp.data("values"),
      from_fixed: $inp.data("fromFixed"),
      from_min: $inp.data("fromMin"),
      from_max: $inp.data("fromMax"),
      from_shadow: $inp.data("fromShadow"),
      to_fixed: $inp.data("toFixed"),
      to_min: $inp.data("toMin"),
      to_max: $inp.data("toMax"),
      to_shadow: $inp.data("toShadow"),
      prettify_enabled: $inp.data("prettifyEnabled"),
      prettify_separator: $inp.data("prettifySeparator"),
      force_edges: $inp.data("forceEdges"),
      keyboard: $inp.data("keyboard"),
      grid: $inp.data("grid"),
      grid_margin: $inp.data("gridMargin"),
      grid_num: $inp.data("gridNum"),
      grid_snap: $inp.data("gridSnap"),
      hide_min_max: $inp.data("hideMinMax"),
      hide_from_to: $inp.data("hideFromTo"),
      prefix: $inp.data("prefix"),
      postfix: $inp.data("postfix"),
      max_postfix: $inp.data("maxPostfix"),
      decorate_both: $inp.data("decorateBoth"),
      values_separator: $inp.data("valuesSeparator"),
      input_values_separator: $inp.data("inputValuesSeparator"),
      disable: $inp.data("disable"),
      block: $inp.data("block"),
      extra_classes: $inp.data("extraClasses")
    };
    config_from_data.values = config_from_data.values && config_from_data.values.split(",");

    for (prop in config_from_data) {
      if (config_from_data.hasOwnProperty(prop)) {
        if (config_from_data[prop] === undefined || config_from_data[prop] === "") {
          delete config_from_data[prop];
        }
      }
    } // input value extends default config


    if (val !== undefined && val !== "") {
      val = val.split(config_from_data.input_values_separator || options.input_values_separator || ";");

      if (val[0] && val[0] == +val[0]) {
        val[0] = +val[0];
      }

      if (val[1] && val[1] == +val[1]) {
        val[1] = +val[1];
      }

      if (options && options.values && options.values.length) {
        config.from = val[0] && options.values.indexOf(val[0]);
        config.to = val[1] && options.values.indexOf(val[1]);
      } else {
        config.from = val[0] && +val[0];
        config.to = val[1] && +val[1];
      }
    } // js config extends default config


    $.extend(config, options); // data config extends config

    $.extend(config, config_from_data);
    this.options = config; // validate config, to be sure that all data types are correct

    this.update_check = {};
    this.validate(); // default result object, returned to callbacks

    this.result = {
      input: this.$cache.input,
      slider: null,
      min: this.options.min,
      max: this.options.max,
      from: this.options.from,
      from_percent: 0,
      from_value: null,
      to: this.options.to,
      to_percent: 0,
      to_value: null
    };
    this.init();
  };

  IonRangeSlider.prototype = {
    /**
     * Starts or updates the plugin instance
     *
     * @param [is_update] {boolean}
     */
    init: function init(is_update) {
      this.no_diapason = false;
      this.coords.p_step = this.convertToPercent(this.options.step, true);
      this.target = "base";
      this.toggleInput();
      this.append();
      this.setMinMax();

      if (is_update) {
        this.force_redraw = true;
        this.calc(true); // callbacks called

        this.callOnUpdate();
      } else {
        this.force_redraw = true;
        this.calc(true); // callbacks called

        this.callOnStart();
      }

      this.updateScene();
    },

    /**
     * Appends slider template to a DOM
     */
    append: function append() {
      var container_html = '<span class="irs irs--' + this.options.skin + ' js-irs-' + this.plugin_count + ' ' + this.options.extra_classes + '"></span>';
      this.$cache.input.before(container_html);
      this.$cache.input.prop("readonly", true);
      this.$cache.cont = this.$cache.input.prev();
      this.result.slider = this.$cache.cont;
      this.$cache.cont.html(base_html);
      this.$cache.rs = this.$cache.cont.find(".irs");
      this.$cache.min = this.$cache.cont.find(".irs-min");
      this.$cache.max = this.$cache.cont.find(".irs-max");
      this.$cache.from = this.$cache.cont.find(".irs-from");
      this.$cache.to = this.$cache.cont.find(".irs-to");
      this.$cache.single = this.$cache.cont.find(".irs-single");
      this.$cache.line = this.$cache.cont.find(".irs-line");
      this.$cache.grid = this.$cache.cont.find(".irs-grid");

      if (this.options.type === "single") {
        this.$cache.cont.append(single_html);
        this.$cache.bar = this.$cache.cont.find(".irs-bar");
        this.$cache.edge = this.$cache.cont.find(".irs-bar-edge");
        this.$cache.s_single = this.$cache.cont.find(".single");
        this.$cache.from[0].style.visibility = "hidden";
        this.$cache.to[0].style.visibility = "hidden";
        this.$cache.shad_single = this.$cache.cont.find(".shadow-single");
      } else {
        this.$cache.cont.append(double_html);
        this.$cache.bar = this.$cache.cont.find(".irs-bar");
        this.$cache.s_from = this.$cache.cont.find(".from");
        this.$cache.s_to = this.$cache.cont.find(".to");
        this.$cache.shad_from = this.$cache.cont.find(".shadow-from");
        this.$cache.shad_to = this.$cache.cont.find(".shadow-to");
        this.setTopHandler();
      }

      if (this.options.hide_from_to) {
        this.$cache.from[0].style.display = "none";
        this.$cache.to[0].style.display = "none";
        this.$cache.single[0].style.display = "none";
      }

      this.appendGrid();

      if (this.options.disable) {
        this.appendDisableMask();
        this.$cache.input[0].disabled = true;
      } else {
        this.$cache.input[0].disabled = false;
        this.removeDisableMask();
        this.bindEvents();
      } // block only if not disabled


      if (!this.options.disable) {
        if (this.options.block) {
          this.appendDisableMask();
        } else {
          this.removeDisableMask();
        }
      }

      if (this.options.drag_interval) {
        this.$cache.bar[0].style.cursor = "ew-resize";
      }
    },

    /**
     * Determine which handler has a priority
     * works only for double slider type
     */
    setTopHandler: function setTopHandler() {
      var min = this.options.min,
          max = this.options.max,
          from = this.options.from,
          to = this.options.to;

      if (from > min && to === max) {
        this.$cache.s_from.addClass("type_last");
      } else if (to < max) {
        this.$cache.s_to.addClass("type_last");
      }
    },

    /**
     * Determine which handles was clicked last
     * and which handler should have hover effect
     *
     * @param target {String}
     */
    changeLevel: function changeLevel(target) {
      switch (target) {
        case "single":
          this.coords.p_gap = this.toFixed(this.coords.p_pointer - this.coords.p_single_fake);
          this.$cache.s_single.addClass("state_hover");
          break;

        case "from":
          this.coords.p_gap = this.toFixed(this.coords.p_pointer - this.coords.p_from_fake);
          this.$cache.s_from.addClass("state_hover");
          this.$cache.s_from.addClass("type_last");
          this.$cache.s_to.removeClass("type_last");
          break;

        case "to":
          this.coords.p_gap = this.toFixed(this.coords.p_pointer - this.coords.p_to_fake);
          this.$cache.s_to.addClass("state_hover");
          this.$cache.s_to.addClass("type_last");
          this.$cache.s_from.removeClass("type_last");
          break;

        case "both":
          this.coords.p_gap_left = this.toFixed(this.coords.p_pointer - this.coords.p_from_fake);
          this.coords.p_gap_right = this.toFixed(this.coords.p_to_fake - this.coords.p_pointer);
          this.$cache.s_to.removeClass("type_last");
          this.$cache.s_from.removeClass("type_last");
          break;
      }
    },

    /**
     * Then slider is disabled
     * appends extra layer with opacity
     */
    appendDisableMask: function appendDisableMask() {
      this.$cache.cont.append(disable_html);
      this.$cache.cont.addClass("irs-disabled");
    },

    /**
     * Then slider is not disabled
     * remove disable mask
     */
    removeDisableMask: function removeDisableMask() {
      this.$cache.cont.remove(".irs-disable-mask");
      this.$cache.cont.removeClass("irs-disabled");
    },

    /**
     * Remove slider instance
     * and unbind all events
     */
    remove: function remove() {
      this.$cache.cont.remove();
      this.$cache.cont = null;
      this.$cache.line.off("keydown.irs_" + this.plugin_count);
      this.$cache.body.off("touchmove.irs_" + this.plugin_count);
      this.$cache.body.off("mousemove.irs_" + this.plugin_count);
      this.$cache.win.off("touchend.irs_" + this.plugin_count);
      this.$cache.win.off("mouseup.irs_" + this.plugin_count);

      if (is_old_ie) {
        this.$cache.body.off("mouseup.irs_" + this.plugin_count);
        this.$cache.body.off("mouseleave.irs_" + this.plugin_count);
      }

      this.$cache.grid_labels = [];
      this.coords.big = [];
      this.coords.big_w = [];
      this.coords.big_p = [];
      this.coords.big_x = [];
      cancelAnimationFrame(this.raf_id);
    },

    /**
     * bind all slider events
     */
    bindEvents: function bindEvents() {
      if (this.no_diapason) {
        return;
      }

      this.$cache.body.on("touchmove.irs_" + this.plugin_count, this.pointerMove.bind(this));
      this.$cache.body.on("mousemove.irs_" + this.plugin_count, this.pointerMove.bind(this));
      this.$cache.win.on("touchend.irs_" + this.plugin_count, this.pointerUp.bind(this));
      this.$cache.win.on("mouseup.irs_" + this.plugin_count, this.pointerUp.bind(this));
      this.$cache.line.on("touchstart.irs_" + this.plugin_count, this.pointerClick.bind(this, "click"));
      this.$cache.line.on("mousedown.irs_" + this.plugin_count, this.pointerClick.bind(this, "click"));
      this.$cache.line.on("focus.irs_" + this.plugin_count, this.pointerFocus.bind(this));

      if (this.options.drag_interval && this.options.type === "double") {
        this.$cache.bar.on("touchstart.irs_" + this.plugin_count, this.pointerDown.bind(this, "both"));
        this.$cache.bar.on("mousedown.irs_" + this.plugin_count, this.pointerDown.bind(this, "both"));
      } else {
        this.$cache.bar.on("touchstart.irs_" + this.plugin_count, this.pointerClick.bind(this, "click"));
        this.$cache.bar.on("mousedown.irs_" + this.plugin_count, this.pointerClick.bind(this, "click"));
      }

      if (this.options.type === "single") {
        this.$cache.single.on("touchstart.irs_" + this.plugin_count, this.pointerDown.bind(this, "single"));
        this.$cache.s_single.on("touchstart.irs_" + this.plugin_count, this.pointerDown.bind(this, "single"));
        this.$cache.shad_single.on("touchstart.irs_" + this.plugin_count, this.pointerClick.bind(this, "click"));
        this.$cache.single.on("mousedown.irs_" + this.plugin_count, this.pointerDown.bind(this, "single"));
        this.$cache.s_single.on("mousedown.irs_" + this.plugin_count, this.pointerDown.bind(this, "single"));
        this.$cache.edge.on("mousedown.irs_" + this.plugin_count, this.pointerClick.bind(this, "click"));
        this.$cache.shad_single.on("mousedown.irs_" + this.plugin_count, this.pointerClick.bind(this, "click"));
      } else {
        this.$cache.single.on("touchstart.irs_" + this.plugin_count, this.pointerDown.bind(this, null));
        this.$cache.single.on("mousedown.irs_" + this.plugin_count, this.pointerDown.bind(this, null));
        this.$cache.from.on("touchstart.irs_" + this.plugin_count, this.pointerDown.bind(this, "from"));
        this.$cache.s_from.on("touchstart.irs_" + this.plugin_count, this.pointerDown.bind(this, "from"));
        this.$cache.to.on("touchstart.irs_" + this.plugin_count, this.pointerDown.bind(this, "to"));
        this.$cache.s_to.on("touchstart.irs_" + this.plugin_count, this.pointerDown.bind(this, "to"));
        this.$cache.shad_from.on("touchstart.irs_" + this.plugin_count, this.pointerClick.bind(this, "click"));
        this.$cache.shad_to.on("touchstart.irs_" + this.plugin_count, this.pointerClick.bind(this, "click"));
        this.$cache.from.on("mousedown.irs_" + this.plugin_count, this.pointerDown.bind(this, "from"));
        this.$cache.s_from.on("mousedown.irs_" + this.plugin_count, this.pointerDown.bind(this, "from"));
        this.$cache.to.on("mousedown.irs_" + this.plugin_count, this.pointerDown.bind(this, "to"));
        this.$cache.s_to.on("mousedown.irs_" + this.plugin_count, this.pointerDown.bind(this, "to"));
        this.$cache.shad_from.on("mousedown.irs_" + this.plugin_count, this.pointerClick.bind(this, "click"));
        this.$cache.shad_to.on("mousedown.irs_" + this.plugin_count, this.pointerClick.bind(this, "click"));
      }

      if (this.options.keyboard) {
        this.$cache.line.on("keydown.irs_" + this.plugin_count, this.key.bind(this, "keyboard"));
      }

      if (is_old_ie) {
        this.$cache.body.on("mouseup.irs_" + this.plugin_count, this.pointerUp.bind(this));
        this.$cache.body.on("mouseleave.irs_" + this.plugin_count, this.pointerUp.bind(this));
      }
    },

    /**
     * Focus with tabIndex
     *
     * @param e {Object} event object
     */
    pointerFocus: function pointerFocus(e) {
      if (!this.target) {
        var x;
        var $handle;

        if (this.options.type === "single") {
          $handle = this.$cache.single;
        } else {
          $handle = this.$cache.from;
        }

        x = $handle.offset().left;
        x += $handle.width() / 2 - 1;
        this.pointerClick("single", {
          preventDefault: function preventDefault() {},
          pageX: x
        });
      }
    },

    /**
     * Mousemove or touchmove
     * only for handlers
     *
     * @param e {Object} event object
     */
    pointerMove: function pointerMove(e) {
      if (!this.dragging) {
        return;
      }

      var x = e.pageX || e.originalEvent.touches && e.originalEvent.touches[0].pageX;
      this.coords.x_pointer = x - this.coords.x_gap;
      this.calc();
    },

    /**
     * Mouseup or touchend
     * only for handlers
     *
     * @param e {Object} event object
     */
    pointerUp: function pointerUp(e) {
      if (this.current_plugin !== this.plugin_count) {
        return;
      }

      if (this.is_active) {
        this.is_active = false;
      } else {
        return;
      }

      this.$cache.cont.find(".state_hover").removeClass("state_hover");
      this.force_redraw = true;

      if (is_old_ie) {
        $("*").prop("unselectable", false);
      }

      this.updateScene();
      this.restoreOriginalMinInterval(); // callbacks call

      if ($.contains(this.$cache.cont[0], e.target) || this.dragging) {
        this.callOnFinish();
      }

      this.dragging = false;
    },

    /**
     * Mousedown or touchstart
     * only for handlers
     *
     * @param target {String|null}
     * @param e {Object} event object
     */
    pointerDown: function pointerDown(target, e) {
      e.preventDefault();
      var x = e.pageX || e.originalEvent.touches && e.originalEvent.touches[0].pageX;

      if (e.button === 2) {
        return;
      }

      if (target === "both") {
        this.setTempMinInterval();
      }

      if (!target) {
        target = this.target || "from";
      }

      this.current_plugin = this.plugin_count;
      this.target = target;
      this.is_active = true;
      this.dragging = true;
      this.coords.x_gap = this.$cache.rs.offset().left;
      this.coords.x_pointer = x - this.coords.x_gap;
      this.calcPointerPercent();
      this.changeLevel(target);

      if (is_old_ie) {
        $("*").prop("unselectable", true);
      }

      this.$cache.line.trigger("focus");
      this.updateScene();
    },

    /**
     * Mousedown or touchstart
     * for other slider elements, like diapason line
     *
     * @param target {String}
     * @param e {Object} event object
     */
    pointerClick: function pointerClick(target, e) {
      e.preventDefault();
      var x = e.pageX || e.originalEvent.touches && e.originalEvent.touches[0].pageX;

      if (e.button === 2) {
        return;
      }

      this.current_plugin = this.plugin_count;
      this.target = target;
      this.is_click = true;
      this.coords.x_gap = this.$cache.rs.offset().left;
      this.coords.x_pointer = +(x - this.coords.x_gap).toFixed();
      this.force_redraw = true;
      this.calc();
      this.$cache.line.trigger("focus");
    },

    /**
     * Keyborard controls for focused slider
     *
     * @param target {String}
     * @param e {Object} event object
     * @returns {boolean|undefined}
     */
    key: function key(target, e) {
      if (this.current_plugin !== this.plugin_count || e.altKey || e.ctrlKey || e.shiftKey || e.metaKey) {
        return;
      }

      switch (e.which) {
        case 83: // W

        case 65: // A

        case 40: // DOWN

        case 37:
          // LEFT
          e.preventDefault();
          this.moveByKey(false);
          break;

        case 87: // S

        case 68: // D

        case 38: // UP

        case 39:
          // RIGHT
          e.preventDefault();
          this.moveByKey(true);
          break;
      }

      return true;
    },

    /**
     * Move by key
     *
     * @param right {boolean} direction to move
     */
    moveByKey: function moveByKey(right) {
      var p = this.coords.p_pointer;
      var p_step = (this.options.max - this.options.min) / 100;
      p_step = this.options.step / p_step;

      if (right) {
        p += p_step;
      } else {
        p -= p_step;
      }

      this.coords.x_pointer = this.toFixed(this.coords.w_rs / 100 * p);
      this.is_key = true;
      this.calc();
    },

    /**
     * Set visibility and content
     * of Min and Max labels
     */
    setMinMax: function setMinMax() {
      if (!this.options) {
        return;
      }

      if (this.options.hide_min_max) {
        this.$cache.min[0].style.display = "none";
        this.$cache.max[0].style.display = "none";
        return;
      }

      if (this.options.values.length) {
        this.$cache.min.html(this.decorate(this.options.p_values[this.options.min]));
        this.$cache.max.html(this.decorate(this.options.p_values[this.options.max]));
      } else {
        var min_pretty = this._prettify(this.options.min);

        var max_pretty = this._prettify(this.options.max);

        this.result.min_pretty = min_pretty;
        this.result.max_pretty = max_pretty;
        this.$cache.min.html(this.decorate(min_pretty, this.options.min));
        this.$cache.max.html(this.decorate(max_pretty, this.options.max));
      }

      this.labels.w_min = this.$cache.min.outerWidth(false);
      this.labels.w_max = this.$cache.max.outerWidth(false);
    },

    /**
     * Then dragging interval, prevent interval collapsing
     * using min_interval option
     */
    setTempMinInterval: function setTempMinInterval() {
      var interval = this.result.to - this.result.from;

      if (this.old_min_interval === null) {
        this.old_min_interval = this.options.min_interval;
      }

      this.options.min_interval = interval;
    },

    /**
     * Restore min_interval option to original
     */
    restoreOriginalMinInterval: function restoreOriginalMinInterval() {
      if (this.old_min_interval !== null) {
        this.options.min_interval = this.old_min_interval;
        this.old_min_interval = null;
      }
    },
    // =============================================================================================================
    // Calculations

    /**
     * All calculations and measures start here
     *
     * @param update {boolean=}
     */
    calc: function calc(update) {
      if (!this.options) {
        return;
      }

      this.calc_count++;

      if (this.calc_count === 10 || update) {
        this.calc_count = 0;
        this.coords.w_rs = this.$cache.rs.outerWidth(false);
        this.calcHandlePercent();
      }

      if (!this.coords.w_rs) {
        return;
      }

      this.calcPointerPercent();
      var handle_x = this.getHandleX();

      if (this.target === "both") {
        this.coords.p_gap = 0;
        handle_x = this.getHandleX();
      }

      if (this.target === "click") {
        this.coords.p_gap = this.coords.p_handle / 2;
        handle_x = this.getHandleX();

        if (this.options.drag_interval) {
          this.target = "both_one";
        } else {
          this.target = this.chooseHandle(handle_x);
        }
      }

      switch (this.target) {
        case "base":
          var w = (this.options.max - this.options.min) / 100,
              f = (this.result.from - this.options.min) / w,
              t = (this.result.to - this.options.min) / w;
          this.coords.p_single_real = this.toFixed(f);
          this.coords.p_from_real = this.toFixed(f);
          this.coords.p_to_real = this.toFixed(t);
          this.coords.p_single_real = this.checkDiapason(this.coords.p_single_real, this.options.from_min, this.options.from_max);
          this.coords.p_from_real = this.checkDiapason(this.coords.p_from_real, this.options.from_min, this.options.from_max);
          this.coords.p_to_real = this.checkDiapason(this.coords.p_to_real, this.options.to_min, this.options.to_max);
          this.coords.p_single_fake = this.convertToFakePercent(this.coords.p_single_real);
          this.coords.p_from_fake = this.convertToFakePercent(this.coords.p_from_real);
          this.coords.p_to_fake = this.convertToFakePercent(this.coords.p_to_real);
          this.target = null;
          break;

        case "single":
          if (this.options.from_fixed) {
            break;
          }

          this.coords.p_single_real = this.convertToRealPercent(handle_x);
          this.coords.p_single_real = this.calcWithStep(this.coords.p_single_real);
          this.coords.p_single_real = this.checkDiapason(this.coords.p_single_real, this.options.from_min, this.options.from_max);
          this.coords.p_single_fake = this.convertToFakePercent(this.coords.p_single_real);
          break;

        case "from":
          if (this.options.from_fixed) {
            break;
          }

          this.coords.p_from_real = this.convertToRealPercent(handle_x);
          this.coords.p_from_real = this.calcWithStep(this.coords.p_from_real);

          if (this.coords.p_from_real > this.coords.p_to_real) {
            this.coords.p_from_real = this.coords.p_to_real;
          }

          this.coords.p_from_real = this.checkDiapason(this.coords.p_from_real, this.options.from_min, this.options.from_max);
          this.coords.p_from_real = this.checkMinInterval(this.coords.p_from_real, this.coords.p_to_real, "from");
          this.coords.p_from_real = this.checkMaxInterval(this.coords.p_from_real, this.coords.p_to_real, "from");
          this.coords.p_from_fake = this.convertToFakePercent(this.coords.p_from_real);
          break;

        case "to":
          if (this.options.to_fixed) {
            break;
          }

          this.coords.p_to_real = this.convertToRealPercent(handle_x);
          this.coords.p_to_real = this.calcWithStep(this.coords.p_to_real);

          if (this.coords.p_to_real < this.coords.p_from_real) {
            this.coords.p_to_real = this.coords.p_from_real;
          }

          this.coords.p_to_real = this.checkDiapason(this.coords.p_to_real, this.options.to_min, this.options.to_max);
          this.coords.p_to_real = this.checkMinInterval(this.coords.p_to_real, this.coords.p_from_real, "to");
          this.coords.p_to_real = this.checkMaxInterval(this.coords.p_to_real, this.coords.p_from_real, "to");
          this.coords.p_to_fake = this.convertToFakePercent(this.coords.p_to_real);
          break;

        case "both":
          if (this.options.from_fixed || this.options.to_fixed) {
            break;
          }

          handle_x = this.toFixed(handle_x + this.coords.p_handle * 0.001);
          this.coords.p_from_real = this.convertToRealPercent(handle_x) - this.coords.p_gap_left;
          this.coords.p_from_real = this.calcWithStep(this.coords.p_from_real);
          this.coords.p_from_real = this.checkDiapason(this.coords.p_from_real, this.options.from_min, this.options.from_max);
          this.coords.p_from_real = this.checkMinInterval(this.coords.p_from_real, this.coords.p_to_real, "from");
          this.coords.p_from_fake = this.convertToFakePercent(this.coords.p_from_real);
          this.coords.p_to_real = this.convertToRealPercent(handle_x) + this.coords.p_gap_right;
          this.coords.p_to_real = this.calcWithStep(this.coords.p_to_real);
          this.coords.p_to_real = this.checkDiapason(this.coords.p_to_real, this.options.to_min, this.options.to_max);
          this.coords.p_to_real = this.checkMinInterval(this.coords.p_to_real, this.coords.p_from_real, "to");
          this.coords.p_to_fake = this.convertToFakePercent(this.coords.p_to_real);
          break;

        case "both_one":
          if (this.options.from_fixed || this.options.to_fixed) {
            break;
          }

          var real_x = this.convertToRealPercent(handle_x),
              from = this.result.from_percent,
              to = this.result.to_percent,
              full = to - from,
              half = full / 2,
              new_from = real_x - half,
              new_to = real_x + half;

          if (new_from < 0) {
            new_from = 0;
            new_to = new_from + full;
          }

          if (new_to > 100) {
            new_to = 100;
            new_from = new_to - full;
          }

          this.coords.p_from_real = this.calcWithStep(new_from);
          this.coords.p_from_real = this.checkDiapason(this.coords.p_from_real, this.options.from_min, this.options.from_max);
          this.coords.p_from_fake = this.convertToFakePercent(this.coords.p_from_real);
          this.coords.p_to_real = this.calcWithStep(new_to);
          this.coords.p_to_real = this.checkDiapason(this.coords.p_to_real, this.options.to_min, this.options.to_max);
          this.coords.p_to_fake = this.convertToFakePercent(this.coords.p_to_real);
          break;
      }

      if (this.options.type === "single") {
        this.coords.p_bar_x = this.coords.p_handle / 2;
        this.coords.p_bar_w = this.coords.p_single_fake;
        this.result.from_percent = this.coords.p_single_real;
        this.result.from = this.convertToValue(this.coords.p_single_real);
        this.result.from_pretty = this._prettify(this.result.from);

        if (this.options.values.length) {
          this.result.from_value = this.options.values[this.result.from];
        }
      } else {
        this.coords.p_bar_x = this.toFixed(this.coords.p_from_fake + this.coords.p_handle / 2);
        this.coords.p_bar_w = this.toFixed(this.coords.p_to_fake - this.coords.p_from_fake);
        this.result.from_percent = this.coords.p_from_real;
        this.result.from = this.convertToValue(this.coords.p_from_real);
        this.result.from_pretty = this._prettify(this.result.from);
        this.result.to_percent = this.coords.p_to_real;
        this.result.to = this.convertToValue(this.coords.p_to_real);
        this.result.to_pretty = this._prettify(this.result.to);

        if (this.options.values.length) {
          this.result.from_value = this.options.values[this.result.from];
          this.result.to_value = this.options.values[this.result.to];
        }
      }

      this.calcMinMax();
      this.calcLabels();
    },

    /**
     * calculates pointer X in percent
     */
    calcPointerPercent: function calcPointerPercent() {
      if (!this.coords.w_rs) {
        this.coords.p_pointer = 0;
        return;
      }

      if (this.coords.x_pointer < 0 || isNaN(this.coords.x_pointer)) {
        this.coords.x_pointer = 0;
      } else if (this.coords.x_pointer > this.coords.w_rs) {
        this.coords.x_pointer = this.coords.w_rs;
      }

      this.coords.p_pointer = this.toFixed(this.coords.x_pointer / this.coords.w_rs * 100);
    },
    convertToRealPercent: function convertToRealPercent(fake) {
      var full = 100 - this.coords.p_handle;
      return fake / full * 100;
    },
    convertToFakePercent: function convertToFakePercent(real) {
      var full = 100 - this.coords.p_handle;
      return real / 100 * full;
    },
    getHandleX: function getHandleX() {
      var max = 100 - this.coords.p_handle,
          x = this.toFixed(this.coords.p_pointer - this.coords.p_gap);

      if (x < 0) {
        x = 0;
      } else if (x > max) {
        x = max;
      }

      return x;
    },
    calcHandlePercent: function calcHandlePercent() {
      if (this.options.type === "single") {
        this.coords.w_handle = this.$cache.s_single.outerWidth(false);
      } else {
        this.coords.w_handle = this.$cache.s_from.outerWidth(false);
      }

      this.coords.p_handle = this.toFixed(this.coords.w_handle / this.coords.w_rs * 100);
    },

    /**
     * Find closest handle to pointer click
     *
     * @param real_x {Number}
     * @returns {String}
     */
    chooseHandle: function chooseHandle(real_x) {
      if (this.options.type === "single") {
        return "single";
      } else {
        var m_point = this.coords.p_from_real + (this.coords.p_to_real - this.coords.p_from_real) / 2;

        if (real_x >= m_point) {
          return this.options.to_fixed ? "from" : "to";
        } else {
          return this.options.from_fixed ? "to" : "from";
        }
      }
    },

    /**
     * Measure Min and Max labels width in percent
     */
    calcMinMax: function calcMinMax() {
      if (!this.coords.w_rs) {
        return;
      }

      this.labels.p_min = this.labels.w_min / this.coords.w_rs * 100;
      this.labels.p_max = this.labels.w_max / this.coords.w_rs * 100;
    },

    /**
     * Measure labels width and X in percent
     */
    calcLabels: function calcLabels() {
      if (!this.coords.w_rs || this.options.hide_from_to) {
        return;
      }

      if (this.options.type === "single") {
        this.labels.w_single = this.$cache.single.outerWidth(false);
        this.labels.p_single_fake = this.labels.w_single / this.coords.w_rs * 100;
        this.labels.p_single_left = this.coords.p_single_fake + this.coords.p_handle / 2 - this.labels.p_single_fake / 2;
        this.labels.p_single_left = this.checkEdges(this.labels.p_single_left, this.labels.p_single_fake);
      } else {
        this.labels.w_from = this.$cache.from.outerWidth(false);
        this.labels.p_from_fake = this.labels.w_from / this.coords.w_rs * 100;
        this.labels.p_from_left = this.coords.p_from_fake + this.coords.p_handle / 2 - this.labels.p_from_fake / 2;
        this.labels.p_from_left = this.toFixed(this.labels.p_from_left);
        this.labels.p_from_left = this.checkEdges(this.labels.p_from_left, this.labels.p_from_fake);
        this.labels.w_to = this.$cache.to.outerWidth(false);
        this.labels.p_to_fake = this.labels.w_to / this.coords.w_rs * 100;
        this.labels.p_to_left = this.coords.p_to_fake + this.coords.p_handle / 2 - this.labels.p_to_fake / 2;
        this.labels.p_to_left = this.toFixed(this.labels.p_to_left);
        this.labels.p_to_left = this.checkEdges(this.labels.p_to_left, this.labels.p_to_fake);
        this.labels.w_single = this.$cache.single.outerWidth(false);
        this.labels.p_single_fake = this.labels.w_single / this.coords.w_rs * 100;
        this.labels.p_single_left = (this.labels.p_from_left + this.labels.p_to_left + this.labels.p_to_fake) / 2 - this.labels.p_single_fake / 2;
        this.labels.p_single_left = this.toFixed(this.labels.p_single_left);
        this.labels.p_single_left = this.checkEdges(this.labels.p_single_left, this.labels.p_single_fake);
      }
    },
    // =============================================================================================================
    // Drawings

    /**
     * Main function called in request animation frame
     * to update everything
     */
    updateScene: function updateScene() {
      if (this.raf_id) {
        cancelAnimationFrame(this.raf_id);
        this.raf_id = null;
      }

      clearTimeout(this.update_tm);
      this.update_tm = null;

      if (!this.options) {
        return;
      }

      this.drawHandles();

      if (this.is_active) {
        this.raf_id = requestAnimationFrame(this.updateScene.bind(this));
      } else {
        this.update_tm = setTimeout(this.updateScene.bind(this), 300);
      }
    },

    /**
     * Draw handles
     */
    drawHandles: function drawHandles() {
      this.coords.w_rs = this.$cache.rs.outerWidth(false);

      if (!this.coords.w_rs) {
        return;
      }

      if (this.coords.w_rs !== this.coords.w_rs_old) {
        this.target = "base";
        this.is_resize = true;
      }

      if (this.coords.w_rs !== this.coords.w_rs_old || this.force_redraw) {
        this.setMinMax();
        this.calc(true);
        this.drawLabels();

        if (this.options.grid) {
          this.calcGridMargin();
          this.calcGridLabels();
        }

        this.force_redraw = true;
        this.coords.w_rs_old = this.coords.w_rs;
        this.drawShadow();
      }

      if (!this.coords.w_rs) {
        return;
      }

      if (!this.dragging && !this.force_redraw && !this.is_key) {
        return;
      }

      if (this.old_from !== this.result.from || this.old_to !== this.result.to || this.force_redraw || this.is_key) {
        this.drawLabels();
        this.$cache.bar[0].style.left = this.coords.p_bar_x + "%";
        this.$cache.bar[0].style.width = this.coords.p_bar_w + "%";

        if (this.options.type === "single") {
          this.$cache.bar[0].style.left = 0;
          this.$cache.bar[0].style.width = this.coords.p_bar_w + this.coords.p_bar_x + "%";
          this.$cache.s_single[0].style.left = this.coords.p_single_fake + "%";
          this.$cache.single[0].style.left = this.labels.p_single_left + "%";
        } else {
          this.$cache.s_from[0].style.left = this.coords.p_from_fake + "%";
          this.$cache.s_to[0].style.left = this.coords.p_to_fake + "%";

          if (this.old_from !== this.result.from || this.force_redraw) {
            this.$cache.from[0].style.left = this.labels.p_from_left + "%";
          }

          if (this.old_to !== this.result.to || this.force_redraw) {
            this.$cache.to[0].style.left = this.labels.p_to_left + "%";
          }

          this.$cache.single[0].style.left = this.labels.p_single_left + "%";
        }

        this.writeToInput();

        if ((this.old_from !== this.result.from || this.old_to !== this.result.to) && !this.is_start) {
          this.$cache.input.trigger("change");
          this.$cache.input.trigger("input");
        }

        this.old_from = this.result.from;
        this.old_to = this.result.to; // callbacks call

        if (!this.is_resize && !this.is_update && !this.is_start && !this.is_finish) {
          this.callOnChange();
        }

        if (this.is_key || this.is_click) {
          this.is_key = false;
          this.is_click = false;
          this.callOnFinish();
        }

        this.is_update = false;
        this.is_resize = false;
        this.is_finish = false;
      }

      this.is_start = false;
      this.is_key = false;
      this.is_click = false;
      this.force_redraw = false;
    },

    /**
     * Draw labels
     * measure labels collisions
     * collapse close labels
     */
    drawLabels: function drawLabels() {
      if (!this.options) {
        return;
      }

      var values_num = this.options.values.length;
      var p_values = this.options.p_values;
      var text_single;
      var text_from;
      var text_to;
      var from_pretty;
      var to_pretty;

      if (this.options.hide_from_to) {
        return;
      }

      if (this.options.type === "single") {
        if (values_num) {
          text_single = this.decorate(p_values[this.result.from]);
          this.$cache.single.html(text_single);
        } else {
          from_pretty = this._prettify(this.result.from);
          text_single = this.decorate(from_pretty, this.result.from);
          this.$cache.single.html(text_single);
        }

        this.calcLabels();

        if (this.labels.p_single_left < this.labels.p_min + 1) {
          this.$cache.min[0].style.visibility = "hidden";
        } else {
          this.$cache.min[0].style.visibility = "visible";
        }

        if (this.labels.p_single_left + this.labels.p_single_fake > 100 - this.labels.p_max - 1) {
          this.$cache.max[0].style.visibility = "hidden";
        } else {
          this.$cache.max[0].style.visibility = "visible";
        }
      } else {
        if (values_num) {
          if (this.options.decorate_both) {
            text_single = this.decorate(p_values[this.result.from]);
            text_single += this.options.values_separator;
            text_single += this.decorate(p_values[this.result.to]);
          } else {
            text_single = this.decorate(p_values[this.result.from] + this.options.values_separator + p_values[this.result.to]);
          }

          text_from = this.decorate(p_values[this.result.from]);
          text_to = this.decorate(p_values[this.result.to]);
          this.$cache.single.html(text_single);
          this.$cache.from.html(text_from);
          this.$cache.to.html(text_to);
        } else {
          from_pretty = this._prettify(this.result.from);
          to_pretty = this._prettify(this.result.to);

          if (this.options.decorate_both) {
            text_single = this.decorate(from_pretty, this.result.from);
            text_single += this.options.values_separator;
            text_single += this.decorate(to_pretty, this.result.to);
          } else {
            text_single = this.decorate(from_pretty + this.options.values_separator + to_pretty, this.result.to);
          }

          text_from = this.decorate(from_pretty, this.result.from);
          text_to = this.decorate(to_pretty, this.result.to);
          this.$cache.single.html(text_single);
          this.$cache.from.html(text_from);
          this.$cache.to.html(text_to);
        }

        this.calcLabels();
        var min = Math.min(this.labels.p_single_left, this.labels.p_from_left),
            single_left = this.labels.p_single_left + this.labels.p_single_fake,
            to_left = this.labels.p_to_left + this.labels.p_to_fake,
            max = Math.max(single_left, to_left);

        if (this.labels.p_from_left + this.labels.p_from_fake >= this.labels.p_to_left) {
          this.$cache.from[0].style.visibility = "hidden";
          this.$cache.to[0].style.visibility = "hidden";
          this.$cache.single[0].style.visibility = "visible";

          if (this.result.from === this.result.to) {
            if (this.target === "from") {
              this.$cache.from[0].style.visibility = "visible";
            } else if (this.target === "to") {
              this.$cache.to[0].style.visibility = "visible";
            } else if (!this.target) {
              this.$cache.from[0].style.visibility = "visible";
            }

            this.$cache.single[0].style.visibility = "hidden";
            max = to_left;
          } else {
            this.$cache.from[0].style.visibility = "hidden";
            this.$cache.to[0].style.visibility = "hidden";
            this.$cache.single[0].style.visibility = "visible";
            max = Math.max(single_left, to_left);
          }
        } else {
          this.$cache.from[0].style.visibility = "visible";
          this.$cache.to[0].style.visibility = "visible";
          this.$cache.single[0].style.visibility = "hidden";
        }

        if (min < this.labels.p_min + 1) {
          this.$cache.min[0].style.visibility = "hidden";
        } else {
          this.$cache.min[0].style.visibility = "visible";
        }

        if (max > 100 - this.labels.p_max - 1) {
          this.$cache.max[0].style.visibility = "hidden";
        } else {
          this.$cache.max[0].style.visibility = "visible";
        }
      }
    },

    /**
     * Draw shadow intervals
     */
    drawShadow: function drawShadow() {
      var o = this.options,
          c = this.$cache,
          is_from_min = typeof o.from_min === "number" && !isNaN(o.from_min),
          is_from_max = typeof o.from_max === "number" && !isNaN(o.from_max),
          is_to_min = typeof o.to_min === "number" && !isNaN(o.to_min),
          is_to_max = typeof o.to_max === "number" && !isNaN(o.to_max),
          from_min,
          from_max,
          to_min,
          to_max;

      if (o.type === "single") {
        if (o.from_shadow && (is_from_min || is_from_max)) {
          from_min = this.convertToPercent(is_from_min ? o.from_min : o.min);
          from_max = this.convertToPercent(is_from_max ? o.from_max : o.max) - from_min;
          from_min = this.toFixed(from_min - this.coords.p_handle / 100 * from_min);
          from_max = this.toFixed(from_max - this.coords.p_handle / 100 * from_max);
          from_min = from_min + this.coords.p_handle / 2;
          c.shad_single[0].style.display = "block";
          c.shad_single[0].style.left = from_min + "%";
          c.shad_single[0].style.width = from_max + "%";
        } else {
          c.shad_single[0].style.display = "none";
        }
      } else {
        if (o.from_shadow && (is_from_min || is_from_max)) {
          from_min = this.convertToPercent(is_from_min ? o.from_min : o.min);
          from_max = this.convertToPercent(is_from_max ? o.from_max : o.max) - from_min;
          from_min = this.toFixed(from_min - this.coords.p_handle / 100 * from_min);
          from_max = this.toFixed(from_max - this.coords.p_handle / 100 * from_max);
          from_min = from_min + this.coords.p_handle / 2;
          c.shad_from[0].style.display = "block";
          c.shad_from[0].style.left = from_min + "%";
          c.shad_from[0].style.width = from_max + "%";
        } else {
          c.shad_from[0].style.display = "none";
        }

        if (o.to_shadow && (is_to_min || is_to_max)) {
          to_min = this.convertToPercent(is_to_min ? o.to_min : o.min);
          to_max = this.convertToPercent(is_to_max ? o.to_max : o.max) - to_min;
          to_min = this.toFixed(to_min - this.coords.p_handle / 100 * to_min);
          to_max = this.toFixed(to_max - this.coords.p_handle / 100 * to_max);
          to_min = to_min + this.coords.p_handle / 2;
          c.shad_to[0].style.display = "block";
          c.shad_to[0].style.left = to_min + "%";
          c.shad_to[0].style.width = to_max + "%";
        } else {
          c.shad_to[0].style.display = "none";
        }
      }
    },

    /**
     * Write values to input element
     */
    writeToInput: function writeToInput() {
      if (this.options.type === "single") {
        if (this.options.values.length) {
          this.$cache.input.prop("value", this.result.from_value);
        } else {
          this.$cache.input.prop("value", this.result.from);
        }

        this.$cache.input.data("from", this.result.from);
      } else {
        if (this.options.values.length) {
          this.$cache.input.prop("value", this.result.from_value + this.options.input_values_separator + this.result.to_value);
        } else {
          this.$cache.input.prop("value", this.result.from + this.options.input_values_separator + this.result.to);
        }

        this.$cache.input.data("from", this.result.from);
        this.$cache.input.data("to", this.result.to);
      }
    },
    // =============================================================================================================
    // Callbacks
    callOnStart: function callOnStart() {
      this.writeToInput();

      if (this.options.onStart && typeof this.options.onStart === "function") {
        if (this.options.scope) {
          this.options.onStart.call(this.options.scope, this.result);
        } else {
          this.options.onStart(this.result);
        }
      }
    },
    callOnChange: function callOnChange() {
      this.writeToInput();

      if (this.options.onChange && typeof this.options.onChange === "function") {
        if (this.options.scope) {
          this.options.onChange.call(this.options.scope, this.result);
        } else {
          this.options.onChange(this.result);
        }
      }
    },
    callOnFinish: function callOnFinish() {
      this.writeToInput();

      if (this.options.onFinish && typeof this.options.onFinish === "function") {
        if (this.options.scope) {
          this.options.onFinish.call(this.options.scope, this.result);
        } else {
          this.options.onFinish(this.result);
        }
      }
    },
    callOnUpdate: function callOnUpdate() {
      this.writeToInput();

      if (this.options.onUpdate && typeof this.options.onUpdate === "function") {
        if (this.options.scope) {
          this.options.onUpdate.call(this.options.scope, this.result);
        } else {
          this.options.onUpdate(this.result);
        }
      }
    },
    // =============================================================================================================
    // Service methods
    toggleInput: function toggleInput() {
      this.$cache.input.toggleClass("irs-hidden-input");

      if (this.has_tab_index) {
        this.$cache.input.prop("tabindex", -1);
      } else {
        this.$cache.input.removeProp("tabindex");
      }

      this.has_tab_index = !this.has_tab_index;
    },

    /**
     * Convert real value to percent
     *
     * @param value {Number} X in real
     * @param no_min {boolean=} don't use min value
     * @returns {Number} X in percent
     */
    convertToPercent: function convertToPercent(value, no_min) {
      var diapason = this.options.max - this.options.min,
          one_percent = diapason / 100,
          val,
          percent;

      if (!diapason) {
        this.no_diapason = true;
        return 0;
      }

      if (no_min) {
        val = value;
      } else {
        val = value - this.options.min;
      }

      percent = val / one_percent;
      return this.toFixed(percent);
    },

    /**
     * Convert percent to real values
     *
     * @param percent {Number} X in percent
     * @returns {Number} X in real
     */
    convertToValue: function convertToValue(percent) {
      var min = this.options.min,
          max = this.options.max,
          min_decimals = min.toString().split(".")[1],
          max_decimals = max.toString().split(".")[1],
          min_length,
          max_length,
          avg_decimals = 0,
          abs = 0;

      if (percent === 0) {
        return this.options.min;
      }

      if (percent === 100) {
        return this.options.max;
      }

      if (min_decimals) {
        min_length = min_decimals.length;
        avg_decimals = min_length;
      }

      if (max_decimals) {
        max_length = max_decimals.length;
        avg_decimals = max_length;
      }

      if (min_length && max_length) {
        avg_decimals = min_length >= max_length ? min_length : max_length;
      }

      if (min < 0) {
        abs = Math.abs(min);
        min = +(min + abs).toFixed(avg_decimals);
        max = +(max + abs).toFixed(avg_decimals);
      }

      var number = (max - min) / 100 * percent + min,
          string = this.options.step.toString().split(".")[1],
          result;

      if (string) {
        number = +number.toFixed(string.length);
      } else {
        number = number / this.options.step;
        number = number * this.options.step;
        number = +number.toFixed(0);
      }

      if (abs) {
        number -= abs;
      }

      if (string) {
        result = +number.toFixed(string.length);
      } else {
        result = this.toFixed(number);
      }

      if (result < this.options.min) {
        result = this.options.min;
      } else if (result > this.options.max) {
        result = this.options.max;
      }

      return result;
    },

    /**
     * Round percent value with step
     *
     * @param percent {Number}
     * @returns percent {Number} rounded
     */
    calcWithStep: function calcWithStep(percent) {
      var rounded = Math.round(percent / this.coords.p_step) * this.coords.p_step;

      if (rounded > 100) {
        rounded = 100;
      }

      if (percent === 100) {
        rounded = 100;
      }

      return this.toFixed(rounded);
    },
    checkMinInterval: function checkMinInterval(p_current, p_next, type) {
      var o = this.options,
          current,
          next;

      if (!o.min_interval) {
        return p_current;
      }

      current = this.convertToValue(p_current);
      next = this.convertToValue(p_next);

      if (type === "from") {
        if (next - current < o.min_interval) {
          current = next - o.min_interval;
        }
      } else {
        if (current - next < o.min_interval) {
          current = next + o.min_interval;
        }
      }

      return this.convertToPercent(current);
    },
    checkMaxInterval: function checkMaxInterval(p_current, p_next, type) {
      var o = this.options,
          current,
          next;

      if (!o.max_interval) {
        return p_current;
      }

      current = this.convertToValue(p_current);
      next = this.convertToValue(p_next);

      if (type === "from") {
        if (next - current > o.max_interval) {
          current = next - o.max_interval;
        }
      } else {
        if (current - next > o.max_interval) {
          current = next + o.max_interval;
        }
      }

      return this.convertToPercent(current);
    },
    checkDiapason: function checkDiapason(p_num, min, max) {
      var num = this.convertToValue(p_num),
          o = this.options;

      if (typeof min !== "number") {
        min = o.min;
      }

      if (typeof max !== "number") {
        max = o.max;
      }

      if (num < min) {
        num = min;
      }

      if (num > max) {
        num = max;
      }

      return this.convertToPercent(num);
    },
    toFixed: function toFixed(num) {
      num = num.toFixed(20);
      return +num;
    },
    _prettify: function _prettify(num) {
      if (!this.options.prettify_enabled) {
        return num;
      }

      if (this.options.prettify && typeof this.options.prettify === "function") {
        return this.options.prettify(num);
      } else {
        return this.prettify(num);
      }
    },
    prettify: function prettify(num) {
      var n = num.toString();
      return n.replace(/(\d{1,3}(?=(?:\d\d\d)+(?!\d)))/g, "$1" + this.options.prettify_separator);
    },
    checkEdges: function checkEdges(left, width) {
      if (!this.options.force_edges) {
        return this.toFixed(left);
      }

      if (left < 0) {
        left = 0;
      } else if (left > 100 - width) {
        left = 100 - width;
      }

      return this.toFixed(left);
    },
    validate: function validate() {
      var o = this.options,
          r = this.result,
          v = o.values,
          vl = v.length,
          value,
          i;
      if (typeof o.min === "string") o.min = +o.min;
      if (typeof o.max === "string") o.max = +o.max;
      if (typeof o.from === "string") o.from = +o.from;
      if (typeof o.to === "string") o.to = +o.to;
      if (typeof o.step === "string") o.step = +o.step;
      if (typeof o.from_min === "string") o.from_min = +o.from_min;
      if (typeof o.from_max === "string") o.from_max = +o.from_max;
      if (typeof o.to_min === "string") o.to_min = +o.to_min;
      if (typeof o.to_max === "string") o.to_max = +o.to_max;
      if (typeof o.grid_num === "string") o.grid_num = +o.grid_num;

      if (o.max < o.min) {
        o.max = o.min;
      }

      if (vl) {
        o.p_values = [];
        o.min = 0;
        o.max = vl - 1;
        o.step = 1;
        o.grid_num = o.max;
        o.grid_snap = true;

        for (i = 0; i < vl; i++) {
          value = +v[i];

          if (!isNaN(value)) {
            v[i] = value;
            value = this._prettify(value);
          } else {
            value = v[i];
          }

          o.p_values.push(value);
        }
      }

      if (typeof o.from !== "number" || isNaN(o.from)) {
        o.from = o.min;
      }

      if (typeof o.to !== "number" || isNaN(o.to)) {
        o.to = o.max;
      }

      if (o.type === "single") {
        if (o.from < o.min) o.from = o.min;
        if (o.from > o.max) o.from = o.max;
      } else {
        if (o.from < o.min) o.from = o.min;
        if (o.from > o.max) o.from = o.max;
        if (o.to < o.min) o.to = o.min;
        if (o.to > o.max) o.to = o.max;

        if (this.update_check.from) {
          if (this.update_check.from !== o.from) {
            if (o.from > o.to) o.from = o.to;
          }

          if (this.update_check.to !== o.to) {
            if (o.to < o.from) o.to = o.from;
          }
        }

        if (o.from > o.to) o.from = o.to;
        if (o.to < o.from) o.to = o.from;
      }

      if (typeof o.step !== "number" || isNaN(o.step) || !o.step || o.step < 0) {
        o.step = 1;
      }

      if (typeof o.from_min === "number" && o.from < o.from_min) {
        o.from = o.from_min;
      }

      if (typeof o.from_max === "number" && o.from > o.from_max) {
        o.from = o.from_max;
      }

      if (typeof o.to_min === "number" && o.to < o.to_min) {
        o.to = o.to_min;
      }

      if (typeof o.to_max === "number" && o.from > o.to_max) {
        o.to = o.to_max;
      }

      if (r) {
        if (r.min !== o.min) {
          r.min = o.min;
        }

        if (r.max !== o.max) {
          r.max = o.max;
        }

        if (r.from < r.min || r.from > r.max) {
          r.from = o.from;
        }

        if (r.to < r.min || r.to > r.max) {
          r.to = o.to;
        }
      }

      if (typeof o.min_interval !== "number" || isNaN(o.min_interval) || !o.min_interval || o.min_interval < 0) {
        o.min_interval = 0;
      }

      if (typeof o.max_interval !== "number" || isNaN(o.max_interval) || !o.max_interval || o.max_interval < 0) {
        o.max_interval = 0;
      }

      if (o.min_interval && o.min_interval > o.max - o.min) {
        o.min_interval = o.max - o.min;
      }

      if (o.max_interval && o.max_interval > o.max - o.min) {
        o.max_interval = o.max - o.min;
      }
    },
    decorate: function decorate(num, original) {
      var decorated = "",
          o = this.options;

      if (o.prefix) {
        decorated += o.prefix;
      }

      decorated += num;

      if (o.max_postfix) {
        if (o.values.length && num === o.p_values[o.max]) {
          decorated += o.max_postfix;

          if (o.postfix) {
            decorated += " ";
          }
        } else if (original === o.max) {
          decorated += o.max_postfix;

          if (o.postfix) {
            decorated += " ";
          }
        }
      }

      if (o.postfix) {
        decorated += o.postfix;
      }

      return decorated;
    },
    updateFrom: function updateFrom() {
      this.result.from = this.options.from;
      this.result.from_percent = this.convertToPercent(this.result.from);
      this.result.from_pretty = this._prettify(this.result.from);

      if (this.options.values) {
        this.result.from_value = this.options.values[this.result.from];
      }
    },
    updateTo: function updateTo() {
      this.result.to = this.options.to;
      this.result.to_percent = this.convertToPercent(this.result.to);
      this.result.to_pretty = this._prettify(this.result.to);

      if (this.options.values) {
        this.result.to_value = this.options.values[this.result.to];
      }
    },
    updateResult: function updateResult() {
      this.result.min = this.options.min;
      this.result.max = this.options.max;
      this.updateFrom();
      this.updateTo();
    },
    // =============================================================================================================
    // Grid
    appendGrid: function appendGrid() {
      if (!this.options.grid) {
        return;
      }

      var o = this.options,
          i,
          z,
          total = o.max - o.min,
          big_num = o.grid_num,
          big_p = 0,
          big_w = 0,
          small_max = 4,
          local_small_max,
          small_p,
          small_w = 0,
          result,
          html = '';
      this.calcGridMargin();

      if (o.grid_snap) {
        big_num = total / o.step;
      }

      if (big_num > 50) big_num = 50;
      big_p = this.toFixed(100 / big_num);

      if (big_num > 4) {
        small_max = 3;
      }

      if (big_num > 7) {
        small_max = 2;
      }

      if (big_num > 14) {
        small_max = 1;
      }

      if (big_num > 28) {
        small_max = 0;
      }

      for (i = 0; i < big_num + 1; i++) {
        local_small_max = small_max;
        big_w = this.toFixed(big_p * i);

        if (big_w > 100) {
          big_w = 100;
        }

        this.coords.big[i] = big_w;
        small_p = (big_w - big_p * (i - 1)) / (local_small_max + 1);

        for (z = 1; z <= local_small_max; z++) {
          if (big_w === 0) {
            break;
          }

          small_w = this.toFixed(big_w - small_p * z);
          html += '<span class="irs-grid-pol small" style="left: ' + small_w + '%"></span>';
        }

        html += '<span class="irs-grid-pol" style="left: ' + big_w + '%"></span>';
        result = this.convertToValue(big_w);

        if (o.values.length) {
          result = o.p_values[result];
        } else {
          result = this._prettify(result);
        }

        html += '<span class="irs-grid-text js-grid-text-' + i + '" style="left: ' + big_w + '%">' + result + '</span>';
      }

      this.coords.big_num = Math.ceil(big_num + 1);
      this.$cache.cont.addClass("irs-with-grid");
      this.$cache.grid.html(html);
      this.cacheGridLabels();
    },
    cacheGridLabels: function cacheGridLabels() {
      var $label,
          i,
          num = this.coords.big_num;

      for (i = 0; i < num; i++) {
        $label = this.$cache.grid.find(".js-grid-text-" + i);
        this.$cache.grid_labels.push($label);
      }

      this.calcGridLabels();
    },
    calcGridLabels: function calcGridLabels() {
      var i,
          label,
          start = [],
          finish = [],
          num = this.coords.big_num;

      for (i = 0; i < num; i++) {
        this.coords.big_w[i] = this.$cache.grid_labels[i].outerWidth(false);
        this.coords.big_p[i] = this.toFixed(this.coords.big_w[i] / this.coords.w_rs * 100);
        this.coords.big_x[i] = this.toFixed(this.coords.big_p[i] / 2);
        start[i] = this.toFixed(this.coords.big[i] - this.coords.big_x[i]);
        finish[i] = this.toFixed(start[i] + this.coords.big_p[i]);
      }

      if (this.options.force_edges) {
        if (start[0] < -this.coords.grid_gap) {
          start[0] = -this.coords.grid_gap;
          finish[0] = this.toFixed(start[0] + this.coords.big_p[0]);
          this.coords.big_x[0] = this.coords.grid_gap;
        }

        if (finish[num - 1] > 100 + this.coords.grid_gap) {
          finish[num - 1] = 100 + this.coords.grid_gap;
          start[num - 1] = this.toFixed(finish[num - 1] - this.coords.big_p[num - 1]);
          this.coords.big_x[num - 1] = this.toFixed(this.coords.big_p[num - 1] - this.coords.grid_gap);
        }
      }

      this.calcGridCollision(2, start, finish);
      this.calcGridCollision(4, start, finish);

      for (i = 0; i < num; i++) {
        label = this.$cache.grid_labels[i][0];

        if (this.coords.big_x[i] !== Number.POSITIVE_INFINITY) {
          label.style.marginLeft = -this.coords.big_x[i] + "%";
        }
      }
    },
    // Collisions Calc Beta
    // TODO: Refactor then have plenty of time
    calcGridCollision: function calcGridCollision(step, start, finish) {
      var i,
          next_i,
          label,
          num = this.coords.big_num;

      for (i = 0; i < num; i += step) {
        next_i = i + step / 2;

        if (next_i >= num) {
          break;
        }

        label = this.$cache.grid_labels[next_i][0];

        if (finish[i] <= start[next_i]) {
          label.style.visibility = "visible";
        } else {
          label.style.visibility = "hidden";
        }
      }
    },
    calcGridMargin: function calcGridMargin() {
      if (!this.options.grid_margin) {
        return;
      }

      this.coords.w_rs = this.$cache.rs.outerWidth(false);

      if (!this.coords.w_rs) {
        return;
      }

      if (this.options.type === "single") {
        this.coords.w_handle = this.$cache.s_single.outerWidth(false);
      } else {
        this.coords.w_handle = this.$cache.s_from.outerWidth(false);
      }

      this.coords.p_handle = this.toFixed(this.coords.w_handle / this.coords.w_rs * 100);
      this.coords.grid_gap = this.toFixed(this.coords.p_handle / 2 - 0.1);
      this.$cache.grid[0].style.width = this.toFixed(100 - this.coords.p_handle) + "%";
      this.$cache.grid[0].style.left = this.coords.grid_gap + "%";
    },
    // =============================================================================================================
    // Public methods
    update: function update(options) {
      if (!this.input) {
        return;
      }

      this.is_update = true;
      this.options.from = this.result.from;
      this.options.to = this.result.to;
      this.update_check.from = this.result.from;
      this.update_check.to = this.result.to;
      this.options = $.extend(this.options, options);
      this.validate();
      this.updateResult(options);
      this.toggleInput();
      this.remove();
      this.init(true);
    },
    reset: function reset() {
      if (!this.input) {
        return;
      }

      this.updateResult();
      this.update();
    },
    destroy: function destroy() {
      if (!this.input) {
        return;
      }

      this.toggleInput();
      this.$cache.input.prop("readonly", false);
      $.data(this.input, "ionRangeSlider", null);
      this.remove();
      this.input = null;
      this.options = null;
    }
  };

  $.fn.ionRangeSlider = function (options) {
    return this.each(function () {
      if (!$.data(this, "ionRangeSlider")) {
        $.data(this, "ionRangeSlider", new IonRangeSlider(this, options, plugin_count++));
      }
    });
  }; // =================================================================================================================
  // http://paulirish.com/2011/requestanimationframe-for-smart-animating/
  // http://my.opera.com/emoller/blog/2011/12/20/requestanimationframe-for-smart-er-animating
  // requestAnimationFrame polyfill by Erik Möller. fixes from Paul Irish and Tino Zijdel
  // MIT license


  (function () {
    var lastTime = 0;
    var vendors = ['ms', 'moz', 'webkit', 'o'];

    for (var x = 0; x < vendors.length && !window.requestAnimationFrame; ++x) {
      window.requestAnimationFrame = window[vendors[x] + 'RequestAnimationFrame'];
      window.cancelAnimationFrame = window[vendors[x] + 'CancelAnimationFrame'] || window[vendors[x] + 'CancelRequestAnimationFrame'];
    }

    if (!window.requestAnimationFrame) window.requestAnimationFrame = function (callback, element) {
      var currTime = new Date().getTime();
      var timeToCall = Math.max(0, 16 - (currTime - lastTime));
      var id = window.setTimeout(function () {
        callback(currTime + timeToCall);
      }, timeToCall);
      lastTime = currTime + timeToCall;
      return id;
    };
    if (!window.cancelAnimationFrame) window.cancelAnimationFrame = function (id) {
      clearTimeout(id);
    };
  })();
});
$(function () {
  /**
   * Get Selection HTML
   *
   * @returns {string}
   */
  function getSelectionHtml() {
    var html = '';

    if (typeof window.getSelection != 'undefined') {
      var sel = window.getSelection();

      if (sel.rangeCount) {
        var container = document.createElement("div");

        for (var i = 0, len = sel.rangeCount; i < len; ++i) {
          container.appendChild(sel.getRangeAt(i).cloneContents());
        }

        html = container.innerHTML;
      }
    } else if (typeof document.selection != 'undefined') {
      if (String(document.selection.type).toLowerCase() === 'text') html = document.selection.createRange().htmlText;
    }

    return html;
  }
  /**
   * 'COPY' HANDLER
   */


  document.addEventListener('copy', function (e) {
    return;
    var selection = getSelectionHtml();
    e.clipboardData.setData('text/plain', $('<div/>').html(selection + '').text().replace(/­/g, '') + '\n\n' + 'Источник: ' + document.location.href);
    e.clipboardData.setData('text/html', selection + '<br /><br />Источник: <a href="' + document.location.href + '">' + document.title + '</a>');
    e.preventDefault();
  });
});
/**
 * jMathEdu System Core v 2.0 -- FEEDBACK FORM
 *
 * Last Mod Date: 2019-09-15
 */
$(function () {
  var formFeedback, selFormFeedback, selName, selEmail, selMessage, selSubject, selBtnSend;
  if (!(formFeedback = $(selFormFeedback = '[data-form-type="contacts"]')).get(0)) return false;
  var btnSend = $(selBtnSend = '[data-action="send"]');
  var contactName = formFeedback.find(selName = '[name="in-name"]'),
      contactEmail = formFeedback.find(selEmail = '[name="in-email"]'),
      contactSubject = formFeedback.find(selSubject = '[name="in-subject"]'),
      contactMessage = formFeedback.find(selMessage = '[name="in-message"]');
  formFeedback.on('input change', [selName, selEmail, selMessage, selSubject].join(', '), function (e) {
    doValidateContact(false);
  }) // ESC/ENTER HANDLERS
  .on('keydown', [selName, selEmail, selMessage, selSubject].join(', '), function (e) {
    var event = e.originalEvent || e;

    if (event.key === 'Enter') {
      if (!doValidateContact(true)) {
        e.preventDefault(); //btnSave.trigger( 'click' );

        return false;
      }
    }

    return true;
  }).on('submit', function (e) {
    if (!doValidateContact(true)) {
      e.preventDefault();
      return false;
    }

    btnSend.prop('disabled', true);
  });

  var doValidateContact = function doValidateContact() {
    var markBadFields = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var szName = String(contactName.val()),
        szEmail = String(contactEmail.val()),
        szMessage = String(contactMessage.val()),
        bFormOK = true;
    $([selName, selEmail, selMessage, selSubject].join(', ')).removeClass('input-error');
    btnSend.prop('disabled', '1');

    if (!szName.length) {
      if (markBadFields) $([selName].join(', ')).addClass('input-error');
      bFormOK = false;
    }

    if (!szEmail.length || !szEmail.checkEmailAddress()) {
      if (markBadFields) $([selEmail].join(', ')).addClass('input-error');
      bFormOK = false;
    }

    if (!szMessage.length) {
      if (markBadFields) $([selMessage].join(', ')).addClass('input-error');
      bFormOK = false;
    }

    btnSend.prop('disabled', !bFormOK);
    $('[name="do-contact"]').val(bFormOK ? 'do-the-post' : '');
    return bFormOK;
  };
});
/**
 * jMathEdu System Core v 2.0 -- Form Elements Init
 *
 * Last Mod Date: 2019-09-15
 */
$(function () {
  // FANCY RADIO/CHECKBOXES
  jQuery.each($(":checkbox, :radio"), function (index, item) {
    $(item).labelauty({
      extra_class: $(item).attr('data-class'),
      icon: true,
      same_width: true
    });
  }); // NICE <SELECT>

  $('select.stylize').niceSelect(); // RANGESLIDER

  $('.rangeSlider').ionRangeSlider({
    min_interval: null,
    max_interval: null,
    skin: 'round',
    grid: true,
    hide_min_max: true,
    prettify_enabled: false,
    force_edges: true,
    grid_num: 5 //drag_interval   : true,
    //grid_snap : true

  }); // RESET HANDLER (CLEARS THE FORM)

  $('button.btn-reset:reset').click(function () {
    $(this.closest('form')).find(':radio, :checkbox').removeAttr('checked').attr('name', '').end().find('textarea, :text, select, :hidden').val('').attr('name', '').end().submit();
    return false;
  }); // MATERIAL VALIDATION

  $('[data-form-type="quick-search"], [data-quick-search]').materialvalidation().on('submit', function (event) {
    if ($(this).data().materialvalidation.methods.validate()) {
      $('[name="do-contact"]').val('do-the-post');
      return true;
    }

    return false;
  }).on('reset', function (event) {
    $(this).data().materialvalidation.methods.reset();
  });
});
/**
 * jMathEdu System Core v 2.0 -- SEARCH FORMS
 *
 * Last Mod Date: 2019-09-15
 */
$(function () {
  // ADVANCED SEARCH FORM OPEN/EXPAND
  $('[data-type=search-form]').on('click', '.expander', function (e) {
    $(e.delegateTarget).toggleClass('is-expanded');
    setTimeout(function () {
      $(e.delegateTarget).removeClass('is-expanded').addClass('is-open');
    }, 300);
  }); // SEARCH SELECTS

  var catRoot, catChildren, optObj, $selCat, $selSubCat, $selSubSubCat, $selTitle, $grpCat, $grpSubCat, $grpSubSubCat;

  if ((catRoot = $('[data-type=cat-root]')).length) {
    catRoot = JSON.parse(catRoot.text());

    if (catRoot) {
      $selCat = $('[name=srch-cat]');
      $selSubCat = $('[name=srch-subcat]');
      $selSubSubCat = $('[name=srch-subsubcat]');
      $grpCat = $selCat.closest('.control-chain');
      $grpSubCat = $selSubCat.closest('.control-chain');
      $grpSubSubCat = $selSubSubCat.closest('.control-chain');
      $selCat.on('change', function () {
        var $this = $(this),
            val = $this.val();
        catChildren = Object();
        $selSubCat.removeOptions();
        $selSubSubCat.removeOptions();

        if (catRoot[val] && (catChildren = catRoot[val]['children'])) {
          for (optObj in catChildren) {
            $selSubCat.append($('<option></option>').attr('value', optObj).text(catChildren[optObj]['title']));
          }
        }

        $selSubCat.niceSelect('update');
        $selSubSubCat.niceSelect('update');
        $grpSubCat[!jQuery.isEmptyObject(catChildren) ? 'removeClass' : 'addClass']('is-hidden');
        $grpSubSubCat['addClass']('is-hidden');
      });
      $selSubCat.on('change', function () {
        var $this = $(this),
            val = $this.val(),
            pval = $selCat.val(),
            catChildren = Object();
        $selSubSubCat.removeOptions();

        if (catRoot[pval] && catRoot[pval]['children'] && catRoot[pval]['children'][val] && (catChildren = catRoot[pval]['children'][val]['children'])) {
          for (optObj in catChildren) {
            $selSubSubCat.append($('<option></option>').attr('value', optObj).text(catChildren[optObj]['title']));
          }
        }

        var labelText = $selSubSubCat.closest('.control-chain').data('label-text').split(','),
            labelOption = $selSubSubCat.closest('.control-chain').data('label-option').split(','),
            $labelSubSubCat = $selSubSubCat.closest('.control-chain').find('.label'),
            $labelOption = $($selSubSubCat.find('option').get(0));

        if (pval === 'collections' && (val === 'journals' || val === 'groups')) {
          $labelSubSubCat.text(labelText[1]);
          $labelOption.text(labelOption[1]);
        } else {
          $labelSubSubCat.text(labelText[0]);
          $labelOption.text(labelOption[0]);
        }

        $selSubSubCat.niceSelect('update');
        $grpSubSubCat[!jQuery.isEmptyObject(catChildren) ? 'removeClass' : 'addClass']('is-hidden');
      });
    }

    var formSearch = $('[data-type=search-form] form'),
        formInitData = formSearch.serialize(),
        btnSubmit = formSearch.find('[type=submit]'),
        btnReset = formSearch.find('[type=reset]');
    formSearch.on('change keyup paste', ':input', function (e) {
      var $this = $(e.delegateTarget),
          $control = $(e.target);

      if ($control.hasClass('has-clear-button')) {
        $control.next('button')[$control.val() === '' ? 'addClass' : 'removeClass']('is-disabled');
      }

      if ($control.hasClass('has-hideable-switches')) {
        $control.closest('.control-input').find('.hideable-switches')[$control.val().trim() === '' ? 'addClass' : 'removeClass']('is-hidden');
      }

      formSearch.data('changed', formSearch.serialize() !== formInitData);
    }).on('click', '.btn-reset', function (e) {
      var $control = $(e.target);
      $control.prev('input:text').val('').trigger('change').focus();
      $control.addClass('is-disabled');
      e.preventDefault();
      e.stopPropagation();
      return false;
    }).on('submit', function (e) {}).on('reset', function (e) {
      formSearch.find('input:text').val('').trigger('change');
      $selCat.val('').trigger('change').niceSelect('update');
      $selSubCat.val('').trigger('change').niceSelect('update');
      $selSubSubCat.val('').trigger('change').niceSelect('update');
      formSearch.find('[data-default-state]').prop('checked', true);
      var $yrSlider = formSearch.find('[name=srch-year]'),
          ionSlider = $yrSlider.data('ionRangeSlider');
      ionSlider.update({
        from: $yrSlider.data('min'),
        to: $yrSlider.data('max')
      });
      formSearch.data('changed', false);
      formInitData = formSearch.serialize();
      $('[data-type=search-results]').empty().remove();
      window.history.replaceState({}, '', window.location.href.replace(/advanced\/.*\/(.*)/, 'advanced/'));
      formSearch.find('[name=query]').focus();
      e.preventDefault();
      e.stopPropagation();
      return false;
    });
  }
});
/**
 * jMathEdu System Core v 2.0 -- BURGER MENU
 *
 * Last Mod Date: 2019-09-15
 */
$(function () {
  $('.burger-menu').on('click', function (event) {
    $(body).toggleClass('burger-menu-active');

    if ($(body).hasClass('burger-menu-active')) {
      onResize();
      scrollToView($('.ph-burger-menu .active').last(), $('.ph-burger-menu'));
    }

    event.preventDefault();
    event.stopPropagation();
    return false;
  });
  $('[data-type="burger-menu"]') //.on( 'mousewheel touch touchscroll touchmove', function ( event ) {
  //	event.stopPropagation();
  //} )
  .on('click', '.ph-page', function (event) {
    event.stopPropagation();
    event.preventDefault();
    return true;
  }).on('click', '.menu-close', function (event) {
    $(body).removeClass('burger-menu-active');
    event.stopPropagation();
    event.preventDefault();
    return true;
  }).on('click', 'ins', function (event) {
    var $pel = $(event.target).closest('li');
    var $rel = $(event.target).next('ul');

    if (!$pel.hasClass('expanded')) {
      $rel.css('height', $rel.prop('scrollHeight'));
      setTimeout(onResize, 100);
    } else {
      $rel.css('height', $rel.prop('scrollHeight'));
      $rel.css('height', 0);
    }

    $pel.toggleClass('expanded');
    event.stopPropagation();
    event.preventDefault();
    return true;
  });

  var onResize = function onResize() {
    var docHeight = $(window).outerHeight();
    $('[data-type="burger-menu"]').css({
      height: docHeight
    });
  };

  $(window).on('resize', onResize);
  onResize();
});
// USER PROFILE DROP DOWN
$(function () {
  var timerPopup = null;

  var userResize = function userResize() {
    var userDD;

    if ($(userDD = '.acc-button.ab-user').get(0)) {
      var popupDiv = $('[data-type="dropdown-account"]'),
          linkDiv = $(userDD),
          linkDivMobile = $('.nav-item.ab-user'),
          lW = linkDiv.getBox().width,
          pW = popupDiv.getBox().width,
          lP = linkDiv.cssInt('padding-left'),
          shX = Math.floor(lW - pW + 10);

      if (shX > 0) {
        popupDiv.css('right', (shX >> 1) - lP / 2).addClass('is-aligned');
      } else {}

      linkDiv.removeClass('no-events');
      linkDivMobile.removeClass('no-events');
      setTimeout(function () {
        popupDiv.addClass('c3');
      }, 50);
    }
  };

  setTimeout(function () {
    userResize();
  }, 100);
  $(window).on('resize', function () {
    clearTimeout(timerPopup);
    timerPopup = setTimeout(userResize, 100);
  });
});
/**
 * jMathEdu System Core v 2.0 -- MENU-TOP DROPDOWNS
 *
 * Last Mod Date: 2019-09-15
 */
$(function () {
  var T_TOPMENU_HIDE = 300; ////////////////////////////
  //   TOP MENU SUBMENU
  ////////////////////////////

  $('.menu-item.has-dropdown').on('click', function (e) {
    var $this = $(this);
    clearTimeout($this.data('timerhide'));
    $(this).addClass('is-expanded');
  }).on('mouseenter', function (e) {
    var $this = $(this);
    clearTimeout($this.data('timerhide'));
  }).on('mouseleave', function (e) {
    var $this = $(this);
    clearTimeout($this.data('timerhide'));
    $this.data('timerhide', setTimeout(function () {
      $this.removeClass('is-expanded');
    }, T_TOPMENU_HIDE));
  });
});
/**
 * jMathEdu System Core v 2.0 -- LIBDESC POPUPS, TITLE EXPANDERS
 *
 * Last Mod Date: 2019-09-15
 */
// NEW LIBDESC POPUPS
$(function () {
  var timerPopup = null;
  var T_POPUP_SHOW = 50,
      T_POPUP_HIDE = 400,
      T_POPUP_KILL = T_POPUP_HIDE + 250;
  var $elPackagesList = $('[data-type="page-contents"]'),
      $elShowLibDesc = $('[data-show-libdesc]');
  $elShowLibDesc.on('mouseenter', function (e) {
    var $this = $(e.delegateTarget);
    clearPopupTimers($this);
  }).on('click', function (e) {
    var $this = $(e.delegateTarget),
        $elRec = $(e.delegateTarget).closest('[data-type=record-item]'),
        $elDesc = $elRec.find('[data-type=libdesc]').clone(),
        $elPopup,
        $phDesc;
    T_POPUP_HIDE = window.isMobile ? 50 : 400;
    T_POPUP_KILL = T_POPUP_HIDE + 250; //clearInterval( $this.data( 'timershow' ) );
    //clearInterval( $this.data( 'timerhide' ) );
    //clearInterval( $this.data( 'timerdestroy' ) );

    clearPopupTimers($this);
    $this.data('timershow', setTimeout(function () {
      // CREATE or RETRIEVE
      if (!$this.data('popup')) {
        $elPopup = $('<div data-popup-libdesc style="position: fixed" class="is-hidden no-events"><div class="ph"></div><dd></dd><dl></dl></div>');
        $elPopup.appendTo($('.ph-app')); // EVENTS

        $elPopup.on('mouseenter', function () {
          clearInterval($this.data('timerhide'));
          clearInterval($this.data('timerdestroy'));
          $this.data('timerhide', null);
          $this.data('timerdestroy', null);
        }).on('mouseleave', function () {
          clearPopupTimers($this);
          $this.data('timerhide', setTimeout(function () {
            if ($elPopup) {
              $this.removeClass('is-active');
              $elPopup.addClass('is-hidden');
            }
          }, T_POPUP_HIDE));
          $this.data('timerdestroy', setTimeout(function () {
            if ($elPopup) $elPopup.remove();
            $this.data('popup', null);
            $this.data('timershow', null);
            $this.data('timerhide', null);
            $this.data('timerdestroy', null);
          }, T_POPUP_KILL));
        });
        $this.data('popup', $elPopup);
      } else {
        $elPopup = $this.data('popup');
        $elPopup.addClass('no-events');
      }

      $this.addClass('is-active'); // FILL WITH HTML

      $phDesc = $elPopup.find('.ph');
      $phDesc.empty().append($elDesc);
      requestAnimationFrame(function () {
        var rectHandler = $this.get(0).getBoundingClientRect(),
            rectList = $elPackagesList.get(0).getBoundingClientRect(),
            rectEl = $elPopup.get(0).getBoundingClientRect(),
            xMargin = window.isMobile ? 0 : Math.floor($elPackagesList.cssInt('padding-left') / 1.5),
            popupDir = rectHandler.y < rectEl.height ? 'bottom' : 'top',
            shiftX = 0; // MOVE

        $elPopup.position($this, popupDir === 'top' ? {
          anchor: ['bc', 'tc'],
          offset: [0, -8]
        } : {
          anchor: ['tc', 'bc'],
          offset: [0, 8]
        });
        $elPopup.css({
          'margin-left': 0,
          'position': ''
        });
        $elPopup[popupDir === 'top' ? 'addClass' : 'removeClass']('to-top'); // ADJUST HORIZONTALLY

        rectEl = $elPopup.get(0).getBoundingClientRect();

        if (window.isMobile) {
          shiftX = rectList.right - rectEl.right - 12;
        } else {
          if (rectEl.right + xMargin >= rectList.right) {
            shiftX = rectList.right - rectEl.right - xMargin;
          } else if (rectEl.left - xMargin <= rectList.left) {
            shiftX = rectList.left - rectEl.left + xMargin;
          }
        }

        $elPopup.css('margin-left', shiftX).removeClass('is-hidden no-events').find('dl').css('margin-left', -shiftX);
        $this.data('timershow', null);
      });
    }, T_POPUP_SHOW));
  }).on('mouseleave', function (e) {
    var $this = $(e.delegateTarget),
        $elPopup = $this.data('popup');
    clearPopupTimers($this);
    $this.data('timerhide', setTimeout(function () {
      if ($elPopup) {
        $this.removeClass('is-active');
        $elPopup.addClass('is-hidden');
      }
    }, T_POPUP_HIDE));
    $this.data('timerdestroy', setTimeout(function () {
      if ($elPopup) $elPopup.remove();
      $this.data('popup', null);
      $this.data('timershow', null);
      $this.data('timerhide', null);
      $this.data('timerdestroy', null);
    }, T_POPUP_KILL));
  });

  function clearPopupTimers($obj) {
    clearInterval($obj.data('timershow'));
    clearInterval($obj.data('timerhide'));
    clearInterval($obj.data('timerdestroy'));
  }

  function killPopups() {
    $elShowLibDesc.data('popup', null);
    $('[data-popup-libdesc]').remove();
  }

  $(window).on('resize', function () {
    clearTimeout(timerPopup);
    timerPopup = setTimeout(killPopups, 10);
  });
}); // PACKAGES LIST CLOSE / OPEN

$(function () {
  $('[data-type=record-item].is-multiple').on('click', '> * > a', function (e) {
    var $xpanItem = $(e.delegateTarget),
        $xpanEl = $xpanItem.find('[data-type=child-packages-list]');
    $xpanEl.css({
      'max-height': !$($xpanItem).hasClass('is-expanded') ? $xpanEl.find('div').outerHeight() : 0
    });
    $($xpanItem).toggleClass('is-expanded');
    setTimeout(function () {
      $xpanEl.css($($xpanItem).hasClass('is-expanded') ? {
        'max-height': $xpanEl.find('div').outerHeight() * 3,
        'overflow': 'visible'
      } : {
        'overflow': 'hidden'
      });
    }, 300);
    e.preventDefault();
    return false;
  });
});
/**
 * jMathEdu System Core v 2.0 -- LIBDESC POPUPS, TITLE EXPANDERS
 *
 * Last Mod Date: 2019-09-15
 */
// NEW LIBDESC POPUPS
$(function () {
  var timerPopup = null;
  var T_POPUP_SHOW = 50,
      T_POPUP_HIDE = 400,
      T_POPUP_KILL = T_POPUP_HIDE + 250;
  var $elPackagesList = $('[data-type="page-contents"]'),
      $elShowLibDesc = $('[data-show-sets]');
  $elShowLibDesc.on('mouseenter', function (e) {
    var $this = $(e.delegateTarget);
    clearPopupTimers($this);
  }).on('click', function (e) {
    var $this = $(e.delegateTarget),
        $elPopup = $this.data('popup');
    T_POPUP_HIDE = window.isMobile ? 50 : 400;
    T_POPUP_KILL = T_POPUP_HIDE + 250;
    clearPopupTimers($this);
    if ($elPopup) return false;
    $this.data('timershow', setTimeout(function () {
      // CREATE or RETRIEVE
      if (!$this.data('popup')) {
        $elPopup = $('<div data-popup-sets style="position: fixed" class="is-hidden no-events is-loading"><div class="ph"></div><dd></dd><dl></dl></div>');
        $elPopup.appendTo($('.ph-app'));
        $this.data('popup', $elPopup); // ATTACH EVENTS

        attachPopupEvents($this, $elPopup);
      } else {
        $elPopup.addClass('no-events');
      }

      $this.addClass('is-active'); // LOAD SETS

      repositionPopup($this, $elPopup);
      loadPopupSets($this, $elPopup);
    }, T_POPUP_SHOW));
  }).on('mouseleave', function (e) {
    var $this = $(e.delegateTarget),
        $elPopup = $this.data('popup');
    clearPopupTimers($this);
    $this.data('timerhide', setTimeout(function () {
      if ($elPopup) {
        $this.removeClass('is-active');
        $elPopup.addClass('is-hidden');
        $this.data('popup', null);
      }
    }, T_POPUP_HIDE));
    $this.data('timerdestroy', setTimeout(function () {
      if ($elPopup) $elPopup.remove();
      $this.data('popup', null);
      clearPopupTimers($this);
    }, T_POPUP_KILL));
  });

  function attachPopupEvents($__master, $__elPopup) {
    $__elPopup.on('mouseenter', function () {
      clearPopupTimers($__master);
    }).on('mouseleave', function () {
      clearPopupTimers($__master);
      $__master.data('timerhide', setTimeout(function () {
        if ($__elPopup) {
          $__master.removeClass('is-active');
          $__elPopup.addClass('is-hidden');
          $__master.data('popup', null);
        }
      }, T_POPUP_HIDE));
      $__master.data('timerdestroy', setTimeout(function () {
        if ($__elPopup) $__elPopup.remove();
        $__master.data('popup', null);
        clearPopupTimers($__master);
      }, T_POPUP_KILL));
    });
    $__elPopup.on('click', '[data-action]', function (e) {
      var $el = $(e.target),
          $objCreator = $(window.setCreator),
          $elSetBox = $__elPopup,
          $elSetlist = $elSetBox.find('[data-set-list]'),
          $elTitle = $elSetBox.find('input[type="text"]'),
          szTitle = $elTitle.val();

      switch ($el.data('action')) {
        case 'save-new-set':
          if (!window.setCreator) return false; // Simple validate

          if (!szTitle.replace(/[\s-\/\\^$*+?.()|[\]{}<>!]/g, '').length) {
            $elTitle.addClass('is-invalid').trigger('focus');
            return false;
          }

          $objCreator.removeClass('in-edit-mode').addClass('in-save-mode');
          $elTitle.removeClass('is-invalid') //.attr( 'readonly', '1' )
          .trigger('blur'); // todo: check title not empty

          addSet($__master, $__elPopup, $elSetBox, $elSetlist, szTitle);
          break;

        case 'cancel-new-set':
          if (!window.setCreator) return false;
          $objCreator.removeClass('in-edit-mode');
          $elTitle.removeClass('is-invalid') //.attr( 'readonly', '1' )
          .val($elTitle.data('empty')).trigger('blur').trigger('input');
          window.setCreator = null;
          break;

        default:
          break;
      }
    }).on('click', 'input[type=text]', function (e) {
      var $elSet = $(e.target).closest('[data-set-new-form]'),
          $elSetBox = $__elPopup,
          $elInput = $elSet.find('input');
      if ($elSetBox.hasClass('in-edit-mode')) return false;
      if (window.setCreator) $(window.setCreator).find('[data-action="cancel-new-set"]').trigger('click');
      $elSetBox.addClass('in-edit-mode');
      $elInput //.removeAttr( 'readonly' )
      .val('').trigger('input').trigger('focus');
      window.setCreator = $elSetBox;
    }).on('input', 'input[type=text]', function (e) {
      $(e.target).removeClass('is-invalid');
      repositionPopup($__master, $__elPopup);
    }).on('click', 'input[type=text]', function (e) {}).on('blur', 'input[type=text]', function (e) {}).on('click', '[data-set]', function (e) {
      var $elSet = $(e.target),
          action = $elSet.hasClass('is-active') ? 'removeitem' : 'additem',
          setUUID = $elSet.data('set'),
          objType = $__master.data('type'),
          objURL = $__master.data('url'); //if($elSet.hasClass('is-current')) return false;

      if (setUUID && objType && objURL) {
        if (window.setCreator) $(window.setCreator).find('[data-action="cancel-new-set"]').trigger('click');
        modifySetList(action, $__master, $__elPopup, $elSet, setUUID, objType, objURL, $elSet.hasClass('is-current'));
      }
    }).on('keydown', function (e) {
      if (!window.setCreator) return true;
      var event = e.originalEvent || e;

      if (event.key === 'Escape') {
        setTimeout(function () {
          $(window.setCreator).find('[data-action="cancel-new-set"]').trigger('click');
        }, 100);
        return false;
      }

      if (event.key === 'Enter') {
        $(window.setCreator).find('[data-action="save-new-set"]').trigger('click');
        return false;
      }

      return true;
    });
  }

  var modifySetList = function modifySetList(action, $__master, $__elPopup, $elSet, setUUID, objType, objURL, isCurrent) {
    var self = this;
    $__elPopup.addClass('is-loading');
    jQuery.ajax({
      context: self,
      type: 'POST',
      url: '/text/set/',
      data: {
        action: action,
        uuid: setUUID,
        objtype: objType,
        objurl: objURL,
        source: 'list-popup'
      }
    }).always(function (e) {
      $__elPopup.removeClass('is-loading');
    }).done(function (e) {
      var res;

      try {
        res = JSON.parse(e);
      } catch (E) {
        res = {};
      }

      if (res.result === 'OK') {
        $elSet[action === 'additem' ? 'addClass' : 'removeClass']('is-active');
        $__master[res.setscount ? 'addClass' : 'removeClass']('is-added');

        if (isCurrent) {
          var recordItem = $__master.closest('.item');
          recordItem[action === 'additem' ? 'removeClass' : 'addClass']('is-deleted');
        }
      }
    }).fail(function (e) {
      return e;
    });
  };

  var addSet = function addSet($__master, $__elPopup, $elSetBox, $elSetList, $szTitle) {
    var self = this;
    $__elPopup.addClass('is-loading');
    jQuery.ajax({
      type: 'POST',
      url: '/text/set/',
      data: {
        action: 'addset',
        title: $szTitle
      }
    }).always(function (e) {
      $__elPopup.addClass('is-loading');
      setTimeout(function () {
        $(window.setCreator).find('[data-action="cancel-new-set"]').trigger('click');
        self.resizeInfoBox();
      }, 20);
    }).done(function (e) {
      var res, $setBoxes, $elNewSet;

      try {
        res = JSON.parse(e);
      } catch (E) {
        res = {};
      }

      if (res.result === 'OK') {
        $elNewSet = $('<div data-created="1" data-set="' + res.uuid + '"></div>').text(res.title);
        $elNewSet.insertBefore('[data-set-list] [data-set-new-form]');
        setTimeout(function () {
          $__elPopup.find('[data-created]').css({
            opacity: 1
          });
          $(window.setCreator).find('[data-set="' + res.uuid + '"]').trigger('click');
          repositionPopup($__master, $__elPopup);
        }, 10);
      } else {}
    }).fail(function (e) {});
  };
  /**
   * LOAD SETS -- RPC CALL
   * @param $__master
   * @param $__elPopup
   */


  function loadPopupSets($__master, $__elPopup) {
    $__elPopup.addClass('is-loading');
    var $phSets = $__elPopup.find('.ph');
    $phSets.empty(); // Append Current Set

    var $curSet = $('[data-type="set-title"][data-uuid]'),
        curSetUUID = $curSet.get(0) ? $curSet.data('uuid') : '',
        curURL = location.pathname,
        curQuery = location.search.replace(/\?/ig, '').replace(/&/ig, '@');
    jQuery.ajax({
      context: $__master,
      type: 'POST',
      url: '/text/set/',
      data: {
        action: 'loadsets',
        objurl: $__master.data('url'),
        source: 'list-popup',
        cursetuuid: curSetUUID,
        cururl: curURL,
        curquery: curQuery
      }
    }).always(function (e) {
      setTimeout(function () {
        $__elPopup.removeClass('is-loading');
      }, 250);
    }).done(function (e) {
      var res;
      $phSets.html(e);
      repositionPopup($__master, $__elPopup);

      try {
        res = JSON.parse(e);
      } catch (E) {
        res = {};
      }

      if (res.result) {} else {}

      setTimeout(function () {
        $__elPopup.find('[data-autoresize]').autoresize({
          padding: 0,
          minWidth: 71,
          "class": 'acc-popupset-resizer'
        });
      }, 5);
    }).fail(function (e) {});
  }
  /**
   *
   * @param $__master
   * @param $__elPopup
   */


  function repositionPopup($__master, $__elPopup) {
    requestAnimationFrame(function () {
      var rectHandler = $__master.get(0).getBoundingClientRect(),
          rectList = $elPackagesList.get(0).getBoundingClientRect(),
          rectEl = $__elPopup.get(0).getBoundingClientRect(),
          xMargin = window.isMobile ? 0 : Math.floor($elPackagesList.cssInt('padding-left') / 1.5),
          popupDir = rectHandler.y < Math.max(rectEl.height, 200) ? 'bottom' : 'top',
          shiftX = 0; // MOVE

      $__elPopup.position($__master, popupDir === 'top' ? {
        anchor: ['bc', 'tc'],
        offset: [0, -8]
      } : {
        anchor: ['tc', 'bc'],
        offset: [0, 8]
      });
      $__elPopup.css({
        'margin-left': 0,
        'position': ''
      });
      $__elPopup[popupDir === 'top' ? 'addClass' : 'removeClass']('to-top'); // ADJUST HORIZONTALLY

      rectEl = $__elPopup.get(0).getBoundingClientRect();

      if (window.isMobile) {
        shiftX = rectList.right - rectEl.right - 14;
      } else {
        if (rectEl.right + xMargin >= rectList.right) {
          shiftX = rectList.right - rectEl.right - xMargin;
        } else if (rectEl.left - xMargin <= rectList.left) {
          shiftX = rectList.left - rectEl.left + xMargin;
        }
      }

      $__elPopup.css('margin-left', shiftX).removeClass('is-hidden no-events').find('dl').css('margin-left', -shiftX);
      $__master.data('timershow', null);
    });
  }

  function clearPopupTimers($obj) {
    clearTimeout($obj.data('timershow'));
    clearTimeout($obj.data('timerhide'));
    clearTimeout($obj.data('timerdestroy'));
  }

  function killPopups() {
    $elShowLibDesc.data('popup', null);
    $('[data-popup-sets]').remove();
  }

  $(window).on('resize', function () {
    clearTimeout(timerPopup);
    timerPopup = setTimeout(killPopups, 10);
  });
});
/**
 * jMathEdu System Core v 2.0 -- SCROLLERS
 *
 * Last Mod Date: 2019-09-15
 */

/*
	jQuery.fn.scrollIntoViewCentered = function ( objContainer, objDoc, smooth, gapY ) {
		if ( !this || !$( this )[ 0 ] ) return null;

		if ( typeof objContainer === 'undefined' ) objContainer = window;
		if ( typeof objDoc === 'undefined' ) objDoc = document;
		if ( typeof smooth === 'undefined' ) smooth = 0;
		if ( typeof gapY === 'undefined' ) gapY = 0;

		var $parentElement = this.getScrollParent( false, objDoc );
		var viewportHeight = Math.ceil( $parentElement[ 0 ].offsetHeight || 0 );
		var targetElement = this[ 0 ];

		var scrollY = ( targetElement.offsetHeight < viewportHeight )
			? ( ( targetElement.offsetTop + ( targetElement.offsetHeight >> 1 ) - ( viewportHeight >> 1 ) ) || 0 )
			: ( targetElement.offsetTop - gapY || 0 );

		objContainer[ 0 ].deflectScrollEvent = true;

		if ( !smooth ) $parentElement.scrollTop( scrollY ); else $parentElement.animate( { scrollTop: scrollY }, smooth );

		window.setTimeout( function () { objContainer[ 0 ].deflectScrollEvent = false; }, smooth * 2 );
	};
	*/
function scrollToView(element, parent) {
  element = $(element);
  parent = $(parent);
  if (!element.get(0)) return false;
  var timeAnim = 50,
      elOffset = (element && element.offset() ? element.offset().top : 0) + (parent && parent.scrollTop() ? parent.scrollTop() : 0),
      elHeight = element.innerHeight(),
      elOffsetEnd = elOffset + elHeight,
      vpStart = parent.scrollTop(),
      vpEnd = vpStart + parent.innerHeight();

  if (!element.is(':visible')) {
    element.css({
      'visibility': 'hidden'
    }).show();
    elOffset = element.offset() ? element.offset().top : 0;
    element.css({
      'visibility': '',
      'display': ''
    });
  }

  if (elOffset - elHeight < vpStart) {
    parent.animate({
      scrollTop: elOffset - elHeight
    }, timeAnim);
    return false;
  } else if (elOffsetEnd > vpEnd) {
    parent.animate({
      scrollTop: parent.scrollTop() + elOffsetEnd - vpEnd
    }, timeAnim);
    return false;
  }

  return true;
}
/**
 * jMathEdu System Core v 2.0 -- TIPS AND HINTS
 *
 * Last Mod Date: 2019-09-15
 */
$(function () {
  // OBJECT TIP (EX.: AUTHOR PHOTO)
  jQuery.each($('.is-tipped'), function (idx, tip) {
    $(tip).data('powertiptarget', '[data-rel="' + $(tip).data('src') + '"]');
    $(tip).powerTip({
      followMouse: true
      /*, mouseOnToPopup: true, placement: 'e' */

    });
  }); // MISC TIPS (PROFILE/LOGIN/..)

  $('.is-core-tip').powerTip({
    followMouse: false,
    smartPlacement: true,
    popupClass: 'help-core-tip',
    mouseOnToPopup: true,
    offset: 6,
    placement: 's'
  }); //jQuery.each( $tips, function ( idx, tip ) {
  //	$( tip ).data( 'powertiptarget', '[data-rel="' + $( tip ).data( 'src' ) + '"]' );
  //	$( tip ).powerTip( { followMouse: true/*, mouseOnToPopup: true, placement: 'e' */ } );
  //} );
  //$( '.is-tipped img' )
  //	.powerTip( {
  //		           followMouse: true
  //	           } );
});
$(function () {
  var dlgCookie, selDlgCookie;
  if (!(dlgCookie = $(selDlgCookie = '[data-dialog="cookie-accept"]')).get(0)) return false;
  dlgCookie.on('click', '[data-action="acceptcookie"]', function (e) {
    var $this = $(e.target);
    jQuery.ajax({
      context: $this,
      type: 'POST',
      url: '/rpc/',
      data: {
        action: 'acceptcookie'
      }
    }).always(function (e) {}).done(function (e) {
      dlgCookie.removeClass('is-visible');
    }).fail(function (e) {});
  });
  setTimeout(function () {
    dlgCookie.addClass('is-visible');
  }, 100);
});
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/*
* iziToast | v1.4.0
* http://izitoast.marcelodolce.com
* by Marcelo Dolce.
*/
(function (root, factory) {
  if (typeof define === 'function' && define.amd) {
    define([], factory(root));
  } else if ((typeof exports === "undefined" ? "undefined" : _typeof(exports)) === 'object') {
    module.exports = factory(root);
  } else {
    root.iziToast = factory(root);
  }
})(typeof global !== 'undefined' ? global : window || this.window || this.global, function (root) {
  'use strict'; //
  // Variables
  //

  var $iziToast = {},
      PLUGIN_NAME = 'iziToast',
      BODY = document.querySelector('body'),
      ISMOBILE = /Mobi/.test(navigator.userAgent),
      ISCHROME = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor),
      ISFIREFOX = typeof InstallTrigger !== 'undefined',
      ACCEPTSTOUCH = 'ontouchstart' in document.documentElement,
      POSITIONS = ['bottomRight', 'bottomLeft', 'bottomCenter', 'topRight', 'topLeft', 'topCenter', 'center'],
      THEMES = {
    info: {
      color: 'blue',
      icon: 'ico-info'
    },
    success: {
      color: 'green',
      icon: 'ico-success'
    },
    warning: {
      color: 'orange',
      icon: 'ico-warning'
    },
    error: {
      color: 'red',
      icon: 'ico-error'
    },
    question: {
      color: 'yellow',
      icon: 'ico-question'
    }
  },
      MOBILEWIDTH = 568,
      CONFIG = {};
  $iziToast.children = {}; // Default settings

  var defaults = {
    id: null,
    "class": '',
    title: '',
    titleColor: '',
    titleSize: '',
    titleLineHeight: '',
    message: '',
    messageColor: '',
    messageSize: '',
    messageLineHeight: '',
    backgroundColor: '',
    theme: 'light',
    // dark
    color: '',
    // blue, red, green, yellow
    icon: '',
    iconText: '',
    iconColor: '',
    iconUrl: null,
    image: '',
    imageWidth: 50,
    maxWidth: null,
    zindex: null,
    layout: 1,
    balloon: false,
    close: true,
    closeOnEscape: false,
    closeOnClick: false,
    displayMode: 0,
    position: 'bottomRight',
    // bottomRight, bottomLeft, topRight, topLeft, topCenter, bottomCenter, center
    target: '',
    targetFirst: true,
    timeout: 5000,
    rtl: false,
    animateInside: true,
    drag: true,
    pauseOnHover: true,
    resetOnHover: false,
    progressBar: true,
    progressBarColor: '',
    progressBarEasing: 'linear',
    overlay: false,
    overlayClose: false,
    overlayColor: 'rgba(0, 0, 0, 0.6)',
    transitionIn: 'fadeInUp',
    // bounceInLeft, bounceInRight, bounceInUp, bounceInDown, fadeIn, fadeInDown, fadeInUp, fadeInLeft, fadeInRight, flipInX
    transitionOut: 'fadeOut',
    // fadeOut, fadeOutUp, fadeOutDown, fadeOutLeft, fadeOutRight, flipOutX
    transitionInMobile: 'fadeInUp',
    transitionOutMobile: 'fadeOutDown',
    buttons: {},
    inputs: {},
    onOpening: function onOpening() {},
    onOpened: function onOpened() {},
    onClosing: function onClosing() {},
    onClosed: function onClosed() {}
  }; //
  // Methods
  //

  /**
   * Polyfill for remove() method
   */

  if (!('remove' in Element.prototype)) {
    Element.prototype.remove = function () {
      if (this.parentNode) {
        this.parentNode.removeChild(this);
      }
    };
  }
  /*
      * Polyfill for CustomEvent for IE >= 9
      * https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent/CustomEvent#Polyfill
      */


  if (typeof window.CustomEvent !== 'function') {
    var CustomEventPolyfill = function CustomEventPolyfill(event, params) {
      params = params || {
        bubbles: false,
        cancelable: false,
        detail: undefined
      };
      var evt = document.createEvent('CustomEvent');
      evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
      return evt;
    };

    CustomEventPolyfill.prototype = window.Event.prototype;
    window.CustomEvent = CustomEventPolyfill;
  }
  /**
   * A simple forEach() implementation for Arrays, Objects and NodeLists
   * @private
   * @param {Array|Object|NodeList} collection Collection of items to iterate
   * @param {Function} callback Callback function for each iteration
   * @param {Array|Object|NodeList} scope Object/NodeList/Array that forEach is iterating over (aka `this`)
   */


  var forEach = function forEach(collection, callback) {
    var scope = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

    if (Object.prototype.toString.call(collection) === '[object Object]') {
      for (var prop in collection) {
        if (Object.prototype.hasOwnProperty.call(collection, prop)) {
          callback.call(scope, collection[prop], prop, collection);
        }
      }
    } else {
      if (collection) {
        for (var i = 0, len = collection.length; i < len; i++) {
          callback.call(scope, collection[i], i, collection);
        }
      }
    }
  };
  /**
   * Merge defaults with user options
   * @private
   * @param {Object} defaults Default settings
   * @param {Object} options User options
   * @returns {Object} Merged values of defaults and options
   */


  var extend = function extend(defaults, options) {
    var extended = {};
    forEach(defaults, function (value, prop) {
      extended[prop] = defaults[prop];
    });
    forEach(options, function (value, prop) {
      extended[prop] = options[prop];
    });
    return extended;
  };
  /**
   * Create a fragment DOM elements
   * @private
   */


  var createFragElem = function createFragElem(htmlStr) {
    var frag = document.createDocumentFragment(),
        temp = document.createElement('div');
    temp.innerHTML = htmlStr;

    while (temp.firstChild) {
      frag.appendChild(temp.firstChild);
    }

    return frag;
  };
  /**
   * Generate new ID
   * @private
   */


  var generateId = function generateId(params) {
    var newId = btoa(encodeURIComponent(params)); //newId = btoa ( String((Date.now ? Date.now() : new Date().getTime()) / 1000 ));

    return newId.replace(/=/g, "");
  };
  /**
   * Check if is a color
   * @private
   */


  var isColor = function isColor(color) {
    return color.substring(0, 1) === '#' || color.substring(0, 3) === 'rgb' || color.substring(0, 3) === 'hsl';
  };
  /**
   * Check if is a Base64 string
   * @private
   */


  var isBase64 = function isBase64(str) {
    try {
      return btoa(atob(str)) === str;
    } catch (err) {
      return false;
    }
  };
  /**
   * Drag method of toasts
   * @private
   */


  var drag = function () {
    return {
      move: function move(toast, instance, settings, xpos) {
        var opacity,
            opacityRange = 0.3,
            distance = 180;

        if (xpos !== 0) {
          toast.classList.add(PLUGIN_NAME + '-dragged');
          toast.style.transform = 'translateX(' + xpos + 'px)';

          if (xpos > 0) {
            opacity = (distance - xpos) / distance;

            if (opacity < opacityRange) {
              instance.hide(extend(settings, {
                transitionOut: 'fadeOutRight',
                transitionOutMobile: 'fadeOutRight'
              }), toast, 'drag');
            }
          } else {
            opacity = (distance + xpos) / distance;

            if (opacity < opacityRange) {
              instance.hide(extend(settings, {
                transitionOut: 'fadeOutLeft',
                transitionOutMobile: 'fadeOutLeft'
              }), toast, 'drag');
            }
          }

          toast.style.opacity = opacity;

          if (opacity < opacityRange) {
            if (ISCHROME || ISFIREFOX) toast.style.left = xpos + 'px';
            toast.parentNode.style.opacity = opacityRange;
            this.stopMoving(toast);
          }
        }
      },
      startMoving: function startMoving(toast, instance, settings, e) {
        e = e || window.event;
        var posX = ACCEPTSTOUCH ? e.touches[0].clientX : e.clientX,
            toastLeft = toast.style.transform.replace('px)', '');
        toastLeft = toastLeft.replace('translateX(', '');
        var offsetX = posX - toastLeft;

        if (settings.transitionIn) {
          toast.classList.remove(settings.transitionIn);
        }

        if (settings.transitionInMobile) {
          toast.classList.remove(settings.transitionInMobile);
        }

        toast.style.transition = '';

        if (ACCEPTSTOUCH) {
          document.ontouchmove = function (e) {
            e.preventDefault();
            e = e || window.event;
            var posX = e.touches[0].clientX,
                finalX = posX - offsetX;
            drag.move(toast, instance, settings, finalX);
          };
        } else {
          document.onmousemove = function (e) {
            e.preventDefault();
            e = e || window.event;
            var posX = e.clientX,
                finalX = posX - offsetX;
            drag.move(toast, instance, settings, finalX);
          };
        }
      },
      stopMoving: function stopMoving(toast) {
        if (ACCEPTSTOUCH) {
          document.ontouchmove = function () {};
        } else {
          document.onmousemove = function () {};
        }

        toast.style.opacity = '';
        toast.style.transform = '';

        if (toast.classList.contains(PLUGIN_NAME + '-dragged')) {
          toast.classList.remove(PLUGIN_NAME + '-dragged');
          toast.style.transition = 'transform 0.4s ease, opacity 0.4s ease';
          setTimeout(function () {
            toast.style.transition = '';
          }, 400);
        }
      }
    };
  }();

  $iziToast.setSetting = function (ref, option, value) {
    $iziToast.children[ref][option] = value;
  };

  $iziToast.getSetting = function (ref, option) {
    return $iziToast.children[ref][option];
  };
  /**
   * Destroy the current initialization.
   * @public
   */


  $iziToast.destroy = function () {
    forEach(document.querySelectorAll('.' + PLUGIN_NAME + '-overlay'), function (element) {
      element.remove();
    });
    forEach(document.querySelectorAll('.' + PLUGIN_NAME + '-wrapper'), function (element) {
      element.remove();
    });
    forEach(document.querySelectorAll('.' + PLUGIN_NAME), function (element) {
      element.remove();
    });
    this.children = {}; // Remove event listeners

    document.removeEventListener(PLUGIN_NAME + '-opened', {}, false);
    document.removeEventListener(PLUGIN_NAME + '-opening', {}, false);
    document.removeEventListener(PLUGIN_NAME + '-closing', {}, false);
    document.removeEventListener(PLUGIN_NAME + '-closed', {}, false);
    document.removeEventListener('keyup', {}, false); // Reset variables

    CONFIG = {};
  };
  /**
   * Initialize Plugin
   * @public
   * @param {Object} options User settings
   */


  $iziToast.settings = function (options) {
    // Destroy any existing initializations
    $iziToast.destroy();
    CONFIG = options;
    defaults = extend(defaults, options || {});
  };
  /**
   * Building themes functions.
   * @public
   * @param {Object} options User settings
   */


  forEach(THEMES, function (theme, name) {
    $iziToast[name] = function (options) {
      var settings = extend(CONFIG, options || {});
      settings = extend(theme, settings || {});
      this.show(settings);
    };
  });
  /**
   * Do the calculation to move the progress bar
   * @private
   */

  $iziToast.progress = function (options, $toast, callback) {
    var that = this,
        ref = $toast.getAttribute('data-iziToast-ref'),
        settings = extend(this.children[ref], options || {}),
        $elem = $toast.querySelector('.' + PLUGIN_NAME + '-progressbar div');
    return {
      start: function start() {
        if (typeof settings.time.REMAINING == 'undefined') {
          $toast.classList.remove(PLUGIN_NAME + '-reseted');

          if ($elem !== null) {
            $elem.style.transition = 'width ' + settings.timeout + 'ms ' + settings.progressBarEasing;
            $elem.style.width = '0%';
          }

          settings.time.START = new Date().getTime();
          settings.time.END = settings.time.START + settings.timeout;
          settings.time.TIMER = setTimeout(function () {
            clearTimeout(settings.time.TIMER);

            if (!$toast.classList.contains(PLUGIN_NAME + '-closing')) {
              that.hide(settings, $toast, 'timeout');

              if (typeof callback === 'function') {
                callback.apply(that);
              }
            }
          }, settings.timeout);
          that.setSetting(ref, 'time', settings.time);
        }
      },
      pause: function pause() {
        if (typeof settings.time.START !== 'undefined' && !$toast.classList.contains(PLUGIN_NAME + '-paused') && !$toast.classList.contains(PLUGIN_NAME + '-reseted')) {
          $toast.classList.add(PLUGIN_NAME + '-paused');
          settings.time.REMAINING = settings.time.END - new Date().getTime();
          clearTimeout(settings.time.TIMER);
          that.setSetting(ref, 'time', settings.time);

          if ($elem !== null) {
            var computedStyle = window.getComputedStyle($elem),
                propertyWidth = computedStyle.getPropertyValue('width');
            $elem.style.transition = 'none';
            $elem.style.width = propertyWidth;
          }

          if (typeof callback === 'function') {
            setTimeout(function () {
              callback.apply(that);
            }, 10);
          }
        }
      },
      resume: function resume() {
        if (typeof settings.time.REMAINING !== 'undefined') {
          $toast.classList.remove(PLUGIN_NAME + '-paused');

          if ($elem !== null) {
            $elem.style.transition = 'width ' + settings.time.REMAINING + 'ms ' + settings.progressBarEasing;
            $elem.style.width = '0%';
          }

          settings.time.END = new Date().getTime() + settings.time.REMAINING;
          settings.time.TIMER = setTimeout(function () {
            clearTimeout(settings.time.TIMER);

            if (!$toast.classList.contains(PLUGIN_NAME + '-closing')) {
              that.hide(settings, $toast, 'timeout');

              if (typeof callback === 'function') {
                callback.apply(that);
              }
            }
          }, settings.time.REMAINING);
          that.setSetting(ref, 'time', settings.time);
        } else {
          this.start();
        }
      },
      reset: function reset() {
        clearTimeout(settings.time.TIMER);
        delete settings.time.REMAINING;
        that.setSetting(ref, 'time', settings.time);
        $toast.classList.add(PLUGIN_NAME + '-reseted');
        $toast.classList.remove(PLUGIN_NAME + '-paused');

        if ($elem !== null) {
          $elem.style.transition = 'none';
          $elem.style.width = '100%';
        }

        if (typeof callback === 'function') {
          setTimeout(function () {
            callback.apply(that);
          }, 10);
        }
      }
    };
  };
  /**
   * Close the specific Toast
   * @public
   * @param {Object} options User settings
   * @param $toast
   * @param closedBy
   */


  $iziToast.hide = function (options, $toast, closedBy) {
    if (_typeof($toast) != 'object') {
      $toast = document.querySelector($toast ? $toast : '.' + PLUGIN_NAME);
    }

    if (!$toast) return false;
    var that = this,
        settings = extend(this.children[$toast.getAttribute('data-iziToast-ref')], options || {});
    settings.closedBy = closedBy || null;
    delete settings.time.REMAINING;
    $toast.classList.add(PLUGIN_NAME + '-closing'); // Overlay

    (function () {
      var $overlay = document.querySelector('.' + PLUGIN_NAME + '-overlay');

      if ($overlay !== null) {
        var refs = $overlay.getAttribute('data-iziToast-ref');
        refs = refs.split(',');
        var index = refs.indexOf(String(settings.ref));

        if (index !== -1) {
          refs.splice(index, 1);
        }

        $overlay.setAttribute('data-iziToast-ref', refs.join());

        if (refs.length === 0) {
          $overlay.classList.remove('fadeIn');
          $overlay.classList.add('fadeOut');
          setTimeout(function () {
            $overlay.remove();
          }, 700);
        }
      }
    })();

    if (settings.transitionIn) {
      $toast.classList.remove(settings.transitionIn);
    }

    if (settings.transitionInMobile) {
      $toast.classList.remove(settings.transitionInMobile);
    }

    if (ISMOBILE || window.innerWidth <= MOBILEWIDTH) {
      if (settings.transitionOutMobile) $toast.classList.add(settings.transitionOutMobile);
    } else {
      if (settings.transitionOut) $toast.classList.add(settings.transitionOut);
    }

    var H = $toast.parentNode.offsetHeight;
    $toast.parentNode.style.height = H + 'px';
    $toast.style.pointerEvents = 'none';

    if (!ISMOBILE || window.innerWidth > MOBILEWIDTH) {
      $toast.parentNode.style.transitionDelay = '0.2s';
    }

    try {
      var event = new CustomEvent(PLUGIN_NAME + '-closing', {
        detail: settings,
        bubbles: true,
        cancelable: true
      });
      document.dispatchEvent(event);
    } catch (ex) {
      console.warn(ex);
    }

    setTimeout(function () {
      $toast.parentNode.style.height = '0px';
      $toast.parentNode.style.overflow = '';
      setTimeout(function () {
        delete that.children[settings.ref];
        $toast.parentNode.remove();

        try {
          var event = new CustomEvent(PLUGIN_NAME + '-closed', {
            detail: settings,
            bubbles: true,
            cancelable: true
          });
          document.dispatchEvent(event);
        } catch (ex) {
          console.warn(ex);
        }

        if (typeof settings.onClosed !== 'undefined') {
          settings.onClosed.apply(null, [settings, $toast, closedBy]);
        }
      }, 1000);
    }, 200);

    if (typeof settings.onClosing !== 'undefined') {
      settings.onClosing.apply(null, [settings, $toast, closedBy]);
    }
  };
  /**
   * Create and show the Toast
   * @public
   * @param {Object} options User settings
   */


  $iziToast.show = function (options) {
    var that = this; // Merge user options with defaults

    var settings = extend(CONFIG, options || {});
    settings = extend(defaults, settings);
    settings.time = {};

    if (settings.id === null) {
      settings.id = generateId(settings.title + settings.message + settings.color);
    }

    if (settings.displayMode === 1 || settings.displayMode === 'once') {
      try {
        if (document.querySelectorAll('.' + PLUGIN_NAME + '#' + settings.id).length > 0) {
          return false;
        }
      } catch (exc) {
        console.warn('[' + PLUGIN_NAME + '] Could not find an element with this selector: ' + '#' + settings.id + '. Try to set an valid id.');
      }
    }

    if (settings.displayMode === 2 || settings.displayMode === 'replace') {
      //console.error( ( '.' + PLUGIN_NAME + '#' + settings.id ) );
      //console.warn(document.querySelectorAll( '.' + PLUGIN_NAME + '#' + settings.id ));
      //console.warn(document.querySelectorAll( '.' + PLUGIN_NAME + '#' + settings.id ));
      try {
        //forEach( document.querySelectorAll( '.' + PLUGIN_NAME + '#' + settings.id ), function ( element) {
        forEach(document.querySelectorAll('.' + PLUGIN_NAME
        /*+ '#' + settings.id*/
        ), function (element) {
          that.hide(settings, element, 'replaced');
        });
      } catch (exc) {
        console.warn('[' + PLUGIN_NAME + '] Could not find an element with this selector: ' + '#' + settings.id + '. Try to set an valid id.');
      }
    }

    settings.ref = new Date().getTime() + Math.floor(Math.random() * 10000000 + 1);
    $iziToast.children[settings.ref] = settings;
    var $DOM = {
      body: document.querySelector('body'),
      overlay: document.createElement('div'),
      toast: document.createElement('div'),
      toastBody: document.createElement('div'),
      toastTexts: document.createElement('div'),
      toastCapsule: document.createElement('div'),
      cover: document.createElement('div'),
      buttons: document.createElement('div'),
      inputs: document.createElement('div'),
      icon: !settings.iconUrl ? document.createElement('i') : document.createElement('img'),
      wrapper: null
    };
    $DOM.toast.setAttribute('data-iziToast-ref', settings.ref);
    $DOM.toast.appendChild($DOM.toastBody);
    $DOM.toastCapsule.appendChild($DOM.toast); // CSS Settings

    (function () {
      $DOM.toast.classList.add(PLUGIN_NAME);
      $DOM.toast.classList.add(PLUGIN_NAME + '-opening');
      $DOM.toastCapsule.classList.add(PLUGIN_NAME + '-capsule');
      $DOM.toastBody.classList.add(PLUGIN_NAME + '-body');
      $DOM.toastTexts.classList.add(PLUGIN_NAME + '-texts');

      if (ISMOBILE || window.innerWidth <= MOBILEWIDTH) {
        if (settings.transitionInMobile) $DOM.toast.classList.add(settings.transitionInMobile);
      } else {
        if (settings.transitionIn) $DOM.toast.classList.add(settings.transitionIn);
      }

      if (settings["class"]) {
        var classes = settings["class"].split(' ');
        forEach(classes, function (value) {
          $DOM.toast.classList.add(value);
        });
      }

      if (settings.id) {
        $DOM.toast.id = settings.id;
      }

      if (settings.rtl) {
        $DOM.toast.classList.add(PLUGIN_NAME + '-rtl');
        $DOM.toast.setAttribute('dir', 'rtl');
      }

      if (settings.layout > 1) {
        $DOM.toast.classList.add(PLUGIN_NAME + '-layout' + settings.layout);
      }

      if (settings.balloon) {
        $DOM.toast.classList.add(PLUGIN_NAME + '-balloon');
      }

      if (settings.maxWidth) {
        if (!isNaN(settings.maxWidth)) {
          $DOM.toast.style.maxWidth = settings.maxWidth + 'px';
        } else {
          $DOM.toast.style.maxWidth = settings.maxWidth;
        }
      }

      if (settings.theme !== '' || settings.theme !== 'light') {
        $DOM.toast.classList.add(PLUGIN_NAME + '-theme-' + settings.theme);
      }

      if (settings.color) {
        //#, rgb, rgba, hsl
        if (isColor(settings.color)) {
          $DOM.toast.style.background = settings.color;
        } else {
          $DOM.toast.classList.add(PLUGIN_NAME + '-color-' + settings.color);
        }
      }

      if (settings.backgroundColor) {
        $DOM.toast.style.background = settings.backgroundColor;

        if (settings.balloon) {
          $DOM.toast.style.borderColor = settings.backgroundColor;
        }
      }
    })(); // Cover image


    (function () {
      if (settings.image) {
        $DOM.cover.classList.add(PLUGIN_NAME + '-cover');
        $DOM.cover.style.width = settings.imageWidth + 'px';

        if (isBase64(settings.image.replace(/ /g, ''))) {
          $DOM.cover.style.backgroundImage = 'url(data:image/png;base64,' + settings.image.replace(/ /g, '') + ')';
        } else {
          $DOM.cover.style.backgroundImage = 'url(' + settings.image + ')';
        }

        if (settings.rtl) {
          $DOM.toastBody.style.marginRight = settings.imageWidth + 10 + 'px';
        } else {
          $DOM.toastBody.style.marginLeft = settings.imageWidth + 10 + 'px';
        }

        $DOM.toast.appendChild($DOM.cover);
      }
    })(); // Button close


    (function () {
      if (settings.close) {
        $DOM.buttonClose = document.createElement('button');
        $DOM.buttonClose.type = 'button';
        $DOM.buttonClose.classList.add(PLUGIN_NAME + '-close');
        $DOM.buttonClose.addEventListener('click', function (e) {
          that.hide(settings, $DOM.toast, 'button');
        });
        $DOM.toast.appendChild($DOM.buttonClose);
      } else {
        if (settings.rtl) {
          //$DOM.toast.style.paddingLeft = '18px';
          $DOM.toast.classList.add('no-close-button');
        } else {
          //$DOM.toast.style.paddingRight = '18px';
          $DOM.toast.classList.add('no-close-button');
        }
      }
    })(); // Progress Bar & Timeout


    (function () {
      if (settings.progressBar) {
        $DOM.progressBar = document.createElement('div');
        $DOM.progressBarDiv = document.createElement('div');
        $DOM.progressBar.classList.add(PLUGIN_NAME + '-progressbar');
        $DOM.progressBarDiv.style.background = settings.progressBarColor;
        $DOM.progressBar.appendChild($DOM.progressBarDiv);
        $DOM.toast.appendChild($DOM.progressBar);
      }

      if (settings.timeout) {
        if (settings.pauseOnHover && !settings.resetOnHover) {
          $DOM.toast.addEventListener('mouseenter', function () {
            that.progress(settings, $DOM.toast).pause();
          });
          $DOM.toast.addEventListener('mouseleave', function () {
            that.progress(settings, $DOM.toast).resume();
          });
        }

        if (settings.resetOnHover) {
          $DOM.toast.addEventListener('mouseenter', function () {
            that.progress(settings, $DOM.toast).reset();
          });
          $DOM.toast.addEventListener('mouseleave', function () {
            that.progress(settings, $DOM.toast).start();
          });
        }
      }
    })(); // Icon


    (function () {
      if (settings.iconUrl) {
        $DOM.icon.setAttribute('class', PLUGIN_NAME + '-icon');
        $DOM.icon.setAttribute('src', settings.iconUrl);
      } else if (settings.icon) {
        $DOM.icon.setAttribute('class', PLUGIN_NAME + '-icon ' + settings.icon);

        if (settings.iconText) {
          $DOM.icon.appendChild(document.createTextNode(settings.iconText));
        }

        if (settings.iconColor) {
          $DOM.icon.style.color = settings.iconColor;
        }
      }

      if (settings.icon || settings.iconUrl) {
        if (settings.rtl) {
          $DOM.toastBody.classList.add('has-icon'); //$DOM.toastBody.style.paddingRight = '33px';
        } else {
          $DOM.toastBody.classList.add('has-icon'); //$DOM.toastBody.style.paddingLeft = '33px';
        }

        $DOM.toastBody.appendChild($DOM.icon);
      }
    })(); // Title & Message


    (function () {
      if (settings.title.length > 0) {
        $DOM.strong = document.createElement('strong');
        $DOM.strong.classList.add(PLUGIN_NAME + '-title');
        $DOM.strong.appendChild(createFragElem(settings.title));
        $DOM.toastTexts.appendChild($DOM.strong);

        if (settings.titleColor) {
          $DOM.strong.style.color = settings.titleColor;
        }

        if (settings.titleSize) {
          if (!isNaN(settings.titleSize)) {
            $DOM.strong.style.fontSize = settings.titleSize + 'px';
          } else {
            $DOM.strong.style.fontSize = settings.titleSize;
          }
        }

        if (settings.titleLineHeight) {
          if (!isNaN(settings.titleSize)) {
            $DOM.strong.style.lineHeight = settings.titleLineHeight + 'px';
          } else {
            $DOM.strong.style.lineHeight = settings.titleLineHeight;
          }
        }
      }

      if (settings.message.length > 0) {
        $DOM.p = document.createElement('p');
        $DOM.p.classList.add(PLUGIN_NAME + '-message');
        $DOM.p.appendChild(createFragElem(settings.message));
        $DOM.toastTexts.appendChild($DOM.p);

        if (settings.messageColor) {
          $DOM.p.style.color = settings.messageColor;
        }

        if (settings.messageSize) {
          if (!isNaN(settings.titleSize)) {
            $DOM.p.style.fontSize = settings.messageSize + 'px';
          } else {
            $DOM.p.style.fontSize = settings.messageSize;
          }
        }

        if (settings.messageLineHeight) {
          if (!isNaN(settings.titleSize)) {
            $DOM.p.style.lineHeight = settings.messageLineHeight + 'px';
          } else {
            $DOM.p.style.lineHeight = settings.messageLineHeight;
          }
        }
      }

      if (settings.title.length > 0 && settings.message.length > 0) {
        if (settings.rtl) {
          $DOM.strong.style.marginLeft = '10px';
        } else if (settings.layout !== 2 && !settings.rtl) {
          $DOM.strong.style.marginRight = '10px';
        }
      }
    })();

    $DOM.toastBody.appendChild($DOM.toastTexts); // Inputs

    var $inputs;

    (function () {
      if (settings.inputs.length > 0) {
        $DOM.inputs.classList.add(PLUGIN_NAME + '-inputs');
        forEach(settings.inputs, function (value, index) {
          $DOM.inputs.appendChild(createFragElem(value[0]));
          $inputs = $DOM.inputs.childNodes;
          $inputs[index].classList.add(PLUGIN_NAME + '-inputs-child');

          if (value[3]) {
            setTimeout(function () {
              $inputs[index].focus();
            }, 300);
          }

          $inputs[index].addEventListener(value[1], function (e) {
            var ts = value[2];
            return ts(that, $DOM.toast, this, e);
          });
        });
        $DOM.toastBody.appendChild($DOM.inputs);
      }
    })(); // Buttons


    (function () {
      if (settings.buttons.length > 0) {
        $DOM.buttons.classList.add(PLUGIN_NAME + '-buttons');
        forEach(settings.buttons, function (value, index) {
          $DOM.buttons.appendChild(createFragElem(value[0]));
          var $btns = $DOM.buttons.childNodes;
          $btns[index].classList.add(PLUGIN_NAME + '-buttons-child');

          if (value[2]) {
            setTimeout(function () {
              $btns[index].focus();
            }, 300);
          }

          $btns[index].addEventListener('click', function (e) {
            e.preventDefault();
            var ts = value[1];
            return ts(that, $DOM.toast, this, e, $inputs);
          });
        });
      }

      $DOM.toastBody.appendChild($DOM.buttons);
    })();

    if (settings.message.length > 0 && (settings.inputs.length > 0 || settings.buttons.length > 0)) {
      $DOM.p.style.marginBottom = '0';
    }

    if (settings.inputs.length > 0 || settings.buttons.length > 0) {
      if (settings.rtl) {
        $DOM.toastTexts.style.marginLeft = '10px';
      } else {
        $DOM.toastTexts.style.marginRight = '10px';
      }

      if (settings.inputs.length > 0 && settings.buttons.length > 0) {
        if (settings.rtl) {
          $DOM.inputs.style.marginLeft = '8px';
        } else {
          $DOM.inputs.style.marginRight = '8px';
        }
      }
    } // Wrap


    (function () {
      $DOM.toastCapsule.style.visibility = 'hidden';
      setTimeout(function () {
        var H = $DOM.toast.offsetHeight;
        var style = $DOM.toast.currentStyle || window.getComputedStyle($DOM.toast);
        var marginTop = style.marginTop;
        marginTop = marginTop.split('px');
        marginTop = parseInt(marginTop[0]);
        var marginBottom = style.marginBottom;
        marginBottom = marginBottom.split('px');
        marginBottom = parseInt(marginBottom[0]);
        $DOM.toastCapsule.style.visibility = '';
        $DOM.toastCapsule.style.height = H + marginBottom + marginTop + 'px';
        setTimeout(function () {
          $DOM.toastCapsule.style.height = 'auto';

          if (settings.target) {
            $DOM.toastCapsule.style.overflow = 'visible';
          }
        }, 500);

        if (settings.timeout) {
          that.progress(settings, $DOM.toast).start();
        }
      }, 100);
    })(); // Target


    (function () {
      var position = settings.position;

      if (settings.target) {
        $DOM.wrapper = document.querySelector(settings.target);
        $DOM.wrapper.classList.add(PLUGIN_NAME + '-target');

        if (settings.targetFirst) {
          $DOM.wrapper.insertBefore($DOM.toastCapsule, $DOM.wrapper.firstChild);
        } else {
          $DOM.wrapper.appendChild($DOM.toastCapsule);
        }
      } else {
        if (POSITIONS.indexOf(settings.position) === -1) {
          console.warn('[' + PLUGIN_NAME + '] Incorrect position.\nIt can be › ' + POSITIONS);
          return;
        }

        if (ISMOBILE || window.innerWidth <= MOBILEWIDTH) {
          if (settings.position === 'bottomLeft' || settings.position === 'bottomRight' || settings.position === 'bottomCenter') {
            position = PLUGIN_NAME + '-wrapper-bottomCenter';
          } else if (settings.position === 'topLeft' || settings.position === 'topRight' || settings.position === 'topCenter') {
            position = PLUGIN_NAME + '-wrapper-topCenter';
          } else {
            position = PLUGIN_NAME + '-wrapper-center';
          }
        } else {
          position = PLUGIN_NAME + '-wrapper-' + position;
        }

        $DOM.wrapper = document.querySelector('.' + PLUGIN_NAME + '-wrapper.' + position);

        if (!$DOM.wrapper) {
          $DOM.wrapper = document.createElement('div');
          $DOM.wrapper.classList.add(PLUGIN_NAME + '-wrapper');
          $DOM.wrapper.classList.add(position);
          document.body.appendChild($DOM.wrapper);
        }

        if (settings.position === 'topLeft' || settings.position === 'topCenter' || settings.position === 'topRight') {
          $DOM.wrapper.insertBefore($DOM.toastCapsule, $DOM.wrapper.firstChild);
        } else {
          $DOM.wrapper.appendChild($DOM.toastCapsule);
        }
      }

      if (!isNaN(settings.zindex)) {
        $DOM.wrapper.style.zIndex = settings.zindex;
      } else {
        console.warn('[' + PLUGIN_NAME + '] Invalid zIndex.');
      }
    })(); // Overlay


    (function () {
      if (settings.overlay) {
        if (document.querySelector('.' + PLUGIN_NAME + '-overlay.fadeIn') !== null) {
          $DOM.overlay = document.querySelector('.' + PLUGIN_NAME + '-overlay');
          $DOM.overlay.setAttribute('data-iziToast-ref', $DOM.overlay.getAttribute('data-iziToast-ref') + ',' + settings.ref);

          if (!isNaN(settings.zindex) && settings.zindex !== null) {
            $DOM.overlay.style.zIndex = settings.zindex - 1;
          }
        } else {
          $DOM.overlay.classList.add(PLUGIN_NAME + '-overlay');
          $DOM.overlay.classList.add('fadeIn');
          $DOM.overlay.style.background = settings.overlayColor;
          $DOM.overlay.setAttribute('data-iziToast-ref', settings.ref);

          if (!isNaN(settings.zindex) && settings.zindex !== null) {
            $DOM.overlay.style.zIndex = settings.zindex - 1;
          }

          document.querySelector('body').appendChild($DOM.overlay);
        }

        if (settings.overlayClose) {
          $DOM.overlay.removeEventListener('click', {});
          $DOM.overlay.addEventListener('click', function () {
            that.hide(settings, $DOM.toast, 'overlay');
          });
        } else {
          $DOM.overlay.removeEventListener('click', {});
        }
      }
    })(); // Inside animations


    (function () {
      if (settings.animateInside) {
        $DOM.toast.classList.add(PLUGIN_NAME + '-animateInside');
        var animationTimes = [200, 100, 300];

        if (settings.transitionIn === 'bounceInLeft' || settings.transitionIn === 'bounceInRight') {
          animationTimes = [400, 200, 400];
        }

        if (settings.title.length > 0) {
          setTimeout(function () {
            $DOM.strong.classList.add('slideIn');
          }, animationTimes[0]);
        }

        if (settings.message.length > 0) {
          setTimeout(function () {
            $DOM.p.classList.add('slideIn');
          }, animationTimes[1]);
        }

        if (settings.icon || settings.iconUrl) {
          setTimeout(function () {
            $DOM.icon.classList.add('revealIn');
          }, animationTimes[2]);
        }

        var counter = 150;

        if (settings.buttons.length > 0 && $DOM.buttons) {
          setTimeout(function () {
            forEach($DOM.buttons.childNodes, function (element) {
              setTimeout(function () {
                element.classList.add('revealIn');
              }, counter);
              counter = counter + 150;
            });
          }, settings.inputs.length > 0 ? 150 : 0);
        }

        if (settings.inputs.length > 0 && $DOM.inputs) {
          counter = 150;
          forEach($DOM.inputs.childNodes, function (element) {
            setTimeout(function () {
              element.classList.add('revealIn');
            }, counter);
            counter = counter + 150;
          });
        }
      }
    })();

    settings.onOpening.apply(null, [settings, $DOM.toast]);

    try {
      var event = new CustomEvent(PLUGIN_NAME + '-opening', {
        detail: settings,
        bubbles: true,
        cancelable: true
      });
      document.dispatchEvent(event);
    } catch (ex) {
      console.warn(ex);
    }

    setTimeout(function () {
      $DOM.toast.classList.remove(PLUGIN_NAME + '-opening');
      $DOM.toast.classList.add(PLUGIN_NAME + '-opened');

      try {
        var event = new CustomEvent(PLUGIN_NAME + '-opened', {
          detail: settings,
          bubbles: true,
          cancelable: true
        });
        document.dispatchEvent(event);
      } catch (ex) {
        console.warn(ex);
      }

      settings.onOpened.apply(null, [settings, $DOM.toast]);
    }, 1000);

    if (settings.drag) {
      if (ACCEPTSTOUCH) {
        $DOM.toast.addEventListener('touchstart', function (e) {
          drag.startMoving(this, that, settings, e);
        }, false);
        $DOM.toast.addEventListener('touchend', function () {
          drag.stopMoving(this);
        }, false);
      } else {
        $DOM.toast.addEventListener('mousedown', function (e) {
          e.preventDefault();
          drag.startMoving(this, that, settings, e);
        }, false);
        $DOM.toast.addEventListener('mouseup', function (e) {
          e.preventDefault();
          drag.stopMoving(this);
        }, false);
      }
    }

    if (settings.closeOnEscape) {
      document.addEventListener('keyup', function (evt) {
        evt = evt || window.event;

        if (evt.keyCode === 27) {
          that.hide(settings, $DOM.toast, 'esc');
        }
      });
    }

    if (settings.closeOnClick) {
      $DOM.toast.addEventListener('click', function () {
        that.hide(settings, $DOM.toast, 'toast');
      });
    }

    that.toast = $DOM.toast;
  };

  return $iziToast;
});
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

(function (root, factory) {
  // support loading the plugin via common patterns
  if (typeof define === 'function' && define.amd) {
    // load the plugin as an amd module
    define(['jquery'], factory);
  } else if ((typeof module === "undefined" ? "undefined" : _typeof(module)) === 'object' && module.exports) {
    // load the plugin as a commonjs module
    module.exports = factory(require('jquery'));
  } else {
    // load the plugin as a global
    factory(root.jQuery);
  }
})(this, function ($) {
  // useful private variables
  var $document = $(document),
      $window = $(window),
      $body = $('body'); // constants

  var DATA_DISPLAYCONTROLLER = 'displayController',
      DATA_HASACTIVEHOVER = 'hasActiveHover',
      DATA_FORCEDOPEN = 'forcedOpen',
      DATA_HASMOUSEMOVE = 'hasMouseMove',
      DATA_MOUSEONTOTIP = 'mouseOnToPopup',
      DATA_ORIGINALTITLE = 'originalTitle',
      DATA_POWERTIP = 'powertip',
      DATA_POWERTIPJQ = 'powertipjq',
      DATA_POWERTIPTARGET = 'powertiptarget',
      EVENT_NAMESPACE = '.powertip',
      RAD2DEG = 180 / Math.PI,
      MOUSE_EVENTS = ['click', 'dblclick', 'mousedown', 'mouseup', 'mousemove', 'mouseover', 'mouseout', 'mouseenter', 'mouseleave', 'contextmenu'];
  /**
   * Session data
   * Private properties global to all powerTip instances
   */

  var session = {
    elements: null,
    tooltips: null,
    isTipOpen: false,
    isFixedTipOpen: false,
    isClosing: false,
    tipOpenImminent: false,
    activeHover: null,
    currentX: 0,
    currentY: 0,
    previousX: 0,
    previousY: 0,
    desyncTimeout: null,
    closeDelayTimeout: null,
    mouseTrackingActive: false,
    delayInProgress: false,
    windowWidth: 0,
    windowHeight: 0,
    scrollTop: 0,
    scrollLeft: 0
  };
  /**
   * Collision enumeration
   * @enum {number}
   */

  var Collision = {
    none: 0,
    top: 1,
    bottom: 2,
    left: 4,
    right: 8
  };
  /**
   * Display hover tooltips on the matched elements.
   * @param {(Object|string)=} opts The options object to use for the plugin, or
   *     the name of a method to invoke on the first matched element.
   * @param {*=} [arg] Argument for an invoked method (optional).
   * @return {jQuery} jQuery object for the matched selectors.
   */

  $.fn.powerTip = function (opts, arg) {
    var targetElements = this,
        options,
        tipController; // don't do any work if there were no matched elements

    if (!targetElements.length) {
      return targetElements;
    } // handle api method calls on the plugin, e.g. powerTip('hide')


    if ($.type(opts) === 'string' && $.powerTip[opts]) {
      return $.powerTip[opts].call(targetElements, targetElements, arg);
    } // extend options


    options = $.extend({}, $.fn.powerTip.defaults, opts); // handle repeated powerTip calls on the same element by destroying any
    // original instance hooked to it and replacing it with this call

    $.powerTip.destroy(targetElements); // instantiate the TooltipController for this instance

    tipController = new TooltipController(options); // hook mouse and viewport dimension tracking

    initTracking(); // setup the elements

    targetElements.each(function elementSetup() {
      var $this = $(this),
          dataPowertip = $this.data(DATA_POWERTIP),
          dataElem = $this.data(DATA_POWERTIPJQ),
          dataTarget = $this.data(DATA_POWERTIPTARGET),
          title = $this.attr('title'); // attempt to use title attribute text if there is no data-powertip,
      // data-powertipjq or data-powertiptarget. If we do use the title
      // attribute, delete the attribute so the browser will not show it

      if (!dataPowertip && !dataTarget && !dataElem && title) {
        $this.data(DATA_POWERTIP, title);
        $this.data(DATA_ORIGINALTITLE, title);
        $this.removeAttr('title');
      } // create hover controllers for each element


      $this.data(DATA_DISPLAYCONTROLLER, new DisplayController($this, options, tipController));
    }); // attach events to matched elements if the manual option is not enabled

    if (!options.manual) {
      // attach open events
      $.each(options.openEvents, function (idx, evt) {
        if ($.inArray(evt, options.closeEvents) > -1) {
          // event is in both openEvents and closeEvents, so toggle it
          targetElements.on(evt + EVENT_NAMESPACE, function elementToggle(event) {
            $.powerTip.toggle(this, event);
          });
        } else {
          targetElements.on(evt + EVENT_NAMESPACE, function elementOpen(event) {
            $.powerTip.show(this, event);
          });
        }
      }); // attach close events

      $.each(options.closeEvents, function (idx, evt) {
        if ($.inArray(evt, options.openEvents) < 0) {
          targetElements.on(evt + EVENT_NAMESPACE, function elementClose(event) {
            // set immediate to true for any event without mouse info
            $.powerTip.hide(this, !isMouseEvent(event));
          });
        }
      }); // attach escape key close event

      targetElements.on('keydown' + EVENT_NAMESPACE, function elementKeyDown(event) {
        // always close tooltip when the escape key is pressed
        if (event.keyCode === 27) {
          $.powerTip.hide(this, true);
        }
      });
    } // remember elements that the plugin is attached to


    session.elements = session.elements ? session.elements.add(targetElements) : targetElements;
    return targetElements;
  };
  /**
   * Default options for the powerTip plugin.
   */


  $.fn.powerTip.defaults = {
    fadeInTime: 200,
    fadeOutTime: 100,
    followMouse: false,
    popupId: 'powerTip',
    popupClass: null,
    intentSensitivity: 7,
    intentPollInterval: 100,
    closeDelay: 100,
    placement: 'n',
    smartPlacement: false,
    offset: 10,
    mouseOnToPopup: false,
    manual: false,
    noDesyncCheck: false,
    openEvents: ['mouseenter', 'focus'],
    closeEvents: ['mouseleave', 'blur']
  };
  /**
   * Default smart placement priority lists.
   * The first item in the array is the highest priority, the last is the lowest.
   * The last item is also the default, which will be used if all previous options
   * do not fit.
   */

  $.fn.powerTip.smartPlacementLists = {
    n: ['n', 'ne', 'nw', 's'],
    e: ['e', 'ne', 'se', 'w', 'nw', 'sw', 'n', 's', 'e'],
    s: ['s', 'se', 'sw', 'n'],
    w: ['w', 'nw', 'sw', 'e', 'ne', 'se', 'n', 's', 'w'],
    nw: ['nw', 'w', 'sw', 'n', 's', 'se', 'nw'],
    ne: ['ne', 'e', 'se', 'n', 's', 'sw', 'ne'],
    sw: ['sw', 'w', 'nw', 's', 'n', 'ne', 'sw'],
    se: ['se', 'e', 'ne', 's', 'n', 'nw', 'se'],
    'nw-alt': ['nw-alt', 'n', 'ne-alt', 'sw-alt', 's', 'se-alt', 'w', 'e'],
    'ne-alt': ['ne-alt', 'n', 'nw-alt', 'se-alt', 's', 'sw-alt', 'e', 'w'],
    'sw-alt': ['sw-alt', 's', 'se-alt', 'nw-alt', 'n', 'ne-alt', 'w', 'e'],
    'se-alt': ['se-alt', 's', 'sw-alt', 'ne-alt', 'n', 'nw-alt', 'e', 'w']
  };
  /**
   * Public API
   */

  $.powerTip = {
    /**
     * Attempts to show the tooltip for the specified element.
     * @param {jQuery|Element} element The element to open the tooltip for.
     * @param {jQuery.Event=} event jQuery event for hover intent and mouse
     *     tracking (optional).
     * @return {jQuery|Element} The original jQuery object or DOM Element.
     */
    show: function apiShowTip(element, event) {
      // if we were given a mouse event then run the hover intent testing,
      // otherwise, simply show the tooltip asap
      if (isMouseEvent(event)) {
        trackMouse(event);
        session.previousX = event.pageX;
        session.previousY = event.pageY;
        $(element).data(DATA_DISPLAYCONTROLLER).show();
      } else {
        $(element).first().data(DATA_DISPLAYCONTROLLER).show(true, true);
      }

      return element;
    },

    /**
     * Repositions the tooltip on the element.
     * @param {jQuery|Element} element The element the tooltip is shown for.
     * @return {jQuery|Element} The original jQuery object or DOM Element.
     */
    reposition: function apiResetPosition(element) {
      $(element).first().data(DATA_DISPLAYCONTROLLER).resetPosition();
      return element;
    },

    /**
     * Attempts to close any open tooltips.
     * @param {(jQuery|Element)=} element The element with the tooltip that
     *     should be closed (optional).
     * @param {boolean=} immediate Disable close delay (optional).
     * @return {jQuery|Element|undefined} The original jQuery object or DOM
     *     Element, if one was specified.
     */
    hide: function apiCloseTip(element, immediate) {
      var displayController; // set immediate to true when no element is specified

      immediate = element ? immediate : true; // find the relevant display controller

      if (element) {
        displayController = $(element).first().data(DATA_DISPLAYCONTROLLER);
      } else if (session.activeHover) {
        displayController = session.activeHover.data(DATA_DISPLAYCONTROLLER);
      } // if found, hide the tip


      if (displayController) {
        displayController.hide(immediate);
      }

      return element;
    },

    /**
     * Toggles the tooltip for the specified element. This will open a closed
     * tooltip, or close an open tooltip.
     * @param {jQuery|Element} element The element with the tooltip that
     *     should be toggled.
     * @param {jQuery.Event=} event jQuery event for hover intent and mouse
     *     tracking (optional).
     * @return {jQuery|Element} The original jQuery object or DOM Element.
     */
    toggle: function apiToggle(element, event) {
      if (session.activeHover && session.activeHover.is(element)) {
        // tooltip for element is active, so close it
        $.powerTip.hide(element, !isMouseEvent(event));
      } else {
        // tooltip for element is not active, so open it
        $.powerTip.show(element, event);
      }

      return element;
    },

    /**
     * Destroy and roll back any powerTip() instance on the specified elements.
     * If no elements are specified then all elements that the plugin is
     * currently attached to will be rolled back.
     * @param {(jQuery|Element)=} element The element with the powerTip instance.
     * @return {jQuery|Element|undefined} The original jQuery object or DOM
     *     Element, if one was specified.
     */
    destroy: function apiDestroy(element) {
      var $element = element ? $(element) : session.elements; // if the plugin is not hooked to any elements then there is no point
      // trying to destroy anything, or dealing with the possible errors

      if (!session.elements || session.elements.length === 0) {
        return element;
      } // if a tooltip is currently open for an element we are being asked to
      // destroy then it should be forced to close


      if (session.isTipOpen && !session.isClosing && $element.filter(session.activeHover).length > 0) {
        // if the tooltip is waiting to close then cancel that delay timer
        if (session.delayInProgress) {
          session.activeHover.data(DATA_DISPLAYCONTROLLER).cancel();
        } // hide the tooltip, immediately


        $.powerTip.hide(session.activeHover, true);
      } // unhook events and destroy plugin changes to each element


      $element.off(EVENT_NAMESPACE).each(function destroy() {
        var $this = $(this),
            dataAttributes = [DATA_ORIGINALTITLE, DATA_DISPLAYCONTROLLER, DATA_HASACTIVEHOVER, DATA_FORCEDOPEN]; // revert title attribute

        if ($this.data(DATA_ORIGINALTITLE)) {
          $this.attr('title', $this.data(DATA_ORIGINALTITLE));
          dataAttributes.push(DATA_POWERTIP);
        } // remove data attributes


        $this.removeData(dataAttributes);
      }); // remove destroyed element from active elements collection

      session.elements = session.elements.not($element); // if there are no active elements left then we will unhook all of the
      // events that we've bound code to and remove the tooltip elements

      if (session.elements.length === 0) {
        $window.off(EVENT_NAMESPACE);
        $document.off(EVENT_NAMESPACE);
        session.mouseTrackingActive = false;
        session.tooltips.remove();
        session.tooltips = null;
      }

      return element;
    }
  }; // API aliasing

  $.powerTip.showTip = $.powerTip.show;
  $.powerTip.closeTip = $.powerTip.hide;
  /**
   * Creates a new CSSCoordinates object.
   * @private
   * @constructor
   */

  function CSSCoordinates() {
    var me = this; // initialize object properties

    me.top = 'auto';
    me.left = 'auto';
    me.right = 'auto';
    me.bottom = 'auto';
    /**
     * Set a property to a value.
     * @private
     * @param {string} property The name of the property.
     * @param {number} value The value of the property.
     */

    me.set = function (property, value) {
      if ($.isNumeric(value)) {
        me[property] = Math.round(value);
      }
    };
  }
  /**
   * Creates a new tooltip display controller.
   * @private
   * @constructor
   * @param {jQuery} element The element that this controller will handle.
   * @param {Object} options Options object containing settings.
   * @param {TooltipController} tipController The TooltipController object for
   *     this instance.
   */


  function DisplayController(element, options, tipController) {
    var hoverTimer = null,
        myCloseDelay = null;
    /**
     * Begins the process of showing a tooltip.
     * @private
     * @param {boolean=} immediate Skip intent testing (optional).
     * @param {boolean=} forceOpen Ignore cursor position and force tooltip to
     *     open (optional).
     */

    function openTooltip(immediate, forceOpen) {
      cancelTimer();

      if (!element.data(DATA_HASACTIVEHOVER)) {
        if (!immediate) {
          session.tipOpenImminent = true;
          hoverTimer = setTimeout(function intentDelay() {
            hoverTimer = null;
            checkForIntent();
          }, options.intentPollInterval);
        } else {
          if (forceOpen) {
            element.data(DATA_FORCEDOPEN, true);
          }

          closeAnyDelayed();
          tipController.showTip(element);
        }
      } else {
        // cursor left and returned to this element, cancel close
        cancelClose();
      }
    }
    /**
     * Begins the process of closing a tooltip.
     * @private
     * @param {boolean=} disableDelay Disable close delay (optional).
     */


    function closeTooltip(disableDelay) {
      // if this instance already has a close delay in progress then halt it
      //console.log(myCloseDelay);
      if (myCloseDelay) {
        myCloseDelay = session.closeDelayTimeout = clearTimeout(myCloseDelay);
        session.delayInProgress = false;
      }

      cancelTimer();
      session.tipOpenImminent = false;

      if (element.data(DATA_HASACTIVEHOVER)) {
        element.data(DATA_FORCEDOPEN, false);

        if (!disableDelay) {
          session.delayInProgress = true;
          session.closeDelayTimeout = setTimeout(function closeDelay() {
            session.closeDelayTimeout = null;
            tipController.hideTip(element);
            session.delayInProgress = false;
            myCloseDelay = null;
          }, options.closeDelay); // save internal reference close delay id so we can check if the
          // active close delay belongs to this instance

          myCloseDelay = session.closeDelayTimeout;
        } else {
          tipController.hideTip(element);
        }
      }
    }
    /**
     * Checks mouse position to make sure that the user intended to hover on the
     * specified element before showing the tooltip.
     * @private
     */


    function checkForIntent() {
      // calculate mouse position difference
      var xDifference = Math.abs(session.previousX - session.currentX),
          yDifference = Math.abs(session.previousY - session.currentY),
          totalDifference = xDifference + yDifference; // check if difference has passed the sensitivity threshold

      if (totalDifference < options.intentSensitivity) {
        cancelClose();
        closeAnyDelayed();
        tipController.showTip(element);
      } else {
        // try again
        session.previousX = session.currentX;
        session.previousY = session.currentY;
        openTooltip();
      }
    }
    /**
     * Cancels active hover timer.
     * @private
     * @param {boolean=} stopClose Cancel any active close delay timer.
     */


    function cancelTimer(stopClose) {
      hoverTimer = clearTimeout(hoverTimer); // cancel the current close delay if the active close delay is for this
      // element or the stopClose argument is true

      if (session.closeDelayTimeout && myCloseDelay === session.closeDelayTimeout || stopClose) {
        cancelClose();
      }
    }
    /**
     * Cancels any active close delay timer.
     * @private
     */


    function cancelClose() {
      session.closeDelayTimeout = clearTimeout(session.closeDelayTimeout);
      session.delayInProgress = false;
    }
    /**
     * Asks any tooltips waiting on their close delay to close now.
     * @private
     */


    function closeAnyDelayed() {
      // if another element is waiting for its close delay then we should ask
      // it to close immediately so we can proceed without unexpected timeout
      // code being run during this tooltip's lifecycle
      if (session.delayInProgress && session.activeHover && !session.activeHover.is(element)) {
        session.activeHover.data(DATA_DISPLAYCONTROLLER).hide(true);
      }
    }
    /**
     * Repositions the tooltip on this element.
     * @private
     */


    function repositionTooltip() {
      tipController.resetPosition(element);
    } // expose the methods


    this.show = openTooltip;
    this.hide = closeTooltip;
    this.cancel = cancelTimer;
    this.resetPosition = repositionTooltip;
  }
  /**
   * Creates a new Placement Calculator.
   * @private
   * @constructor
   */


  function PlacementCalculator() {
    /**
     * Compute the CSS position to display a tooltip at the specified placement
     * relative to the specified element.
     * @private
     * @param {jQuery} element The element that the tooltip should target.
     * @param {string} placement The placement for the tooltip.
     * @param {number} tipWidth Width of the tooltip element in pixels.
     * @param {number} tipHeight Height of the tooltip element in pixels.
     * @param {number} offset Distance to offset tooltips in pixels.
     * @return {CSSCoordinates} A CSSCoordinates object with the position.
     */
    function computePlacementCoords(element, placement, tipWidth, tipHeight, offset) {
      var placementBase = placement.split('-')[0],
          // ignore 'alt' for corners
      coords = new CSSCoordinates(),
          position;

      if (isSvgElement(element)) {
        position = getSvgPlacement(element, placementBase);
      } else {
        position = getHtmlPlacement(element, placementBase);
      } // calculate the appropriate x and y position in the document


      switch (placement) {
        case 'n':
          coords.set('left', position.left - tipWidth / 2);
          coords.set('bottom', session.windowHeight - position.top + offset);
          break;

        case 'e':
          coords.set('left', position.left + offset);
          coords.set('top', position.top - tipHeight / 2);
          break;

        case 's':
          coords.set('left', position.left - tipWidth / 2);
          coords.set('top', position.top + offset);
          break;

        case 'w':
          coords.set('top', position.top - tipHeight / 2);
          coords.set('right', session.windowWidth - position.left + offset);
          break;

        case 'nw':
          coords.set('bottom', session.windowHeight - position.top + offset);
          coords.set('right', session.windowWidth - position.left - 20);
          break;

        case 'nw-alt':
          coords.set('left', position.left);
          coords.set('bottom', session.windowHeight - position.top + offset);
          break;

        case 'ne':
          coords.set('left', position.left - 20);
          coords.set('bottom', session.windowHeight - position.top + offset);
          break;

        case 'ne-alt':
          coords.set('bottom', session.windowHeight - position.top + offset);
          coords.set('right', session.windowWidth - position.left);
          break;

        case 'sw':
          coords.set('top', position.top + offset);
          coords.set('right', session.windowWidth - position.left - 20);
          break;

        case 'sw-alt':
          coords.set('left', position.left);
          coords.set('top', position.top + offset);
          break;

        case 'se':
          coords.set('left', position.left - 20);
          coords.set('top', position.top + offset);
          break;

        case 'se-alt':
          coords.set('top', position.top + offset);
          coords.set('right', session.windowWidth - position.left);
          break;
      }

      return coords;
    }
    /**
     * Finds the tooltip attachment point in the document for a HTML DOM element
     * for the specified placement.
     * @private
     * @param {jQuery} element The element that the tooltip should target.
     * @param {string} placement The placement for the tooltip.
     * @return {Object} An object with the top,left position values.
     */


    function getHtmlPlacement(element, placement) {
      var objectOffset = element.offset(),
          objectWidth = element.outerWidth(),
          objectHeight = element.outerHeight(),
          left,
          top; // calculate the appropriate x and y position in the document

      switch (placement) {
        case 'n':
          left = objectOffset.left + objectWidth / 2;
          top = objectOffset.top;
          break;

        case 'e':
          left = objectOffset.left + objectWidth;
          top = objectOffset.top + objectHeight / 2;
          break;

        case 's':
          left = objectOffset.left + objectWidth / 2;
          top = objectOffset.top + objectHeight;
          break;

        case 'w':
          left = objectOffset.left;
          top = objectOffset.top + objectHeight / 2;
          break;

        case 'nw':
          left = objectOffset.left;
          top = objectOffset.top;
          break;

        case 'ne':
          left = objectOffset.left + objectWidth;
          top = objectOffset.top;
          break;

        case 'sw':
          left = objectOffset.left;
          top = objectOffset.top + objectHeight;
          break;

        case 'se':
          left = objectOffset.left + objectWidth;
          top = objectOffset.top + objectHeight;
          break;
      }

      return {
        top: top,
        left: left
      };
    }
    /**
     * Finds the tooltip attachment point in the document for a SVG element for
     * the specified placement.
     * @private
     * @param {jQuery} element The element that the tooltip should target.
     * @param {string} placement The placement for the tooltip.
     * @return {Object} An object with the top,left position values.
     */


    function getSvgPlacement(element, placement) {
      var svgElement = element.closest('svg')[0],
          domElement = element[0],
          point = svgElement.createSVGPoint(),
          boundingBox = domElement.getBBox(),
          matrix = domElement.getScreenCTM(),
          halfWidth = boundingBox.width / 2,
          halfHeight = boundingBox.height / 2,
          placements = [],
          placementKeys = ['nw', 'n', 'ne', 'e', 'se', 's', 'sw', 'w'],
          coords,
          rotation,
          steps,
          x;
      /**
       * Transform and append the current points to the placements list.
       * @private
       */

      function pushPlacement() {
        placements.push(point.matrixTransform(matrix));
      } // get bounding box corners and midpoints


      point.x = boundingBox.x;
      point.y = boundingBox.y;
      pushPlacement();
      point.x += halfWidth;
      pushPlacement();
      point.x += halfWidth;
      pushPlacement();
      point.y += halfHeight;
      pushPlacement();
      point.y += halfHeight;
      pushPlacement();
      point.x -= halfWidth;
      pushPlacement();
      point.x -= halfWidth;
      pushPlacement();
      point.y -= halfHeight;
      pushPlacement(); // determine rotation

      if (placements[0].y !== placements[1].y || placements[0].x !== placements[7].x) {
        rotation = Math.atan2(matrix.b, matrix.a) * RAD2DEG;
        steps = Math.ceil((rotation % 360 - 22.5) / 45);

        if (steps < 1) {
          steps += 8;
        }

        while (steps--) {
          placementKeys.push(placementKeys.shift());
        }
      } // find placement


      for (x = 0; x < placements.length; x++) {
        if (placementKeys[x] === placement) {
          coords = placements[x];
          break;
        }
      }

      return {
        top: coords.y + session.scrollTop,
        left: coords.x + session.scrollLeft
      };
    } // expose methods


    this.compute = computePlacementCoords;
  }
  /**
   * Creates a new tooltip controller.
   * @private
   * @constructor
   * @param {Object} options Options object containing settings.
   */


  function TooltipController(options) {
    var placementCalculator = new PlacementCalculator(),
        tipElement = $('#' + options.popupId); // build and append tooltip div if it does not already exist

    if (tipElement.length === 0) {
      tipElement = $('<div/>', {
        id: options.popupId
      }); // grab body element if it was not populated when the script loaded
      // note: this hack exists solely for jsfiddle support

      if ($body.length === 0) {
        $body = $('body');
      }

      $body.append(tipElement); // remember the tooltip elements that the plugin has created

      session.tooltips = session.tooltips ? session.tooltips.add(tipElement) : tipElement;
    } // hook mousemove for cursor follow tooltips


    if (options.followMouse) {
      // only one positionTipOnCursor hook per tooltip element, please
      if (!tipElement.data(DATA_HASMOUSEMOVE)) {
        $document.on('mousemove' + EVENT_NAMESPACE, positionTipOnCursor);
        $window.on('scroll' + EVENT_NAMESPACE, positionTipOnCursor);
        tipElement.data(DATA_HASMOUSEMOVE, true);
      }
    }
    /**
     * Gives the specified element the active-hover state and queues up the
     * showTip function.
     * @private
     * @param {jQuery} element The element that the tooltip should target.
     */


    function beginShowTip(element) {
      element.data(DATA_HASACTIVEHOVER, true); // show tooltip, asap

      tipElement.queue(function queueTipInit(next) {
        showTip(element);
        next();
      });
    }
    /**
     * Shows the tooltip, as soon as possible.
     * @private
     * @param {jQuery} element The element that the tooltip should target.
     */


    function showTip(element) {
      var tipContent; // it is possible, especially with keyboard navigation, to move on to
      // another element with a tooltip during the queue to get to this point
      // in the code. if that happens then we need to not proceed or we may
      // have the fadeout callback for the last tooltip execute immediately
      // after this code runs, causing bugs.

      if (!element.data(DATA_HASACTIVEHOVER)) {
        return;
      } // if the tooltip is open and we got asked to open another one then the
      // old one is still in its fadeOut cycle, so wait and try again


      if (session.isTipOpen) {
        if (!session.isClosing) {
          hideTip(session.activeHover);
        }

        tipElement.delay(100).queue(function queueTipAgain(next) {
          showTip(element);
          next();
        });
        return;
      } // trigger powerTipPreRender event


      element.trigger('powerTipPreRender'); // set tooltip content

      tipContent = getTooltipContent(element);

      if (tipContent) {
        tipElement.empty().append(tipContent);
      } else {
        // we have no content to display, give up
        return;
      } // trigger powerTipRender event


      element.trigger('powerTipRender');
      session.activeHover = element;
      session.isTipOpen = true;
      tipElement.data(DATA_MOUSEONTOTIP, options.mouseOnToPopup); // add custom class to tooltip element

      tipElement.addClass(options.popupClass); // set tooltip position
      // revert to static placement when the "force open" flag was set because
      // that flag means that we do not have accurate mouse position info

      if (!options.followMouse || element.data(DATA_FORCEDOPEN)) {
        positionTipOnElement(element);
        session.isFixedTipOpen = true;
      } else {
        positionTipOnCursor();
      } // close tooltip when clicking anywhere on the page, with the exception
      // of the tooltip's trigger element and any elements that are within a
      // tooltip that has 'mouseOnToPopup' option enabled
      // always enable this feature when the "force open" flag is set on a
      // followMouse tooltip because we reverted to static placement above


      if (!element.data(DATA_FORCEDOPEN) && !options.followMouse) {
        $document.on('click' + EVENT_NAMESPACE, function documentClick(event) {
          var target = event.target;

          if (target !== element[0]) {
            if (options.mouseOnToPopup) {
              if (target !== tipElement[0] && !$.contains(tipElement[0], target)) {
                $.powerTip.hide();
              }
            } else {
              $.powerTip.hide();
            }
          }
        });
      } // if we want to be able to mouse on to the tooltip then we need to
      // attach hover events to the tooltip that will cancel a close request
      // on mouseenter and start a new close request on mouseleave
      // only hook these listeners if we're not in manual mode


      if (options.mouseOnToPopup && !options.manual) {
        tipElement.on('mouseenter' + EVENT_NAMESPACE, function tipMouseEnter() {
          // check activeHover in case the mouse cursor entered the
          // tooltip during the fadeOut and close cycle
          if (session.activeHover) {
            session.activeHover.data(DATA_DISPLAYCONTROLLER).cancel();
          }
        });
        tipElement.on('mouseleave' + EVENT_NAMESPACE, function tipMouseLeave() {
          // check activeHover in case the mouse cursor left the tooltip
          // during the fadeOut and close cycle
          if (session.activeHover) {
            session.activeHover.data(DATA_DISPLAYCONTROLLER).hide();
          }
        });
      } // fadein


      tipElement.fadeIn(options.fadeInTime, function fadeInCallback() {
        // start desync polling
        if (!session.desyncTimeout && !options.noDesyncCheck) {
          session.desyncTimeout = setInterval(closeDesyncedTip, 500);
        } // trigger powerTipOpen event


        element.trigger('powerTipOpen');
      });
    }
    /**
     * Hides the tooltip.
     * @private
     * @param {jQuery} element The element that the tooltip should target.
     */


    function hideTip(element) {
      // reset session
      session.isClosing = true;
      session.isTipOpen = false; // stop desync polling

      session.desyncTimeout = clearInterval(session.desyncTimeout); // reset element state

      element.data(DATA_HASACTIVEHOVER, false);
      element.data(DATA_FORCEDOPEN, false); // remove document click handler

      $document.off('click' + EVENT_NAMESPACE); // unbind the mouseOnToPopup events if they were set

      tipElement.off(EVENT_NAMESPACE); // fade out

      tipElement.fadeOut(options.fadeOutTime, function fadeOutCallback() {
        var coords = new CSSCoordinates(); // reset session and tooltip element

        session.activeHover = null;
        session.isClosing = false;
        session.isFixedTipOpen = false;
        tipElement.removeClass(); // support mouse-follow and fixed position tips at the same time by
        // moving the tooltip to the last cursor location after it is hidden

        coords.set('top', session.currentY + options.offset);
        coords.set('left', session.currentX + options.offset);
        tipElement.css(coords); // trigger powerTipClose event

        element.trigger('powerTipClose');
      });
    }
    /**
     * Moves the tooltip to the users mouse cursor.
     * @private
     */


    function positionTipOnCursor() {
      var tipWidth, tipHeight, coords, collisions, collisionCount; // to support having fixed tooltips on the same page as cursor tooltips,
      // where both instances are referencing the same tooltip element, we
      // need to keep track of the mouse position constantly, but we should
      // only set the tip location if a fixed tip is not currently open, a tip
      // open is imminent or active, and the tooltip element in question does
      // have a mouse-follow using it.

      if (!session.isFixedTipOpen && (session.isTipOpen || session.tipOpenImminent && tipElement.data(DATA_HASMOUSEMOVE))) {
        // grab measurements
        tipWidth = tipElement.outerWidth();
        tipHeight = tipElement.outerHeight();
        coords = new CSSCoordinates(); // grab collisions

        coords.set('top', session.currentY + options.offset);
        coords.set('left', session.currentX + options.offset);
        collisions = getViewportCollisions(coords, tipWidth, tipHeight); // handle tooltip view port collisions

        if (collisions !== Collision.none) {
          collisionCount = countFlags(collisions);

          if (collisionCount === 1) {
            // if there is only one collision (bottom or right) then
            // simply constrain the tooltip to the view port
            if (collisions === Collision.right) {
              coords.set('left', session.scrollLeft + session.windowWidth - tipWidth);
            } else if (collisions === Collision.bottom) {
              coords.set('top', session.scrollTop + session.windowHeight - tipHeight);
            }
          } else {
            // if the tooltip has more than one collision then it is
            // trapped in the corner and should be flipped to get it out
            // of the users way
            coords.set('left', session.currentX - tipWidth - options.offset);
            coords.set('top', session.currentY - tipHeight - options.offset);
          }
        } // position the tooltip


        tipElement.css(coords);
      }
    }
    /**
     * Sets the tooltip to the correct position relative to the specified target
     * element. Based on options settings.
     * @private
     * @param {jQuery} element The element that the tooltip should target.
     */


    function positionTipOnElement(element) {
      var priorityList, finalPlacement; // when the followMouse option is enabled and the "force open" flag is
      // set we revert to static positioning. since the developer may not have
      // considered this scenario we should use smart placement

      if (options.smartPlacement || options.followMouse && element.data(DATA_FORCEDOPEN)) {
        priorityList = $.fn.powerTip.smartPlacementLists[options.placement]; // iterate over the priority list and use the first placement option
        // that does not collide with the view port. if they all collide
        // then the last placement in the list will be used.

        $.each(priorityList, function (idx, pos) {
          // place tooltip and find collisions
          var collisions = getViewportCollisions(placeTooltip(element, pos), tipElement.outerWidth(), tipElement.outerHeight()); // update the final placement variable

          finalPlacement = pos; // break if there were no collisions

          return collisions !== Collision.none;
        });
      } else {
        // if we're not going to use the smart placement feature then just
        // compute the coordinates and do it
        placeTooltip(element, options.placement);
        finalPlacement = options.placement;
      } // add placement as class for CSS arrows


      tipElement.removeClass('w nw sw e ne se n s w se-alt sw-alt ne-alt nw-alt');
      tipElement.addClass(finalPlacement);
    }
    /**
     * Sets the tooltip position to the appropriate values to show the tip at
     * the specified placement. This function will iterate and test the tooltip
     * to support elastic tooltips.
     * @private
     * @param {jQuery} element The element that the tooltip should target.
     * @param {string} placement The placement for the tooltip.
     * @return {CSSCoordinates} A CSSCoordinates object with the top, left, and
     *     right position values.
     */


    function placeTooltip(element, placement) {
      var iterationCount = 0,
          tipWidth,
          tipHeight,
          coords = new CSSCoordinates(); // set the tip to 0,0 to get the full expanded width

      coords.set('top', 0);
      coords.set('left', 0);
      tipElement.css(coords); // to support elastic tooltips we need to check for a change in the
      // rendered dimensions after the tooltip has been positioned

      do {
        // grab the current tip dimensions
        tipWidth = tipElement.outerWidth();
        tipHeight = tipElement.outerHeight(); // get placement coordinates

        coords = placementCalculator.compute(element, placement, tipWidth, tipHeight, options.offset); // place the tooltip

        tipElement.css(coords);
      } while ( // sanity check: limit to 5 iterations, and...
      ++iterationCount <= 5 && ( // try again if the dimensions changed after placement
      tipWidth !== tipElement.outerWidth() || tipHeight !== tipElement.outerHeight()));

      return coords;
    }
    /**
     * Checks for a tooltip desync and closes the tooltip if one occurs.
     * @private
     */


    function closeDesyncedTip() {
      var isDesynced = false,
          hasDesyncableCloseEvent = $.grep(['mouseleave', 'mouseout', 'blur', 'focusout'], function (eventType) {
        return $.inArray(eventType, options.closeEvents) !== -1;
      }).length > 0; // It is possible for the mouse cursor to leave an element without
      // firing the mouseleave or blur event. This most commonly happens when
      // the element is disabled under mouse cursor. If this happens it will
      // result in a desynced tooltip because the tooltip was never asked to
      // close. So we should periodically check for a desync situation and
      // close the tip if such a situation arises.

      if (session.isTipOpen && !session.isClosing && !session.delayInProgress && hasDesyncableCloseEvent) {
        if (session.activeHover.data(DATA_HASACTIVEHOVER) === false || session.activeHover.is(':disabled')) {
          // user moused onto another tip or active hover is disabled
          isDesynced = true;
        } else if (!isMouseOver(session.activeHover) && !session.activeHover.is(':focus') && !session.activeHover.data(DATA_FORCEDOPEN)) {
          // hanging tip - have to test if mouse position is not over the
          // active hover and not over a tooltip set to let the user
          // interact with it.
          // for keyboard navigation: this only counts if the element does
          // not have focus.
          // for tooltips opened via the api: we need to check if it has
          // the forcedOpen flag.
          if (tipElement.data(DATA_MOUSEONTOTIP)) {
            if (!isMouseOver(tipElement)) {
              isDesynced = true;
            }
          } else {
            isDesynced = true;
          }
        }

        if (isDesynced) {
          // close the desynced tip
          hideTip(session.activeHover);
        }
      }
    } // expose methods


    this.showTip = beginShowTip;
    this.hideTip = hideTip;
    this.resetPosition = positionTipOnElement;
  }
  /**
   * Determine whether a jQuery object is an SVG element
   * @private
   * @param {jQuery} element The element to check
   * @return {boolean} Whether this is an SVG element
   */


  function isSvgElement(element) {
    return Boolean(window.SVGElement && element[0] instanceof SVGElement);
  }
  /**
   * Determines if the specified jQuery.Event object has mouse data.
   * @private
   * @param {jQuery.Event=} event The jQuery.Event object to test.
   * @return {boolean} True if there is mouse data, otherwise false.
   */


  function isMouseEvent(event) {
    return Boolean(event && $.inArray(event.type, MOUSE_EVENTS) > -1 && typeof event.pageX === 'number');
  }
  /**
   * Initializes the viewport dimension cache and hooks up the mouse position
   * tracking and viewport dimension tracking events.
   * Prevents attaching the events more than once.
   * @private
   */


  function initTracking() {
    if (!session.mouseTrackingActive) {
      session.mouseTrackingActive = true; // grab the current viewport dimensions on load

      getViewportDimensions();
      $(getViewportDimensions); // hook mouse move tracking

      $document.on('mousemove' + EVENT_NAMESPACE, trackMouse); // hook viewport dimensions tracking

      $window.on('resize' + EVENT_NAMESPACE, trackResize);
      $window.on('scroll' + EVENT_NAMESPACE, trackScroll);
    }
  }
  /**
   * Updates the viewport dimensions cache.
   * @private
   */


  function getViewportDimensions() {
    session.scrollLeft = $window.scrollLeft();
    session.scrollTop = $window.scrollTop();
    session.windowWidth = $window.width();
    session.windowHeight = $window.height();
  }
  /**
   * Updates the window size info in the viewport dimensions cache.
   * @private
   */


  function trackResize() {
    session.windowWidth = $window.width();
    session.windowHeight = $window.height();
  }
  /**
   * Updates the scroll offset info in the viewport dimensions cache.
   * @private
   */


  function trackScroll() {
    var x = $window.scrollLeft(),
        y = $window.scrollTop();

    if (x !== session.scrollLeft) {
      session.currentX += x - session.scrollLeft;
      session.scrollLeft = x;
    }

    if (y !== session.scrollTop) {
      session.currentY += y - session.scrollTop;
      session.scrollTop = y;
    }
  }
  /**
   * Saves the current mouse coordinates to the session object.
   * @private
   * @param {jQuery.Event} event The mousemove event for the document.
   */


  function trackMouse(event) {
    session.currentX = event.pageX;
    session.currentY = event.pageY;
  }
  /**
   * Tests if the mouse is currently over the specified element.
   * @private
   * @param {jQuery} element The element to check for hover.
   * @return {boolean} True if the mouse is over the element, otherwise false.
   */


  function isMouseOver(element) {
    // use getBoundingClientRect() because jQuery's width() and height()
    // methods do not work with SVG elements
    // compute width/height because those properties do not exist on the object
    // returned by getBoundingClientRect() in older versions of IE
    var elementPosition = element.offset(),
        elementBox = element[0].getBoundingClientRect(),
        elementWidth = elementBox.right - elementBox.left,
        elementHeight = elementBox.bottom - elementBox.top;
    return session.currentX >= elementPosition.left && session.currentX <= elementPosition.left + elementWidth && session.currentY >= elementPosition.top && session.currentY <= elementPosition.top + elementHeight;
  }
  /**
   * Fetches the tooltip content from the specified element's data attributes.
   * @private
   * @param {jQuery} element The element to get the tooltip content for.
   * @return {(string|jQuery|undefined)} The text/HTML string, jQuery object, or
   *     undefined if there was no tooltip content for the element.
   */


  function getTooltipContent(element) {
    var tipText = element.data(DATA_POWERTIP),
        tipObject = element.data(DATA_POWERTIPJQ),
        tipTarget = element.data(DATA_POWERTIPTARGET),
        targetElement,
        content;

    if (tipText) {
      if ($.isFunction(tipText)) {
        tipText = tipText.call(element[0]);
      }

      content = tipText;
    } else if (tipObject) {
      if ($.isFunction(tipObject)) {
        tipObject = tipObject.call(element[0]);
      }

      if (tipObject.length > 0) {
        content = tipObject.clone(true, true);
      }
    } else if (tipTarget) {
      targetElement = $(tipTarget);

      if (targetElement.length > 0) {
        content = targetElement.html();
      } else {
        targetElement = $('#' + tipTarget);

        if (targetElement.length > 0) {
          content = targetElement.html();
        }
      }
    }

    return content;
  }
  /**
   * Finds any viewport collisions that an element (the tooltip) would have if it
   * were absolutely positioned at the specified coordinates.
   * @private
   * @param {CSSCoordinates} coords Coordinates for the element.
   * @param {number} elementWidth Width of the element in pixels.
   * @param {number} elementHeight Height of the element in pixels.
   * @return {number} Value with the collision flags.
   */


  function getViewportCollisions(coords, elementWidth, elementHeight) {
    var margin = 0,
        viewportTop = session.scrollTop + margin,
        viewportLeft = session.scrollLeft + margin,
        viewportBottom = viewportTop + session.windowHeight - margin * 2,
        viewportRight = viewportLeft + session.windowWidth - margin * 2,
        collisions = Collision.none;

    if (coords.top < viewportTop || Math.abs(coords.bottom - session.windowHeight) - elementHeight < viewportTop) {
      collisions |= Collision.top;
    }

    if (coords.top + elementHeight > viewportBottom || Math.abs(coords.bottom - session.windowHeight) > viewportBottom) {
      collisions |= Collision.bottom;
    }

    if (coords.left < viewportLeft || coords.right + elementWidth > viewportRight) {
      collisions |= Collision.left;
    }

    if (coords.left + elementWidth > viewportRight || coords.right < viewportLeft) {
      collisions |= Collision.right;
    }

    return collisions;
  }
  /**
   * Counts the number of bits set on a flags value.
   * @param {number} value The flags value.
   * @return {number} The number of bits that have been set.
   */


  function countFlags(value) {
    var count = 0;

    while (value) {
      value &= value - 1;
      count++;
    }

    return count;
  } // return api for commonjs and amd environments


  return $.powerTip;
});
// https://raw.githubusercontent.com/robextrem/materialize-validation/master/js/materialize-validation.js
(function ($) {
  $.fn.materialvalidation = function (options) {
    return this.each(function () {
      var element = $(this); // Return early if this element already has a plugin instance

      if (element.data('materialvalidation')) {
        return;
      } // pass options to plugin constructor


      var myplugin = new materialvalidation(this, options); // Store plugin object in this element's data

      element.data('materialvalidation', myplugin);
      element.data().materialvalidation.methods.init();
    });
  };

  var materialvalidation = function materialvalidation(target, options) {
    var componentObj = {
      defaultText: '',
      fields: "fieldset,select,textarea,input[type=checkbox],input[type=text],input[type=email],input[type=number],input[type=password],input[type=search],input[type=tel],input[type=datetime-local],input[type=date],input[type=url]",
      parentContainer: false,
      html5materialvalidationon: true,
      errorClass: 'input-error',
      okClass: 'input-ok',
      notification: false,
      methods: {
        init: function init() {
          var $target = $(target);

          if (options !== undefined) {
            if (options.notification !== undefined) {
              componentObj.notification = options.notification;
            }

            if (options.errorClass !== undefined) {
              componentObj.errorClass = options.errorClass;
            }

            if (options.parentContainer !== undefined) {
              componentObj.parentContainer = options.parentContainer;
            }
          }

          $target.find(componentObj.fields).each(function (i, e) {
            var elField = $(e),
                $this = $(this);
            elField.data().order = i;

            if (elField.data().content === undefined) {
              elField.data("content", componentObj.defaultText);
              elField.attr("data-content", componentObj.defaultText);
            }

            elField.on("focus", function () {
              $this.removeClass(componentObj.errorClass);
              $this.removeClass(componentObj.okClass);
            });
          });
        },
        reset: function reset() {
          var $target = $(target);
          $target.find(componentObj.fields).removeClass(componentObj.errorClass);
          $target.find(componentObj.fields).removeClass(componentObj.okClass);
        },
        validate: function validate() {
          var $target = $(target),
              formvalid = true;
          $target.find(componentObj.fields).each(function (i, e) {
            var valid = true,
                elCheck = $(e),
                elVal = elCheck.val();
            if (elCheck.prop("disabled")) return true;
            var dataVal = elCheck.data("validation");
            if (!dataVal) return;
            var data_validation_ext = dataVal.split(':'),
                data_validation = data_validation_ext[0],
                data_param = data_validation_ext[1];
            if (elCheck.data().optional && elVal.length < 1) return true;

            switch (data_validation) {
              case "empty":
                {
                  if (elVal.trim().length > 0) {
                    valid = false;
                    formvalid = false;
                  }

                  break;
                }

              case "nonempty":
                {
                  if (!elVal.trim().length) {
                    valid = false;
                    formvalid = false;
                  }

                  break;
                }

              case "text":
                {
                  if (!componentObj.methods.isText(elVal.trim())) {
                    valid = false;
                    formvalid = false;
                  }

                  break;
                }

              case 'minlen':
                {
                  if (elVal.trim().length < Number(data_param)) {
                    valid = false;
                    formvalid = false;
                  }

                  break;
                }

              case 'emptyorminlen':
                {
                  if (elVal.trim().length > 0 && elVal.trim().length < Number(data_param)) {
                    valid = false;
                    formvalid = false;
                  }

                  break;
                }

              case "alphanumeric":
                {
                  if (!componentObj.methods.isAlphaNumeric(elVal.trim())) {
                    valid = false;
                    formvalid = false;
                  }

                  break;
                }

              case "zip":
                {
                  if (!componentObj.methods.isCP(elVal)) {
                    valid = false;
                    formvalid = false;
                  }

                  break;
                }

              case "email":
                {
                  if (!componentObj.methods.isEmail(elVal)) {
                    valid = false;
                    formvalid = false;
                  }

                  break;
                }

              case "phone":
                {
                  if (!componentObj.methods.isPhone(elVal)) {
                    valid = false;
                    formvalid = false;
                  }

                  break;
                }

              case "numericonly":
                {
                  if (!componentObj.methods.isNumeric(elVal)) {
                    valid = false;
                    formvalid = false;
                  }

                  break;
                }

              case "numericonlynozero":
                {
                  if (!componentObj.methods.isNumeric(elVal)) {
                    valid = false;
                    formvalid = false;
                  }

                  if (elVal <= 0) {
                    valid = false;
                    formvalid = false;
                  }

                  break;
                }

              case "numericorempty":
                {
                  if (elVal !== "") {
                    if (!componentObj.methods.isNumeric(elVal.trim())) {
                      valid = false;
                      formvalid = false;
                    }
                  }

                  break;
                }

              case "address":
                {
                  if (!componentObj.methods.isAddress(elVal)) {
                    valid = false;
                    formvalid = false;
                  }

                  break;
                }

              case "password":
                {
                  if (!componentObj.methods.isPassword(elVal)) {
                    valid = false;
                    formvalid = false;
                  }

                  break;
                }

              case "domain":
                {
                  if (!componentObj.methods.isDomain(elVal)) {
                    valid = false;
                    formvalid = false;
                  }

                  break;
                }

              case "url":
                {
                  if (!componentObj.methods.isURL(elVal)) {
                    valid = false;
                    formvalid = false;
                  }

                  break;
                }

              case "date":
                {
                  if (!componentObj.methods.isDate(elVal)) {
                    valid = false;
                    formvalid = false;
                  }

                  break;
                }

              case "samepassword":
                {
                  if (elVal === "") {
                    valid = false;
                    formvalid = false;
                  }

                  if (elVal !== $(".samepassword2").val()) {
                    valid = false;
                    formvalid = false;
                  }

                  break;
                }

              case "select":
                {
                  valid = !!elVal;
                  break;
                }

              case "checked":
                {
                  valid = componentObj.methods.isChecked(e);
                }
            }

            if (!valid) {
              if (componentObj.parentContainer) {
                elCheck.parent().addClass(componentObj.errorClass);
              } else {
                elCheck.addClass(componentObj.errorClass);
                elCheck.removeClass(componentObj.okClass);
              }

              if (componentObj.notification) {
                window.alert(elCheck.data().content);
              } //$( "html, body" ).animate( { scrollTop: elCheck.offset().top - 105 }, 500, function () {
              //$(e).focus();
              //} );
              //return valid;

            } else {
              elCheck.removeClass(componentObj.errorClass).addClass(componentObj.okClass);
            }
          });
          return formvalid;
        },
        isEmail: function isEmail(email) {
          var patternMail = new RegExp(/^(("[\w-+\s]+")|([\w-+]+(?:\.[\w-+]+)*)|("[\w-+\s]+")([\w-+]+(?:\.[\w-+]+)*))(@((?:[\w-+]+\.)*\w[\w-+]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][\d]\.|1[\d]{2}\.|[\d]{1,2}\.))((25[0-5]|2[0-4][\d]|1[\d]{2}|[\d]{1,2})\.){2}(25[0-5]|2[0-4][\d]|1[\d]{2}|[\d]{1,2})\]?$)/i);
          return patternMail.test(email);
        },
        isDomain: function isDomain(domain) {
          var patternDomain = new RegExp(/^((?:(?:(?:\w[\.\-\+]?)*)\w)+)((?:(?:(?:\w[\.\-\+]?){0,62})\w)+)\.(\w{2,6})$/);
          return domain.match(patternDomain);
        },
        isText: function isText(name) {
          if (name === "") return false;
          var patternName = new RegExp(/^[a-zA-ZÁÉÍÓÚáéíóúñÑ ]+$/);
          return patternName.test(name);
        },
        isAlphaNumeric: function isAlphaNumeric(name) {
          if (name === "") return false;
          var patternName = new RegExp(/^[a-z0-9]+$/i);
          return patternName.test(name);
        },
        isPhone: function isPhone(phone) {
          var patternPhone = new RegExp(/^\d{10}$/);
          return patternPhone.test(phone);
        },
        isCP: function isCP(cp) {
          var patternCP = new RegExp(/^[0-9]+$/);
          return patternCP.test(cp) && cp.length === 5;
        },
        isDate: function isDate(date) {
          var patternDate = new RegExp(/[0-9]{4}[-][0-9]{2}[-][0-9]{2}$/);
          return patternDate.test(date);
        },
        isNumeric: function isNumeric(n) {
          return !isNaN(parseFloat(n)) && isFinite(n);
        },
        isPassword: function isPassword(password) {
          var re = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])\w{8,}$/;
          return re.test(password);
        },
        isAddress: function isAddress(addr) {
          var patternAddress = new RegExp(/^[a-zA-Zа-яА-Я0-9ÁÉÍÓÚáéíóúñÑ\-().,# ]+$/);
          return patternAddress.test(addr);
        },
        isURL: function isURL(url) {
          var regex = /^(ht|f)tps?:\/\/\w+([.\-\w]+)?\.([a-z]{2,4}|travel)(:\d{2,5})?(\/.*)?$/i;
          return regex.test(url);
        },
        isChecked: function isChecked(c) {
          return $(c).is(":checked");
        }
      }
    };
    return componentObj;
  };
})(jQuery);
$(function () {
  removeQueryStringParam('realm');
  iziToastInit();
  realmInit(); // CHECK IF WE NEED  AND SHOW IZITOAST

  $(function () {
    var $objRealm = $('[data-realm]');
    if (!$objRealm.get(0)) return false;
    $objRealm = JSON.parse($objRealm.html());
    if (!$objRealm.message) return false;
    setTimeout(function () {
      iziToast.show({
        title: $objRealm.title,
        message: $objRealm.message,
        icon: 'ico-' + $objRealm.icon,
        "class": 'color-' + $objRealm["class"],
        timeout: 5000
      });
    }, 500);
  });
  /**
   * INIT IZITOAST
   * @returns {boolean}
   */

  function iziToastInit() {
    if (window.iziInitDone) return false;
    iziToast.settings({
      closeOnClick: true,
      close: true,
      position: 'bottomCenter',
      animateInside: false,
      transitionIn: 'fadeInUp',
      transitionOut: 'fadeOutDown',
      transitionInMobile: 'fadeInUp',
      transitionOutMobile: 'fadeOutDown',
      timeout: 5000,
      progressBar: false,
      displayMode: 'replace',
      theme: 'dark'
    });
    window.iziInitDone = true;
  }
  /**
   * READ AND STORE REALMS
   * @returns {boolean}
   */


  function realmInit() {
    if (window.realms) return false;
    var $objRealms = $('[data-realms]');
    if (!$objRealms.get(0)) return false;
    $objRealms = JSON.parse($objRealms.html());
    if (!$objRealms) return false;
    window.realms = $objRealms;
  }
  /**
   * REMOVE QUERYSTRING PARAM
   *
   * @param key
   * @param returnURL
   * @returns {boolean}
   */


  function removeQueryStringParam(key, returnURL) {
    if (typeof URLSearchParams == 'undefined') return false;
    var baseUrl = [location.protocol, '//', location.host, location.pathname].join(''),
        urlQueryString = document.location.search,
        newURL = baseUrl;
    var params = new URLSearchParams(urlQueryString);
    params["delete"](key);
    params = params.toString();
    newURL = params.length ? [baseUrl, params].join('?') : newURL;
    return returnURL ? newURL : window.history.replaceState({}, '', newURL);
  }
});
/**
 * Created by dagan on 07/04/2014.
 * Updated by Roman "JJam" Koksharoff on 2019-05-10
 * Original Source: https://github.com/ofirdagan/cross-domain-local-storage
 */
'use strict';

window.XdUtils = window.XdUtils || function () {
  function extend(object, defaultObject) {
    var result = defaultObject || {};
    var key;

    for (key in object) {
      if (object.hasOwnProperty(key)) {
        result[key] = object[key];
      }
    }

    return result;
  } //public interface


  return {
    extend: extend
  };
}();

window.xdLocalStorage = window.xdLocalStorage || function () {
  var MESSAGE_NAMESPACE = 'mathedu-cross-domain-local-message';
  var options = {
    iframeId: 'mathedu-cross-domain-iframe',
    iframeUrl: undefined,
    initCallback: function initCallback() {}
  };
  var requestId = -1;
  var iframe;
  var requests = {};
  var _wasInit = false;
  var iframeReady = true;

  function applyCallback(data) {
    if (requests[data.id]) {
      requests[data.id](data);
      delete requests[data.id];
    }
  }

  function receiveMessage(event) {
    var data;

    try {
      data = JSON.parse(event.data);
    } catch (err) {//not our message, can ignore
    }

    if (data && data.namespace === MESSAGE_NAMESPACE) {
      if (data.id === 'iframe-ready') {
        iframeReady = true;
        options.initCallback();
      } else {
        applyCallback(data);
      }
    }
  }

  function buildMessage(action, key, value, callback) {
    requestId++;
    requests[requestId] = callback;
    var data = {
      namespace: MESSAGE_NAMESPACE,
      id: requestId,
      action: action,
      key: key,
      value: value
    };

    try {
      iframe.contentWindow.postMessage(JSON.stringify(data), '*');
    } catch (E) {}
  }

  function _init(customOptions) {
    options = XdUtils.extend(customOptions, options);
    var temp = document.createElement('div');

    if (window.addEventListener) {
      window.addEventListener('message', receiveMessage, false);
    } else {
      window.attachEvent('onmessage', receiveMessage);
    }

    temp.innerHTML = '<iframe id="' + options.iframeId + '" src="' + options.iframeUrl + '" style="display: none;"></iframe>';
    document.body.appendChild(temp);
    iframe = document.getElementById(options.iframeId);
  }

  function isApiReady() {
    if (!_wasInit) {
      return false;
    }

    if (!iframeReady) {
      return false;
    }

    return true;
  }

  function isDomReady() {
    return document.readyState === 'complete';
  }

  return {
    //callback is optional for cases you use the api before window load.
    init: function init(customOptions) {
      if (!customOptions.iframeUrl) {
        throw 'You must specify iframeUrl';
      }

      if (_wasInit) {
        return;
      }

      _wasInit = true;

      if (isDomReady()) {
        _init(customOptions);
      } else {
        if (document.addEventListener) {
          // All browsers expect IE < 9
          document.addEventListener('readystatechange', function () {
            if (isDomReady()) {
              _init(customOptions);
            }
          });
        } else {
          // IE < 9
          document.attachEvent('readystatechange', function () {
            if (isDomReady()) {
              _init(customOptions);
            }
          });
        }
      }
    },
    setItem: function setItem(key, value, callback) {
      if (!isApiReady()) {
        return;
      }

      buildMessage('set', key, value, callback);
    },
    getItem: function getItem(key, callback) {
      if (!isApiReady()) {
        return;
      }

      buildMessage('get', key, null, callback);
    },
    removeItem: function removeItem(key, callback) {
      if (!isApiReady()) {
        return;
      }

      buildMessage('remove', key, null, callback);
    },
    key: function key(index, callback) {
      if (!isApiReady()) {
        return;
      }

      buildMessage('key', index, null, callback);
    },
    getSize: function getSize(callback) {
      if (!isApiReady()) {
        return;
      }

      buildMessage('size', null, null, callback);
    },
    getLength: function getLength(callback) {
      if (!isApiReady()) {
        return;
      }

      buildMessage('length', null, null, callback);
    },
    clear: function clear(callback) {
      if (!isApiReady()) {
        return;
      }

      buildMessage('clear', null, null, callback);
    },
    wasInit: function wasInit() {
      return _wasInit;
    },
    isReady: function isReady() {
      return isApiReady();
    }
  };
}();
/**
 * jMathEdu Admin Stub v 1.0 beta 1
 * Last Mod Date: 2019-08-04
 *
 * @file: _admin-stub.js
 */
$(document).ready(function () {
  var $body = $('body'),
      isAdminMode = $('.admin-top-menu').length,
      $adminIframe = $('#admin-iframe'),
      $adminPopup = $('.admin-popup'),
      $adminLoader = $adminPopup.find(' .ph-loader');

  if (isAdminMode) {
    // ADMIN LINKS / ACTIONS HANDLER
    $('.admin-action').on('click', function (e) {
      var $this = $(e.target);

      switch ($this.tagNameLC()) {
        case 'admin-a':
        case 'a':
          __adminOpenPopup({
            url: $this.attr('href')
          });

          e.stopPropagation();
          e.preventDefault();
          break;
      }

      return false;
    }); // OPEN PANEL WINDOW

    var __adminOpenPopup = document.__adminOpenPopup = function ($popupData) {
      $body.addClass('is-admin-popup-active');
      $adminIframe.attr('src', $popupData.url);
      $adminLoader.addClass('is-visible');
    }; // CLOSE ADMIN WINDOW


    var __adminClosePopup = document.__adminClosePopup = function () {
      $body.removeClass('is-admin-popup-active');
      setTimeout(function () {
        $adminIframe.attr('src', '');
        $adminLoader.removeClass('is-visible');
        if (!$body.hasClass('layout-bookviewer')) window.location.reload();
      }, 500);
    }; // HIDE LOADER ANIMATION ON IFRAME LOAD


    $adminIframe.on('load', function (e) {
      //console.log($adminIframe.attr( 'src' ));
      //$adminLoader[ $adminIframe.attr( 'src' ) !== '' ? 'removeClass' : 'addClass' ]( 'is-visible' );
      $adminLoader.removeClass('is-visible');
    }); // IFRAME MESSAGES HANDLER

    window.addEventListener('message', function (event) {
      var data = event[event.message ? 'message' : 'data'];

      if (data.action === 'close-popup') {
        __adminClosePopup();
      }
    }, false); // KEYBOARD LISTENERS

    $body.on('keydown', function (e) {
      if (e.key === 'Escape' && $body.hasClass('is-admin-popup-active')) {
        __adminClosePopup();
      }
    });
  }
});
/*const */
var jMathEduVersion = 'Kentavr.Ru / Core / 201908.2';
var jMathEduBookVersion = 'Kentavr.Ru / BookViewer / 201908.2';
var lsSettingsKey = 'Kentavr-Settings-1.2'; // change version to clean users' settings

var lsBookMarksKey = 'Kentavr-Bookmarks-1.2';
jQuery.fn.cssInt = function (prop) {
  return parseInt(this.css(prop), 10) || 0;
};

jQuery.fn.cssFloat = function (prop) {
  return parseFloat(this.css(prop)) || 0;
};

jQuery.fn.getWidthInPercent = function () {
  var width = parseFloat($(this).css('width')) / parseFloat($(this).parent().css('width'));
  return Math.ceil(100 * width);
};

jQuery.fn.tagNameLC = function () {
  return $(this).prop('tagName').toLowerCase();
};

String.prototype.trimChars = function (chars) {
  var l = 0;
  var r = this.length - 1;

  while (chars.indexOf(this[l]) >= 0 && l < r) {
    l++;
  }

  while (chars.indexOf(this[r]) >= 0 && r >= l) {
    r--;
  }

  return this.substring(l, r + 1);
};

String.prototype.cyr2lat = function (options) {
  var str = this,
      i,
      ch,
      newStr = new String();
  var c = {
    'а': 'a',
    'б': 'b',
    'в': 'v',
    'г': 'g',
    'д': 'd',
    'е': 'e',
    'ё': 'jo',
    'ж': 'zh',
    'з': 'z',
    'и': 'i',
    'й': 'j',
    'к': 'k',
    'л': 'l',
    'м': 'm',
    'н': 'n',
    'о': 'o',
    'п': 'p',
    'р': 'r',
    'с': 's',
    'т': 't',
    'у': 'u',
    'ф': 'f',
    'х': 'h',
    'ц': 'c',
    'ч': 'ch',
    'ш': 'sh',
    'щ': 'shch',
    'ъ': '',
    'ы': 'y',
    'ь': '',
    'э': 'e',
    'ю': 'ju',
    'я': 'ja'
  };
  var opts = options ? options : {};
  str = str.toLowerCase().replace(/<.+>/g, ' ').replace(/\s+/g, ' ');

  for (i = 0; i < str.length; i++) {
    ch = str.charAt(i);
    newStr += ch in c ? c[ch] : ch;
  }

  if (opts.replaceSpace) newStr = newStr.replace(/\s/g, '_');
  if (opts.alphanumOnly) newStr = newStr.replace(/[^a-z0-9_\s]/gi, '');
  newStr = newStr.replace(/_+/g, '_').trimChars('_');
  return newStr;
};

function jisNumber(val) {
  var str = ('' + val).trim();
  if (str.length === 0) return false;
  return !isNaN(+str);
}

function jBool(val) {
  var num = +val;
  return !isNaN(num) ? !!num : !!String(val).toLowerCase().replace(!!0, '');
}

function formatBytes(bytes) {
  var decimals = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
  if (bytes === 0) return '0 Bytes';
  var k = 1024;
  var dm = decimals < 0 ? 0 : decimals;
  var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
  var i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
}

String.prototype.getKwdStrength = function () {
  var valParams = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var kwd = this;
  if (!valParams.minLength) valParams = {
    minLength: 8,
    minCap: 2,
    minLow: 2,
    minDigit: 1,
    minSpecial: 1
  };
  var level = 0;
  level += kwd.length >= valParams.minLength ? 10 : 0; // 10?

  level += kwd.length >= 2 ? 1 : 0; // ?

  level += RegExp('[!@#$%^&*?_~<>~"\\\\`\'\\-+.,;:№()=/]{' + valParams.minSpecial + ',}', 'gu').test(kwd) ? 1 : 0;
  level += RegExp('[a-zа-я]{' + valParams.minLow + ',}', 'gu').test(kwd) ? 1 : 0;
  level += RegExp('[A-ZА-Я]{' + valParams.minCap + ',}', 'gu').test(kwd) ? 1 : 0;
  level += RegExp('[0-9]{' + valParams.minDigit + ',}', 'gu').test(kwd) ? 1 : 0;
  return level;
};

String.prototype.checkEmailAddress = function () {
  var email = this;
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
};

String.prototype.checkLogin = function () {
  var login = this;
  return !/[^a-z0-9_]/.test(login);
}; // Get width of text with font.  usage: $("div").textWidth();


jQuery.fn.textWidth = function (_text, _font, _class) {
  var fakeEl = $('<span data-autoresize="">').hide().addClass(this.attr('class')).addClass(_class).appendTo(document.body).text(_text || this.val() || this.text()).css({
    font: _font || this.css('font'),
    whiteSpace: "pre"
  }),
      width = fakeEl.width();
  fakeEl.remove();
  return width;
}; // Resizes elements based on content size.  usage: $('input').autoresize({padding:10,minWidth:0,maxWidth:100});


jQuery.fn.autoresize = function (options) {
  //if(window.isMobile) return;
  options = jQuery.extend({
    padding: 10,
    minWidth: 40,
    maxWidth: 10000
  }, options || {});
  $(this).on('input', function () {
    $(this).css('width', Math.min(options.maxWidth, Math.max(options.minWidth, $(this).textWidth(null, null, options["class"] || '') + options.padding)));
  }).trigger('input');
  return this;
};

jQuery.fn.getBox = function () {
  return {
    left: $(this).offset().left,
    top: $(this).offset().top,
    width: $(this).outerWidth(),
    height: $(this).outerHeight()
  };
};

jQuery.fn.position = function (target, options) {
  var anchorOffsets = {
    t: 0,
    l: 0,
    c: 0.5,
    b: 1,
    r: 1
  };
  var defaults = {
    anchor: ['tl', 'tl'],
    animate: false,
    offset: [0, 0]
  };
  options = jQuery.extend(defaults, options);
  var targetBox = $(target).getBox(),
      sourceBox = $(this).getBox(); //origin is at the top-left of the target element

  var left = targetBox.left,
      top = targetBox.top; //alignment with respect to source

  top -= anchorOffsets[options.anchor[0].charAt(0)] * sourceBox.height;
  left -= anchorOffsets[options.anchor[0].charAt(1)] * sourceBox.width; //alignment with respect to target

  top += anchorOffsets[options.anchor[1].charAt(0)] * targetBox.height;
  left += anchorOffsets[options.anchor[1].charAt(1)] * targetBox.width; // get scroll

  top += $('.ph-app').scrollTop(); //add offset to final coordinates

  left += options.offset[0];
  top += options.offset[1];
  $(this).css({
    left: left + 'px',
    top: top + 'px'
  });
};

jQuery.fn.offsetviewport = function () {
  var el = this[0];
  return {
    top: Number(el.getBoundingClientRect().top),
    left: Number(el.getBoundingClientRect().left),
    width: Number(el.getBoundingClientRect().width),
    height: Number(el.getBoundingClientRect().height),
    vpwidth: Number(document.body.clientWidth),
    vpheight: Number(document.body.clientHeight)
  };
};

jQuery.fn.fadeOutAndRemove = function (speed) {
  $(this).fadeOut(speed, function () {
    $(this).remove();
  });
};

jQuery.fn.getScrollParent = function (includeHidden, objDoc) {
  if (this.css('position') === 'fixed') return objDoc.body;
  var excludeStaticParent = this.css('position') === 'absolute',
      overflowRegex = includeHidden ? /(auto|scroll|hidden)/ : /(auto|scroll)/,
      $parent = $(this.parent());

  while ($parent.length) {
    if (excludeStaticParent && $parent.css('position') === 'static') {
      continue;
    }

    if (overflowRegex.test($parent.css('overflow') + $parent.css('overflow-y') + $parent.css('overflow-x'))) {
      return $parent;
    }

    $parent = $($parent.parent());
  }

  return $(objDoc.body);
};

jQuery.fn.onEnter = function (func) {
  this.bind('keypress', function (e) {
    if (e.keyCode == 13) func.apply(this, [e]);
  });
  return this;
};

jQuery.fn.removeOptions = function (mode) {
  var $this = this;
  mode = mode ? mode : 'nonblanks';
  $this.find('option').filter(function () {
    if (mode === 'blanks') return $(this).val().trim() === '';
    if (mode === 'nonblanks') return $(this).val().trim() !== '';
  }).remove();
};

jQuery.fn.extend({
  qcss: function qcss(css) {
    return $(this).queue(function (next) {
      $(this).css(css);
      next();
    });
  }
});